{
  "brand": {
    "entity": "Heraion",
    "product": "Metria"
  },
  "createHub": {
    "title": "Создать",
    "open": "Создать",
    "close": "Закрыть",
    "actionsHeader": "Начать",
    "todayHeader": "Сегодня",
    "newWorkout": {
      "title": "Новая тренировка",
      "sub": "Начать пустую тренировку сейчас"
    },
    "repeatWorkout": {
      "title": "Повторить тренировку",
      "sub": "Записать новую тренировку на основе прошлой"
    },
    "buildToday": {
      "title": "Собрать тренировку на сегодня",
      "sub": "Упражнения для мышц ниже минимального объёма",
      "subInstead": "Вместо сегодняшнего плана: мышцы ниже минимального объёма"
    },
    "planProgram": {
      "title": "Запланировать программу",
      "sub": "Создайте свою программу"
    },
    "planWorkout": {
      "title": "Запланировать тренировку",
      "sub": "Подготовить одну сессию на потом"
    }
  },
  "library": {
    "header": "Обзор",
    "tabPrograms": "Программы",
    "tabWorkouts": "Тренировки",
    "tabPersonal": "Мои",
    "tabCoach": "Тренер",
    "tabFavorites": "Избранное",
    "favoriteA11y": "В избранное",
    "errFavorite": "Не удалось обновить избранное.",
    "emptyFavoritesTitle": "Пока нет избранного",
    "emptyFavoritesSub": "Отметьте программу или тренировку звездой, чтобы она была здесь.",
    "sectionOfficial": "От $t(brand.product)",
    "sectionPersonal": "Мои",
    "sectionYourPrograms": "Ваши программы",
    "clone": "Клонировать",
    "copySuffix": "(копия)",
    "following": "Подключение…",
    "alreadyYours": "Уже у вас",
    "copyQueued": "В очереди, появится после отправки",
    "goToCopy": "К вашей копии",
    "goToCopies": "К вашим копиям",
    "goToCopyHint": "Открывает раздел «$t(library.tabPersonal)», где ваша копия.",
    "cloneFollowed": "Сделать своим",
    "followed": "Теперь вы следуете «{{name}}».",
    "addedToPrograms": "«{{name}}» добавлен в ваши программы.",
    "searchPlaceholder": "Поиск по названию…",
    "filters": "Фильтры",
    "clearFilters": "Сбросить",
    "axisLevel": "Уровень",
    "axisPerWeek": "Тренировки / неделя",
    "noResultsTitle": "Ничего не найдено",
    "noResultsSub": "Измените поиск или фильтры.",
    "loading": "Загрузка библиотеки…",
    "errLoad": "Не удалось загрузить библиотеку.",
    "errClone": "Не удалось клонировать. Попробуйте ещё раз.",
    "errDelete": "Не удалось удалить. Попробуйте ещё раз.",
    "leaveTitle": "Убрать из библиотеки?",
    "leaveBody_one": "Доступ к «{{name}}» есть ещё у {{count}} человека. Он не потеряет доступ: вы уберёте только свою копию из библиотеки.",
    "leaveBody_few": "Доступ к «{{name}}» есть ещё у {{count}} человек. Они не потеряют доступ: вы уберёте только свою копию из библиотеки.",
    "leaveBody_many": "Доступ к «{{name}}» есть ещё у {{count}} человек. Они не потеряют доступ: вы уберёте только свою копию из библиотеки.",
    "leaveBody_other": "Доступ к «{{name}}» есть ещё у {{count}} человек. Они не потеряют доступ: вы уберёте только свою копию из библиотеки.",
    "leaveConfirm": "Убрать",
    "errLeave": "Не удалось убрать из библиотеки. Попробуйте ещё раз.",
    "unfollow": "Не следовать",
    "unfollowHint": "Убрать из библиотеки. У автора она останется.",
    "unfollowTitle": "Перестать следовать?",
    "unfollowBody": "«{{name}}» останется у автора. Вы уберёте только свою копию из библиотеки.",
    "errUnfollow": "Не удалось перестать следовать. Попробуйте ещё раз.",
    "errFollow": "Не удалось начать следовать программе.",
    "errStatus": "Не удалось обновить программу.",
    "errAssign": "Не удалось обновить список назначенных.",
    "assignSent": "Отправлено. Все новые в списке получают запрос, который могут принять или отклонить.",
    "assignSentSelf": "Отправлено. Так как это создано тренером, проверьте также свои входящие как спортсмен, чтобы принять или отклонить.",
    "emptyTitle": "Пока здесь пусто",
    "emptySub": "Созданные или склонированные программы и тренировки появятся здесь.",
    "emptyCoachTitle": "Пока ничего не назначено",
    "emptyCoachSub": "Никто пока не назначил вам программу или тренировку.",
    "assignedBy": "Назначено: {{name}}",
    "followingVersion": "Вы следуете версии {{name}}",
    "followingVersionUnknown": "Вы следуете версии другого человека",
    "saveAsModel": "Сохранить как модель",
    "modelName": "Название модели",
    "modelHint": "Веса станут % от вашего MAX.",
    "modelSaveError": "Не удалось сохранить модель. Попробуйте ещё раз.",
    "modelSavedTitle": "Модель сохранена",
    "modelSavedBody": "«{{name}}» теперь в разделе «Новая программа», в «Мои модели».",
    "modelQueued": "Она сохранится, когда вы снова будете в сети.",
    "modelAllKept": "Каждая строка сохранила свою прогрессию.",
    "modelWarmUps_one": "{{count}} разминочный подход не учтён.",
    "modelWarmUps_few": "{{count}} разминочных подхода не учтены.",
    "modelWarmUps_many": "{{count}} разминочных подходов не учтено.",
    "modelWarmUps_other": "{{count}} разминочного подхода не учтено.",
    "modelToHistory": "Вес из истории",
    "modelNoLoad": "Без веса",
    "modelDone": "Готово",
    "modelPlan": "Запланировать программу",
    "modelRow": "{{exercise}}, {{day}}",
    "modelDescFallback": "{{days}}, {{rounds}}.",
    "modelChanged": "Изменено в модели",
    "modelChangedByHand": "ячейки вручную отброшены",
    "modelChangedEveryRound": "в каждом круге",
    "modelToHistoryWhy": "Нет MAX или это доп. вес к собственному. Он не будет расти.",
    "modelNoLoadWhy": "Вес выбирается в новой программе.",
    "saveAsModelHint": "Используйте её дни в новой программе. Веса станут % от вашего MAX.",
    "modelShapeDays_one": "{{count}} день",
    "modelShapeDays_few": "{{count}} дня",
    "modelShapeDays_many": "{{count}} дней",
    "modelShapeDays_other": "{{count}} дня",
    "modelNameEmpty": "Дайте ей название, чтобы сохранить.",
    "modelWaitCatalog": "Загрузка упражнений…",
    "customise": "Настроить",
    "customiseHint": "Выберите параметры и посмотрите программу, прежде чем следовать ей.",
    "modelEditHint": "Кнопка «Редактировать» открывает редактор. Программа станет вашей после сохранения.",
    "customiseEdit": "Изменить",
    "customiseEditHint": "Посмотрите программу, затем следуйте ей или измените её в редакторе.",
    "anotherCopy": "Ещё одна копия",
    "anotherCopyHint": "Сделайте ещё одну копию, чтобы изменить или назначить её.",
    "modelMaxesError": "Чтобы прочитать ваши MAX, нужно подключение. Попробуйте снова в сети.",
    "modelCapError": "У вас 100 моделей, это максимум. Удалите одну в «Новая программа», «Мои модели».",
    "catalog": {
      "title": "Программы $t(brand.product)",
      "levelRange": "{{from}} – {{to}}",
      "perWeek_one": "{{count}} день в неделю",
      "perWeek_few": "{{count}} дня в неделю",
      "perWeek_many": "{{count}} дней в неделю",
      "perWeek_other": "{{count}} дня в неделю",
      "perWeekRange": "Дней в неделю: {{from}}-{{to}}",
      "minutesRange": "{{from}}-{{to}} мин",
      "cloning": "Клонирование…",
      "cloned": "«{{name}}» склонирован.",
      "difficultyBeginner": "Новичок",
      "difficultyIntermediate": "Средний",
      "difficultyAdvanced": "Продвинутый",
      "planMeta": "{{n}} упражн.",
      "programMeta": "Цикл {{weeks}} нед. · {{sessions}}× / нед."
    }
  },
  "common": {
    "weightUnit_kg": "кг",
    "weightUnit_lb": "фунт",
    "lastDataAt": "Последние данные {{at}}",
    "noData": "Нет данных",
    "lastDataOn": "Последние данные: {{date}}",
    "languageA11y": "Язык",
    "infoA11y": "Информация",
    "unsavedChanges": {
      "title": "Отменить изменения?",
      "body": "Несохранённые изменения будут потеряны.",
      "keepEditing": "Продолжить редактирование",
      "discard": "Отбросить",
      "exitTitle": "Несохранённые изменения",
      "exitBody": "Эти изменения не сохранены. Сохраните их, оставьте как черновик на этом устройстве или отмените.",
      "exitBodyNoDraft": "Эти изменения не сохранены. Сохраните их или отмените.",
      "save": "Сохранить",
      "keepDraft": "Оставить черновик"
    },
    "relativeAge": {
      "today": "сегодня",
      "days": "{{count}} дн. назад",
      "weeks": "{{count}} нед. назад",
      "months": "{{count}} мес. назад"
    },
    "loadMore": "Загрузить ещё",
    "loadingMore": "Загрузка…",
    "pageOf": "{{current}} из {{total}}",
    "noFullWeekYet": "Пока нет полной недели"
  },
  "bodymap": {
    "viewBack": "Сзади",
    "viewFront": "Спереди",
    "workedTitle": "Задействованные мышцы",
    "workedPrimary": "основные",
    "workedSecondary": "вспомогательные",
    "heatmapTitle": "Самые нагруженные мышцы",
    "heatmapLow": "мало",
    "heatmapHigh": "много",
    "window7d": "7 дней",
    "window30d": "30 дней",
    "painTitle": "Карта боли",
    "painHelp": "Нажмите на мышцу, чтобы отметить её, каждая сторона отдельно: красный (избегать больших весов), жёлтый (осторожно). Сохраняется автоматически.",
    "painRed": "избегать",
    "painYellow": "осторожно",
    "painClearAll": "Очистить всё",
    "painSaving": "Сохранение…",
    "painSaveError": "Не удалось сохранить. Проверьте подключение.",
    "painRiskA11y": "Риск боли: {{severity}}",
    "painRiskSideA11y": "Риск боли: {{severity}}, {{side}}",
    "painBannerMuscleSide": "{{muscle}} (<side>{{side}}</side>)",
    "painSideOnly": {
      "left": "только левая сторона",
      "right": "только правая сторона"
    },
    "painSeverity": {
      "red": "высокий",
      "yellow": "средний",
      "green": "низкий"
    },
    "painPart": {
      "chest": "грудь",
      "chest_left": "левую сторону груди",
      "chest_right": "правую сторону груди",
      "biceps": "бицепсы",
      "biceps_left": "левый бицепс",
      "biceps_right": "правый бицепс",
      "triceps": "трицепсы",
      "triceps_left": "левый трицепс",
      "triceps_right": "правый трицепс",
      "forearm": "предплечья",
      "forearm_left": "левое предплечье",
      "forearm_right": "правое предплечье",
      "front-deltoids": "плечи",
      "front-deltoids_left": "левое плечо",
      "front-deltoids_right": "правое плечо",
      "back-deltoids": "плечи",
      "back-deltoids_left": "левое плечо",
      "back-deltoids_right": "правое плечо",
      "trapezius": "трапеции",
      "trapezius_left": "левую трапецию",
      "trapezius_right": "правую трапецию",
      "upper-back": "верх спины",
      "upper-back_left": "левую сторону верха спины",
      "upper-back_right": "правую сторону верха спины",
      "lower-back": "поясницу",
      "lower-back_left": "левую сторону поясницы",
      "lower-back_right": "правую сторону поясницы",
      "abs": "пресс",
      "abs_left": "левую сторону пресса",
      "abs_right": "правую сторону пресса",
      "obliques": "косые мышцы",
      "obliques_left": "левую косую мышцу",
      "obliques_right": "правую косую мышцу",
      "quadriceps": "квадрицепсы",
      "quadriceps_left": "левый квадрицепс",
      "quadriceps_right": "правый квадрицепс",
      "hamstring": "бицепсы бедра",
      "hamstring_left": "левый бицепс бедра",
      "hamstring_right": "правый бицепс бедра",
      "gluteal": "ягодицы",
      "gluteal_left": "левую ягодицу",
      "gluteal_right": "правую ягодицу",
      "adductors": "приводящие мышцы",
      "adductors_left": "левые приводящие мышцы",
      "adductors_right": "правые приводящие мышцы",
      "abductors": "отводящие мышцы",
      "abductors_left": "левые отводящие мышцы",
      "abductors_right": "правые отводящие мышцы",
      "calves": "икры",
      "calves_left": "левую икру",
      "calves_right": "правую икру",
      "tibialis": "голени",
      "tibialis_left": "левую голень",
      "tibialis_right": "правую голень",
      "neck": "шею",
      "neck_left": "левую сторону шеи",
      "neck_right": "правую сторону шеи",
      "head": "голову",
      "head_left": "левую сторону головы",
      "head_right": "правую сторону головы"
    },
    "painSummaryAvoid": "Не нагружать: {{parts}}",
    "painSummaryCaution": "Осторожно с нагрузкой на {{parts}}",
    "zoomIn": "Увеличить",
    "zoomOut": "Уменьшить",
    "zoomReset": "Сбросить масштаб",
    "zoomPinchHint": "Сведите пальцы или нажмите кнопки.",
    "painListToggle": "Мышцы списком",
    "painListLeft": "{{muscle}} (слева)",
    "painListRight": "{{muscle}} (справа)",
    "painStateRed": "Избегать больших весов",
    "painStateYellow": "Осторожно",
    "painStateNone": "Не отмечено",
    "painListRowA11y": "{{muscle}}, {{state}}"
  },
  "plates": {
    "title": "Раскладка блинов",
    "openHint": "Показать раскладку",
    "close": "Закрыть",
    "targetLabel": "Цель",
    "barLabel": "Гриф",
    "barAria": "Вес грифа",
    "barNone": "Без грифа",
    "perSide": "На сторону",
    "perSidePair": "{{count}} × {{plate}}",
    "barOnly": "Только гриф, блины не нужны.",
    "belowBar": "Цель легче грифа.",
    "invalidInput": "Сначала введите корректный вес.",
    "remainder": "+{{weight}} не хватает до цели с текущим инвентарём.",
    "fallbackPill": "ближайший возможный",
    "inventoryLegend": "Доступные пары",
    "inventoryHint": "Пары каждого блина, доступные сейчас. Укажите 0, если в зале его нет или все заняты. Сохраняется между сессиями.",
    "pairsAria": "Доступно пар {{plate}}",
    "loadedSide": "Нагруженная сторона",
    "singleSideHint": "Блины вешаются только на одну сторону. Лендмайн, T-гриф, сани и рычаги на одну руку загружаются так."
  },
  "app": {
    "title": "$t(brand.product)",
    "tagline": "Силовые тренировки, без лишнего.",
    "signedInAs": "Вы вошли как <bold>{{email}}</bold>.",
    "signOut": "Выйти",
    "loading": "Загрузка…",
    "checking": "проверка…"
  },
  "auth": {
    "signIn": "Войти",
    "signInFailed": "Не удалось войти. Проверьте электронную почту и пароль.",
    "email": "Электронная почта",
    "emailPlaceholder": "email@example.com",
    "password": "Пароль",
    "passwordRules": {
      "length": "Не менее 10 символов",
      "uppercase": "Заглавная буква",
      "lowercase": "Строчная буква",
      "number": "Цифра",
      "met": "готово",
      "unmet": "ещё нет"
    },
    "revealPassword_one": "Показать пароль",
    "revealPassword_few": "Показать пароли",
    "revealPassword_many": "Показать пароли",
    "revealPassword_other": "Показать пароли",
    "hidePassword_one": "Скрыть пароль",
    "hidePassword_few": "Скрыть пароли",
    "hidePassword_many": "Скрыть пароли",
    "hidePassword_other": "Скрыть пароли",
    "passwordHint": "Не менее 10 символов: заглавная и строчная буквы и цифра.",
    "invitedOnly": "Аккаунты создаются по приглашению. Если вас пригласили, войдите с адресом и временным паролем, которые пришли на почту.",
    "submitting": "Подождите…",
    "confirmTitle": "Подтвердите электронную почту",
    "confirmCode": "Код подтверждения",
    "confirmHelp": "Мы отправили код на <bold>{{email}}</bold>. Вставьте его ниже, чтобы завершить регистрацию.",
    "confirmSubmit": "Подтвердить",
    "confirming": "Подтверждение…",
    "resendCode": "Отправить код снова",
    "resentInfo": "Код отправлен снова. Проверьте почту.",
    "confirmedNowSignIn": "Аккаунт подтверждён. Войдите, чтобы продолжить.",
    "forgotEmailRequired": "Введите email, с которым вы входите.",
    "forgotCodeRequired": "Введите код, который мы вам отправили.",
    "forgotLink": "Забыли пароль?",
    "forgotTitle": "Сброс пароля",
    "forgotIntro": "Укажите email - мы вышлем код для сброса пароля.",
    "forgotSendCode": "Отправить код",
    "forgotCodeSent": "Код отправлен. Проверьте почту.",
    "forgotConfirmHelp": "Код отправлен на <bold>{{email}}</bold>. Введите его ниже.",
    "forgotResetSubmit": "Сбросить пароль",
    "forgotResetDone": "Пароль обновлён. Войдите с новым паролем.",
    "newPassword": "Новый пароль",
    "backToSignIn": "Вернуться ко входу",
    "welcome": {
      "title": "Добро пожаловать в $t(brand.product)",
      "help": "Вас пригласили. Выберите пароль, которым будете пользоваться дальше, и скажите, как к вам обращаться.",
      "name": "Как к вам обращаться?",
      "namePlaceholder": "Ваше имя",
      "nameRequired": "Укажите имя. Так приложение будет к вам обращаться.",
      "submit": "Войти",
      "ageRequired": "Поставьте галочку, чтобы продолжить."
    },
    "confirmPassword": "Подтвердите пароль",
    "passwordsMatch": "Пароли совпадают.",
    "passwordMismatch": "Пароли не совпадают.",
    "forgotCodeSubmit": "Далее",
    "forgotCodeIncomplete": "Введите все шесть цифр кода.",
    "forgotPasswordHelp": "Выберите пароль, которым будете пользоваться дальше.",
    "backStep": "Назад",
    "forgotStep": "Шаг {{n}} из 3",
    "forgotCodeWrong": "Код неверный. Проверьте его и попробуйте снова.",
    "forgotCodeExpired": "Срок действия кода истёк. Запросите новый.",
    "forgotTooManyAttempts": "Слишком много попыток. Подождите несколько минут и попробуйте снова.",
    "forgotTooManyRequests": "Запрошено слишком много кодов. Подождите несколько минут.",
    "accountUnconfirmed": "Этот аккаунт ещё не подтверждён. Проверьте почту: там письмо с подтверждением.",
    "passwordResetRequired": "Перед входом нужно сбросить пароль. Нажмите «Забыли пароль?».",
    "passwordRejected": "Этот пароль не соответствует правилам. Проверьте список и попробуйте снова.",
    "resendCodeIn": "Отправить код снова ({{seconds}} с)",
    "ageDeclaration": "Мне не меньше {{age}} лет, или родитель или опекун знает, что я пользуюсь $t(brand.product), и разрешает это.",
    "ageGate": {
      "title": "Прежде чем продолжить",
      "body": "$t(brand.product) спрашивает об этом один раз. Ответ сохраняется с сегодняшней датой.",
      "submit": "Продолжить",
      "saveFailed": "Не удалось сохранить ответ. Проверьте соединение и повторите попытку.",
      "deleting": "Удаляем аккаунт…"
    }
  },
  "dashboard": {
    "meTitle": "Запрос с аутентификацией: /api/me",
    "healthTitle": "Состояние API",
    "exportData": "Экспортировать мои данные",
    "deleteAccount": "Удалить мой аккаунт",
    "exporting": "Подготовка экспорта…",
    "deleting": "Удаление…",
    "deleteConfirm": "Ваш аккаунт и все ваши данные будут окончательно удалены. Введите УДАЛИТЬ для подтверждения.",
    "deleteCancel": "Отмена",
    "deletePlaceholder": "УДАЛИТЬ",
    "deleteSuccess": "Аккаунт удалён.",
    "exportFilename": "metria-export-{{date}}.json",
    "privacyTitle": "Конфиденциальность",
    "privacyHelp": "Экспорт всех данных в JSON или полное удаление аккаунта. Удаление необратимо."
  },
  "privacy": {
    "linkLabel": "Конфиденциальность",
    "title": "Политика конфиденциальности",
    "lastUpdated": "Последнее обновление: 24 октября 2026 г. (Health Connect)",
    "intro": "Metria является приложением для тренировок, публикуемым под именем Heraion Антеноре Гаттой (Antenore Gatta) в Швейцарии. Heraion не является зарегистрированной компанией: ответственность за обработку ваших данных несёт физическое лицо, и именно с ним вы имеете дело. Эта политика объясняет, какие данные мы собираем и зачем, где они хранятся, сколько остаются и что вы можете у нас потребовать.",
    "section1Title": "Какие данные мы собираем",
    "section1Body": "Только то, что нужно приложению для работы, и то, что вы сами в него вносите. Для аккаунта: ваш адрес электронной почты, который одновременно служит идентификатором аккаунта, и пароль, который Amazon Cognito хранит только в виде криптографического хеша. Открытый текст до нас не доходит. В профиле: отображаемое имя, оно обязательно и вполне может быть псевдонимом, а не именем из документов, а также, если вы их заполните, возрастной диапазон и биологический пол, которые приложение использует для формул процента жира и для рисунка фигуры. Дальше всё, что вы вводите, тренируясь: тренировки, подходы, веса, программы, заметки, личные рекорды и, если вы пользуетесь этими разделами, измерения тела, вес, отметки боли и показатели здоровья. Мы не спрашиваем почтовый адрес, номер телефона, дату рождения и платёжные данные и не используем аналитику, рекламу и отслеживание: поведенческого профиля на вас нигде не существует. Вес, измерения тела, отметки боли и всё, что читается из Health Connect, являются данными о здоровье: специальная категория по ст. 9 GDPR и данные, требующие особой защиты, по ст. 5 пп. c швейцарского nLPD. Поэтому они никогда не агрегируются, не попадают в наши логи и удаляются вместе с вашим аккаунтом.",
    "section2Title": "Где хранятся данные и кто ещё к ним прикасается",
    "section2Body": "Все данные хранятся в регионе AWS eu-central-2 (Цюрих, Швейцария). Amazon Web Services является единственным обработчиком, к услугам которого мы прибегаем: аутентификация работает на Amazon Cognito, структурированные данные хранятся в Amazon DynamoDB, серверный код работает на AWS Lambda, статические файлы приложения раздаются через Amazon CloudFront. Мы не используем никаких сервисов аналитики, рекламы или отслеживания, не продаём и не сдаём ваши данные в аренду и не передаём их никому другому. Единственные два пути, по которым ваши данные идут дальше, вы включаете сами: Health Connect на телефоне и тренер, которого вы приглашаете. Каждому из них посвящён отдельный раздел ниже.",
    "section3Title": "Ваши права",
    "section3Body": "В приложении вы можете выгрузить весь свой набор данных в формате JSON и окончательно удалить аккаунт; удаление стирает запись аутентификации и всё, что хранится под вашим аккаунтом, без скрытого «мягкого удаления». Помимо этих двух кнопок у вас есть права, которые даёт закон: узнать, что мы о вас храним, потребовать исправления, потребовать удаления, получить копию в переносимом формате, возразить против обработки или потребовать её ограничения, а также отозвать данное согласие. Отзыв останавливает нас на будущее и не делает незаконным то, что было сделано, пока согласие действовало. Напишите на {{email}}, и вам ответит человек. Если вы считаете, что мы обошлись с вашими данными неправильно, вы можете обратиться в надзорный орган: в Швейцарии это Федеральный уполномоченный по защите данных и гласности, в Европейском союзе это орган страны, где вы живёте.",
    "section4Title": "Кто отвечает за данные и как с нами связаться",
    "section4Body": "Ответственным за обработку ваших данных является Антеноре Гатта (Antenore Gatta), который публикует Metria под именем Heraion из Швейцарии. Heraion является названием проекта, а не зарегистрированной компанией, поэтому ответственность здесь личная, а не корпоративная. Вопросы, запросы и жалобы: {{email}}.",
    "section5Title": "Правовая основа",
    "section5Body": "Аккаунт и ваши тренировочные данные обрабатываются, чтобы предоставить вам запрошенный сервис: это исполнение соглашения между нами, ст. 6 п. 1 пп. b GDPR, и та же цель по швейцарскому закону о защите данных. Данные о здоровье (вес, измерения тела, отметки боли и всё, что читается из Health Connect) обрабатываются только на основании вашего явного согласия, ст. 9 п. 2 пп. a GDPR: вы даёте его, включая эту часть приложения, и отзываете, выключая её или удаляя данные. Мы не растягиваем законный интерес на то, чего вы бы не ожидали, и обновим эту политику прежде, чем добавится любая новая цель.",
    "section6Title": "Кто может пользоваться Metria",
    "section6Body": "Metria не предназначена для детей. Для регистрации вам должно быть не менее 16 лет, или больше, если законодательство вашей страны устанавливает более высокий возраст. Если вы младше, родитель или опекун должен знать, что вы пользуетесь Metria, разрешать это и контролировать использование. Аккаунты не открываются публичной регистрацией: вас приглашает тот, кто уже есть в Metria, и аккаунт создаётся для вас, поэтому приглашение, отправленное несовершеннолетнему, должен принять его родитель или законный представитель.",
    "section7Title": "Сколько мы храним и что убирает удаление",
    "section7Body": "Пока существует ваш аккаунт, введённое вами остаётся: мы не устанавливаем срок годности для вашей истории и не переносим её куда-то ещё, когда вы перестаёте тренироваться. Кое-что живёт меньше, и это сделано намеренно. Когда вы удаляете тренировку, на её месте на 30 дней остаётся метка, чтобы устройство, которое было офлайн, узнало об удалении; потом уходит и метка. Кеш, не позволяющий применить один и тот же запрос дважды, хранит запись 24 часа. Наша база данных резервируется непрерывно и может быть восстановлена на любой момент предыдущих 35 дней, поэтому удалённая вами запись ещё столько времени может существовать внутри резервной копии, прежде чем станет невосстановимой; резервную копию мы разворачиваем только чтобы устранить сбой, и никогда, чтобы вернуть удалённый кем-то аккаунт. Удаление аккаунта убирает запись аутентификации и каждую запись, хранящуюся под ним, включая импортированное из Health Connect и связь с тренером с обеих сторон; после истечения окна резервных копий от них не остаётся ничего. Одно исключение сохраняется, но обезличивается: отзыв, отправленный вами из приложения, остаётся, потому что он о приложении, а не о вас, но сведения о том, кто его написал, из него удаляются.",
    "section8Title": "Health Connect",
    "section8Body": "На Android Metria может подключаться к Health Connect. Пока вы не включите это в настройках, подключение выключено; Health Connect запрашивает разрешение на каждый тип данных отдельно, и приложение работает и без него. Когда подключение включено, Metria читает ваши тренировки, а для кардио их пульс и дистанцию, чтобы занятие, записанное часами, появилось в вашей ленте с его нагрузкой; ваш вес, чтобы раздел тела показывал одну историю вместо двух; ваши записи глюкозы крови и питания, чтобы метаболическая карточка могла поставить сегодняшние углеводы и ваши измерения глюкозы рядом с тренировкой. Обратно в Health Connect Metria записывает только две вещи, и только те, что вы ввели здесь сами: измерение веса и измерение глюкозы крови, чтобы введённое в Metria значение не оставалось запертым в Metria. Прочитанное покидает ваш телефон: оно хранится на наших серверах в Цюрихе вместе с остальными вашими данными и по тем же правилам, никогда не используется для рекламы, не продаётся, не передаётся третьим лицам и не используется для обучения каких-либо моделей. Оно остаётся, пока вы не удалите эти данные или аккаунт, как описано в предыдущем разделе. Вы можете в любой момент отключиться в настройках Metria или отозвать разрешения в самом Health Connect: и то и другое прекращает дальнейшее чтение, а уже импортированные значения остаются вашими, и их можно удалить в Metria.",
    "section9Title": "Если у вас есть тренер",
    "section9Body": "Metria может связать спортсмена и тренера. Связь начинается с приглашения на адрес электронной почты, который мы храним в приглашении, чтобы принять его мог только владелец этого адреса, и который стирается, как только связь становится активной. Пока связь активна, тренер может читать тренировочную сторону спортсмена: занятия и их результаты, программы и цели, максимумы и рекорды, а также профиль, и не может ничего изменить, если спортсмен не предоставил ему право задавать цели; сам себе тренер это право дать не может. Любая из сторон может в любой момент прекратить связь в приложении, и это останавливает доступ. Приглашение спортсмена младше возраста, указанного в разделе выше, требует согласия родителя или опекуна. Приглашённый заявляет об этом при первом входе, с датой: Metria записывает заявление, но не проверяет его.",
    "back": "Назад"
  },
  "terms": {
    "linkLabel": "Условия",
    "title": "Условия использования",
    "lastUpdated": "Последнее обновление: 24 октября 2026 г. (минимальный возраст)",
    "intro": "Эти условия являются соглашением между вами и нами об использовании Metria. Пользуясь приложением, вы их принимаете. Если вы с ними не согласны, не пользуйтесь Metria.",
    "section1Title": "Кто мы",
    "section1Body": "Metria публикуется под именем Heraion Антеноре Гаттой (Antenore Gatta) в Швейцарии. Heraion является названием проекта, а не зарегистрированной компанией: вашим контрагентом является физическое лицо. Написать нам можно на {{email}}.",
    "section2Title": "Эти условия",
    "section2Body": "Аккаунты не открываются публичной регистрацией: вас приглашает тот, кто уже есть в Metria, и аккаунт создаётся для вас. Пользуясь Metria после того, как аккаунт создан (входя в него, записывая тренировку), вы принимаете эти условия, и они становятся соглашением между вами и нами. Если вы их не принимаете, не пользуйтесь Metria и попросите нас удалить аккаунт. Если вы потребитель, ничто написанное здесь не лишает вас права, которое законодательство вашей страны предоставляет вам и от которого нельзя отказаться.",
    "section3Title": "Кто может пользоваться Metria",
    "section3Body": "Для регистрации вам должно быть не менее 16 лет, или больше, если законодательство вашей страны устанавливает более высокий возраст. Если вы младше, родитель или опекун должен знать, что вы пользуетесь Metria, разрешать это и контролировать использование. Аккаунт персональный: держите пароль при себе и сообщите нам, если считаете, что его узнал кто-то ещё.",
    "section4Title": "Metria не даёт медицинских советов",
    "section4Body": "Metria является инструментом для тренировок. Это не медицинское изделие, и она не даёт медицинских советов. Показанные веса, повторения и время отдыха являются предложениями, рассчитанными из введённых вами чисел, а не назначением: вы сами решаете, что поднимать, и тренируетесь на свой риск. Силовые тренировки могут привести к травме. Если у вас есть заболевание или травма, если вы беременны или возвращаетесь после долгого перерыва, поговорите с врачом до начала, и остановитесь, когда что-то болит. Любая отметка боли, измерение тела или показатель здоровья в приложении, включая импортированное из Health Connect, является записью того, что ввели вы или ваше устройство, и никогда не диагнозом: Metria не выявляет и не отслеживает никаких заболеваний.",
    "section5Title": "То, что вы вводите, остаётся вашим",
    "section5Body": "Тренировки, программы, измерения и заметки, которые вы вводите, принадлежат вам. Чтобы сервис работал, нам нужна ограниченная лицензия хранить, резервировать, обрабатывать и показывать их, вам и тем, с кем вы решили ими поделиться. Не более того, и она заканчивается, когда вы удаляете данные или аккаунт. Что мы собираем и зачем, написано в политике конфиденциальности.",
    "section6Title": "Тренеры и спортсмены",
    "section6Body": "Если вы приглашаете кого-то как его тренер, вам нужно его предварительное согласие, и согласие на то, что именно вы сможете видеть. Его данные остаются его: ваш доступ зависит от роли, которая у него есть в приложении, и он может его отозвать. Если спортсмен младше возраста, указанного в предыдущем разделе, до приглашения вам нужно согласие родителя или законного представителя.",
    "section7Title": "Добросовестное использование",
    "section7Body": "Пользуйтесь Metria в рамках закона. Не пытайтесь получить доступ к аккаунтам, данным или частям сервиса, которые вам не принадлежат, не извлекайте и не перепродавайте содержимое, не загружайте противоправные материалы и не вводите данные другого человека без его согласия.",
    "section8Title": "Цена",
    "section8Body": "Сегодня Metria бесплатна. Если мы введём платные функции, мы скажем об этом ясно и заранее, а оплата пойдёт через магазин Apple или Google, чьи правила определяют списание, продление и возвраты. Цифровой контент, который по вашей просьбе начинается сразу, может не давать права на отказ; там, где закон вам его даёт, оно за вами сохраняется.",
    "section9Title": "Доступность и изменения",
    "section9Body": "Мы предоставляем Metria как есть и по мере доступности: мы не обещаем работу без перерывов и без ошибок. Мы можем добавлять, изменять или убирать функции, и перед изменением, которое заметно урезает то, на что вы рассчитывали, мы скажем об этом в приложении.",
    "section10Title": "Как это заканчивается",
    "section10Body": "Вы можете прекратить в любой момент: удалите свои данные или аккаунт в приложении. Мы можем приостановить или закрыть аккаунт, который нарушает эти условия или который мы обязаны закрыть по закону, и, если это не противозаконно и не неразумно, сначала назовём вам причину. Удаление аккаунта убирает ваши данные так, как описано в политике конфиденциальности.",
    "section11Title": "Ответственность",
    "section11Body": "Мы отвечаем за вред, причинённый умышленно или по грубой неосторожности, за вред жизни, телу или здоровью и за всё, что закон не позволяет нам исключить, включая ваши императивные права потребителя. Сверх этого мы не отвечаем за косвенные или непредвидимые убытки, за травмы от тренировки, которую вы выбрали сами, и за данные, потерянные потому, что их не выгрузили.",
    "section12Title": "Приложения Apple и Google",
    "section12Body": "Если вы пользуетесь приложением для iOS, это соглашение заключено между вами и нами, а не с Apple. Apple не отвечает за приложение и за любые претензии к нему и не оказывает поддержку; Apple и её дочерние компании могут требовать исполнения этого соглашения как третьи лица-выгодоприобретатели. Если вы пользуетесь приложением для Android, наряду с этими условиями действуют правила магазина, из которого вы его установили.",
    "section13Title": "Изменения этих условий",
    "section13Body": "Мы можем изменять эти условия. Новая редакция публикуется здесь с датой, а об изменениях, которые вас действительно касаются, мы скажем в приложении до их вступления в силу. Если вы продолжите пользоваться Metria после этого, действует новая редакция.",
    "section14Title": "Право и споры",
    "section14Body": "Применяется швейцарское право. Если вы потребитель, за вами также сохраняется защита императивных норм страны, где вы живёте, и вы можете обратиться в суды этой страны. Потребители в Европейском союзе могут также воспользоваться европейской платформой онлайн-урегулирования споров на ec.europa.eu/consumers/odr.",
    "section15Title": "Языки",
    "section15Body": "Эти условия публикуются на английском, итальянском, французском, немецком и русском языках. Английский является языком, на котором они составлены, и именно эта версия имеет преимущество, если перевод говорит иное, кроме случаев, когда законодательство вашей страны отдаёт приоритет версии на вашем языке: тогда для вас действует она. Политика конфиденциальности публикуется на тех же пяти языках и на тех же основаниях.",
    "back": "Назад"
  },
  "errors": {
    "generic": "Что-то пошло не так."
  },
  "feedback": {
    "title": "Отправить отзыв",
    "help": "Есть ошибка или идея? Напишите нам здесь.",
    "kindLabel": "Тип",
    "kind_bug": "Баг",
    "kind_feature": "Запрос функции",
    "kind_other": "Другое",
    "kind_crash": "Отчёт о сбое",
    "bodyLabel": "Подробности",
    "bodyPlaceholder": "Опишите, что вы увидели, чего ожидали и как это воспроизвести.",
    "send": "Отправить",
    "sending": "Отправка…",
    "sentFlash": "Спасибо, отправлено.",
    "sentHint": "Мы читаем каждое сообщение.",
    "close": "Закрыть",
    "errSubmit": "Не удалось отправить. Попробуйте ещё раз позже.",
    "errRateLimit": "Слишком много отправок за последний час. Попробуйте позже.",
    "inboxTitle": "Входящие отзывы",
    "loading": "Загрузка отзывов…",
    "empty": "Нет отзывов.",
    "filterAll": "Все",
    "loadMore": "Загрузить ещё",
    "status_open": "Открыт",
    "status_in_progress": "В работе",
    "status_shipped": "Готово",
    "status_wontfix": "Не будет исправлено",
    "priorityLabel": "Приоритет",
    "priorityNone": "Нет",
    "statusLabel": "Статус",
    "head_open": "{{count}} открыто",
    "head_in_progress": "{{count}} в работе",
    "head_shipped": "{{count}} готово",
    "head_wontfix": "{{count}} не будет исправлено",
    "headTotal": "{{count}} всего"
  },
  "profile": {
    "title": "Профиль",
    "loading": "Загрузка профиля…",
    "loadingHint": "Станет доступно после загрузки профиля.",
    "name": "Отображаемое имя",
    "namePlaceholder": "Как к вам обращаться?",
    "role": "Роль",
    "roleCoach": "Тренер",
    "roleAthlete": "Спортсмен",
    "roleBoth": "Оба",
    "ageBucket": "Возрастная группа (необязательно)",
    "ageBucketHelp": "Используется только для добровольной анонимной групповой статистики. Если не выбрать, останется пустым.",
    "ageBucketNone": "Предпочитаю не указывать",
    "unitsPreference": "Предпочитаемые единицы",
    "unitsPreferenceHelp": "Вес всегда хранится в килограммах. В каждой записи тренировки можно выбрать другую единицу ввода.",
    "preferredFigure": "Фигура на карте тела",
    "preferredFigureHelp": "Выберите фигуру для карт мышц.",
    "figure_masculine": "Мужская",
    "figure_feminine": "Женская",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "saved": "Профиль сохранён.",
    "agePrefix_under_18": "До 18",
    "age_18-24": "18-24",
    "age_25-29": "25-29",
    "age_30-34": "30-34",
    "age_35-39": "35-39",
    "age_40-44": "40-44",
    "age_45-49": "45-49",
    "age_50-54": "50-54",
    "age_55-59": "55-59",
    "age_60-64": "60-64",
    "age_65-69": "65-69",
    "age_70-plus": "70+",
    "bodyweight": "Вес тела (необязательно)",
    "bodyweightPlaceholder": "напр. 78",
    "bodyweightHelp": "Используется только для расчёта эффективной нагрузки в упражнениях со своим весом. Никогда не агрегируется, не попадает в логи, удаляется вместе с аккаунтом.",
    "errBodyweight": "Введите вес от 20 до 300 кг (или эквивалент в lb).",
    "apk": {
      "title": "Android APK (тестовая сборка)",
      "hint": "Тестовая сборка только для семьи. На Android включите «Установка из неизвестных источников» в браузере и откройте файл.",
      "download": "Скачать APK"
    },
    "email": "Эл. почта",
    "metaTitle": "Сессия"
  },
  "workout": {
    "title": "Тренировки",
    "loading": "Загрузка тренировок…",
    "empty": "Тренировок пока нет.",
    "logNew": "Записать тренировку",
    "startedAt": "Когда",
    "exercise": "Упражнение",
    "exercisePlaceholder": "Выберите упражнение",
    "errPickExercise": "Выберите упражнение из каталога.",
    "catalogEmptyCoach": "Каталог пуст. Добавьте хотя бы одно упражнение, прежде чем записывать тренировку.",
    "catalogEmptyAthlete": "Каталог пуст. Один из ваших тренеров должен добавить упражнения, прежде чем вы сможете записать тренировку.",
    "setsLegend": "Подходы",
    "set": "Подход",
    "reps": "Повторы",
    "amrapHint": "AMRAP: превысьте заданный минимум",
    "weight": "Вес",
    "extra": "Доп. (+/−)",
    "unit": "Единицы",
    "rpe": "RPE",
    "addSet": "Добавить подход",
    "removeSet": "Удалить подход",
    "notes": "Заметки (необязательно)",
    "setNoteToggle": "Добавить заметку к этому подходу",
    "setNotePlaceholder": "Что было особенного в этом подходе",
    "prefillFromDate": "Заполнить из тренировки {{date}}?",
    "prefillAccept": "Применить",
    "savePromptTitle": "Проверьте перед сохранением",
    "savePromptContinue": "Вернуться к тренировке",
    "savePromptAnyway": "Всё равно сохранить",
    "unmarkedPromptBody": "Подходов с данными, но без отметки: {{count}}.",
    "unmarkedPromptFail": "Отметить как неудачные и сохранить",
    "unmarkedPromptComplete": "Отметить как выполненные и сохранить",
    "notWorkPromptBody": "Ни один подход здесь не считается настоящей работой (ничего достаточно тяжёлого). Такие тренировки не попадают в статистику.",
    "outlierPromptBody": "Записей с необычными значениями: {{count}}",
    "outlierItem": "{{exercise}}: {{weight}} (исторический максимум {{expected}})",
    "outlierE1rmItem": "{{exercise}}: расчётный 1RM {{e1rm}} (исторический максимум {{expected}})",
    "outlierPerImplementItem": "{{exercise}}: {{weight}} примерно вдвое больше вашего обычного {{expected}}. Вы ввели вес ОДНОЙ гантели или общий вес двух?",
    "outlierRepsItem": "{{exercise}}: {{reps}} повторений, слишком много",
    "outlierZeroWeightItem": "{{exercise}}: {{reps}} повторений без веса",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "saved": "Тренировка сохранена.",
    "savedEdit": "Тренировка обновлена.",
    "deleted": "Тренировка удалена.",
    "cancel": "Отмена",
    "errNoSets": "Добавьте хотя бы один корректный подход.",
    "creatingTitle": "Новая тренировка",
    "editingTitle": "Редактировать тренировку",
    "exerciseN": "Упражнение {{n}}",
    "addExercise": "Добавить ещё одно упражнение",
    "removeExercise": "Убрать упражнение",
    "removeExerciseConfirm": "Убрать {{name}} из тренировки? Уже записанные подходы будут потеряны.",
    "groupAlignTitle": "Разное число подходов",
    "groupAlignBody": "У участников группы от {{shortest}} до {{longest}} подходов. Выровнять, чтобы круги совпадали?",
    "groupAlignPad": "+ Дополнить до {{n}}",
    "groupAlignTrim": "− Сократить до {{n}}",
    "groupAlignTrimWarning": "Сокращение удалит уже записанные подходы, и вернуть их будет нельзя.",
    "groupAlignTrimHint": "Удаляет лишние подходы у каждого участника группы. Отменить нельзя.",
    "groupAlignKeep": "Оставить как есть",
    "splitGroup": "Разъединить",
    "splitGroupTitle": "Разъединить группу?",
    "splitGroupBody": "Упражнения сохранят подходы и останутся в тренировке, но без связи. Позже их можно снова сгруппировать.",
    "splitGroupConfirm": "Разъединить",
    "removeRoundConfirmTitle": "Удалить этот круг?",
    "removeRoundConfirmBody": "Круг {{n}} будет удалён у всех упражнений: {{names}}.",
    "bilateral": "Билатерально",
    "unilateral": "Унилатерально",
    "edit": "Изменить",
    "repeat": "Повторить",
    "delete": "Удалить",
    "deleting": "Удаление…",
    "deleteConfirm": "Удалить эту тренировку?",
    "distance": "м",
    "duration": "с",
    "cardioDuration": "Длительность",
    "cardioDistance": "Дистанция",
    "cardioWeight": "Вес",
    "cardioHr": "ЧСС ср.",
    "cardioCalories": "Калории",
    "cardioOptionalsShow": "Другие поля",
    "cardioOptionalsHide": "Скрыть другие поля",
    "dateEditor": "Дата и длительность",
    "dateLabel": "Дата",
    "startTimeLabel": "Начало",
    "endTimeLabel": "Конец",
    "durationLabel": "Длительность",
    "side": "Сторона",
    "sideLeft": "Левая",
    "sideRight": "Правая",
    "sideBoth": "Обе",
    "showRpe": "Учитывать RPE",
    "showDuration": "Учитывать время",
    "rir": "RIR {{n}}",
    "swap": "Заменить",
    "swapHint": "Скамья занята? Выберите похожее упражнение.",
    "descriptionToggle": "Показать / скрыть описание",
    "failShort": "F",
    "failToggle": "Отметить подход как неудачный",
    "failHint": "Последнее повторение не выполнено. Учитывается в объёме, но не учитывается в PR.",
    "startRest": "Запустить таймер отдыха",
    "restStartDefault": "Старт отдыха ({{n}} с)",
    "restStartCustom": "Старт отдыха ({{n}} с, по умолчанию для упражнения)",
    "setComplete": "Отметить подход выполненным",
    "setCompleteHint": "Зафиксировать подход и запустить отдых {{n}} с.",
    "setCompleteHintCustom": "Зафиксировать подход и запустить отдых {{n}} с (по умолчанию для упражнения).",
    "setUndo": "Отменить отметку",
    "setUndoHint": "Нажмите снова, чтобы отменить и сбросить таймер.",
    "restLeft": "Отдых",
    "restDone": "Время вышло",
    "restStop": "Стоп",
    "restPause": "Пауза",
    "restResume": "Продолжить",
    "restSound": "Сигнал в конце отдыха",
    "instructions": "Указания тренера (необязательно)",
    "instructionsPlaceholder": "Фокус тренировки, что пропустить при нехватке времени, замысел.",
    "lastTime": "Прошл.",
    "lastToday": "сегодня",
    "lastDaysAgo": "{{n}} дн. назад",
    "dropsetShort": "Дроп",
    "dropsetToggle": "Добавить цепочку дропсета",
    "dropsetTitle": "Дропсет",
    "dropsetVariant": "Вариант",
    "dropsetClassical": "Классический (вес снижается)",
    "dropsetMyorep": "Мио-реп (тот же вес)",
    "dropsetHintClassical": "Снизьте вес на 10–30 % и продолжайте до отказа. Без паузы.",
    "dropsetHintMyorep": "Тот же вес, меньше повторений, 10–20 с дыхания, повторить.",
    "dropsetSameLoad": "= тот же",
    "dropsetAddStep": "Добавить дроп",
    "dropsetRemove": "Убрать",
    "dropsetRemoveConfirm": "У вас {{n}} шагов дропа. Преобразовать обратно в обычный подход и удалить их?",
    "dropsetRemoveStep": "Убрать дроп",
    "groupLabel": "Группа",
    "groupNone": "(нет)",
    "groupCreate": "Создать",
    "groupNewSuperset": "Новый суперсет",
    "groupNewCircuit": "Новая круговая тренировка",
    "groupJoinExisting": "Присоединиться к существующей",
    "groupLeave": "Разгруппировать",
    "groupSharedHint": "Общая. Откройте другое упражнение и выберите ту же группу из списка, чтобы связать их.",
    "supersetN": "Суперсет {{n}}",
    "circuitN": "Круговая {{n}}",
    "supersetDerived": "Суперсет (авто)",
    "supersetDerivedTitle": "Определён по чередованию подходов в этой тренировке",
    "playActiveTitle": "Активное упражнение: последний завершённый подход",
    "errGroupKindMixed": "Одна группа не может сочетать суперсет и круговую тренировку. Выберите один тип.",
    "exerciseNew": "Новое упражнение",
    "cardMenu": "Опции упражнения",
    "menuReplace": "Заменить упражнение",
    "menuGroup": "Группа / суперсет",
    "menuMoveUp": "Переместить вверх",
    "menuMoveDown": "Переместить вниз",
    "menuShowNotes": "Показать заметки",
    "menuHideNotes": "Скрыть заметки",
    "menuShowDescription": "Показать описание",
    "menuHideDescription": "Скрыть описание",
    "tipAlternatives": "Альтернативные упражнения",
    "tipCoachNote": "Заметка тренера",
    "perImplementHint": "Используете два снаряда или работаете на одну сторону? Укажите вес одного. Приложение учтёт оба (×2).",
    "tipProgramNote": "В этой программе",
    "tipNoAlternatives": "В каталоге нет похожих упражнений",
    "tipClose": "Закрыть",
    "painBanner": {
      "red": "Нагружает болезненную мышцу",
      "yellow": "Внимание: нагружает помеченную мышцу",
      "green": "Без риска боли"
    },
    "setCycleHint": "Тап: готово · ещё: провал · ещё: отмена",
    "setStatePending": "Подход открыт",
    "setStateDone": "Подход закрыт",
    "setStatePr": "Подход закрыт, личный рекорд",
    "setStateFailed": "Подход помечен как неудачный",
    "prShort": "🏆",
    "addDrop": "+ дроп",
    "groupBannerSuperset": "СУПЕРСЕТ",
    "groupBannerCircuit": "КРУГОВАЯ",
    "groupAutoTag": "АВТО",
    "groupAutoConfirm": "Зафиксировать",
    "groupAutoConfirmAria": "Зафиксировать группу: остановить детектор и оставить упражнения связанными",
    "groupAutoDismissAria": "Игнорировать определение: упражнения снова становятся отдельными",
    "nameLabel": "Название (необязательно)",
    "namePlaceholder": "Напр. Push A · Lower Quad-Dominant",
    "durationStepperA11y": "регулировка длительности",
    "rirLabel": "RIR",
    "showRir": "Учитывать RIR",
    "maxDownA11y": "MAX возможно снизился",
    "animationOf": "Анимация: {{name}}",
    "animationZoomHint": "Откроет анимацию на весь экран",
    "closeAnimation": "Закрыть анимацию",
    "showAnimation": "Показать анимацию",
    "showBodyMap": "Показать задействованные мышцы",
    "pagerDot": "{{target}}, {{current}} из {{total}}",
    "pagePrev": "Предыдущая страница",
    "pageNext": "Следующая страница",
    "editUnsupportedTitle": "Редактирование пока недоступно",
    "editUnsupportedBody": "Эта тренировка содержит типы упражнений (P1RM, переноска веса), которые пока нельзя редактировать.",
    "deleteManyConfirm_one": "Удалить {{count}} тренировку?",
    "deleteManyConfirm_few": "Удалить {{count}} тренировки?",
    "deleteManyConfirm_many": "Удалить {{count}} тренировок?",
    "deleteManyConfirm_other": "Удалить {{count}} тренировки?"
  },
  "program": {
    "title": "Программы",
    "help": "Многонедельные тренировочные циклы. Задайте название, недели и тренировки в неделю. Конструктор слотов и прогрессии появится позже.",
    "new": "Новая программа",
    "newTitle": "Новая программа",
    "name": "Название",
    "namePlaceholder": "напр. Powerbuilding 6 недель",
    "cycleWeeks": "Недели цикла",
    "sessionsPerWeek": "Тренировок в неделю",
    "description": "Описание",
    "descriptionPlaceholder": "Для чего этот цикл, на кого он рассчитан, заметки для спортсменов.",
    "create": "Создать",
    "creating": "Новая программа: {{name}}",
    "cancel": "Отмена",
    "delete": "Удалить",
    "deleteConfirm": "Подтвердить?",
    "deleteConfirmYes": "Да, удалить",
    "loading": "Загрузка программ…",
    "empty": "Пока нет программ. Создайте программу, чтобы спланировать многонедельный цикл.",
    "statusDraft": "Черновик",
    "statusActive": "Активна",
    "statusArchived": "В архиве",
    "cycleWeeksLabel": "Цикл из {{n}} нед.",
    "sessionsPerWeekLabel": "{{n}}× / нед.",
    "slotCount": "Слотов: {{n}}",
    "skeletonHint": "Только скелет. Слоты заполнятся в следующей фазе.",
    "sessionDefaultName": "Тренировка {{n}}",
    "edit": "Редактировать",
    "editing": "Редактирование: {{name}}",
    "assign": "Назначить",
    "backToList": "Назад к программам",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "errSave": "Не удалось сохранить программу.",
    "metaLegend": "Программа",
    "status": "Статус",
    "metaCyclesLive": "Структурные изменения (дни, недели) применяются сразу",
    "ordinalSession": "{{n}}-я тренировка",
    "sessionName": "Название тренировки",
    "slotN": "Слот {{n}}",
    "addSlot": "Добавить слот",
    "removeSlot": "Удалить",
    "moveUp": "Переместить вверх",
    "moveDown": "Переместить вниз",
    "exercise": "Упражнение",
    "exercisePick": "Выберите упражнение",
    "setsLegend": "Подходы",
    "addSet": "Добавить подход",
    "removeSet": "Удалить подход",
    "reps": "Повт.",
    "setNotesPlaceholder": "Заметка к подходу (необязательно)",
    "set": "Подход",
    "intensityKind": "Интенсивность",
    "intensityNone": "Свободно",
    "intensityPercent": "% от MAX",
    "intensityAbs": "кг (абс.)",
    "intensityRpe": "RPE",
    "intensity_percent-of-max": "Процент",
    "intensity_absolute": "Вес (кг)",
    "intensity_rpe": "RPE",
    "weekShort": "Н{{n}}",
    "previewShow": "Предпросмотр",
    "previewHide": "Скрыть предпросмотр",
    "previewMuscles": "Задействованные мышцы",
    "previewSets": "{{n}} подходов",
    "previewEmptySession": "В этой тренировке нет слотов.",
    "previewEmptyProgram": "Пока нет слотов. Откройте «Редактировать», чтобы добавить.",
    "start": "Начать тренировку",
    "startCancel": "Отмена",
    "startGo": "Начать",
    "starting": "Запуск…",
    "startWeek": "Неделя",
    "startSession": "Тренировка",
    "progressNext": "Следующая: Н{{w}} · Тренировка {{s}}",
    "instructions": "Указания",
    "instructionsPlaceholder": "Темп, длина паузы, технический фокус, целевой RPE.",
    "amrapLastSet": "AMRAP в последнем подходе",
    "maxAttempt": "Попытка 1MAX",
    "amrapBadge": "AMRAP",
    "maxBadge": "1MAX",
    "slotCycleHint": "Применяется на протяжении {{n}} недель цикла.",
    "catalogLoading": "Загрузка каталога упражнений…",
    "builderComingSoon": "Конструктор слотов и прогрессии появится позже. Пока это создаёт пустую оболочку, которую можно удалить или заполнить.",
    "errCycleWeeks": "Число недель цикла должно быть от 1 до 12.",
    "errSessionsPerWeek": "Тренировок в неделю должно быть от 1 до 7.",
    "errName": "Название программы обязательно.",
    "errSchema": "Некорректные данные программы.",
    "errCreate": "Не удалось создать программу.",
    "errCode": {
      "sessionNameEmpty": "У каждого тренировочного дня должно быть название.",
      "slotNoExercise": "Выберите упражнение для каждого слота.",
      "slotNoSets": "В каждом упражнении должен быть хотя бы один подход.",
      "slotAllWeeksInactive": "Упражнение отключено во всех неделях. Включите неделю или удалите его.",
      "rowWidthMismatch": "Строка подходов не совпадает с числом недель. Откройте упражнение заново и попробуйте ещё раз.",
      "invalidReps": "Проверьте повторения: используйте число, например 8, или 8+ для AMRAP.",
      "groupKindMixed": "В суперсете смешаны типы подходов. Задайте его упражнениям один тип.",
      "schemaInvalid": "Некорректные данные программы.",
      "noSession": "Нет тренировки для сохранения.",
      "planNameEmpty": "Название плана обязательно.",
      "planNoExercises": "Добавьте в план хотя бы одно упражнение.",
      "invalidIntensityValue": "Проверьте значение интенсивности: оно должно быть числом.",
      "weightOutOfRange": "Этот вес вне диапазона.",
      "pctOutOfRange": "Процент должен быть от 0 до 200.",
      "rpeOutOfRange": "RPE должен быть от 1 до 10.",
      "rirOutOfRange": "RIR должен быть от 0 до 10.",
      "unknownIntensityKind": "Неизвестный тип интенсивности.",
      "invalidSeconds": "Проверьте секунды: подходу на время нужна длительность, целыми секундами до 3600.",
      "invalid_email": "Похоже, этот email указан неверно.",
      "email_not_found": "Аккаунт с таким email не найден.",
      "too_many_assignees": "Не более 20 человек на одну программу.",
      "programNameEmpty": "Название программы обязательно.",
      "sessionEmpty": "В каждом тренировочном дне должно быть хотя бы одно упражнение.",
      "sessionTooManyExercises": "В тренировочном дне может быть не больше 20 упражнений.",
      "amrapWithTime": "Подход на время не может быть одновременно AMRAP. Уберите одно из двух.",
      "client_outdated": "Обновите приложение, чтобы сохранить эту программу.",
      "invalidRepsRange": "Проверьте диапазон: нижняя и верхняя граница вокруг цели, например 8-12 вокруг 10.",
      "invalidPause": "Проверьте паузу: нужны секунды, целые, от 1 до 10."
    },
    "cardMenu": "Меню слота",
    "menuGroup": "Группа",
    "groupNone": "Без группы",
    "groupJoinExisting": "Добавить в группу",
    "groupCreate": "Создать",
    "groupNewSuperset": "Новый суперсет",
    "groupNewCircuit": "Новый круг",
    "groupSupersetN": "Суперсет {{letter}}",
    "groupCircuitN": "Круг {{letter}}",
    "assignTo": "Назначить спортсменам",
    "assignToHelp": "Назначение отправляет предложение: программа попадёт в их библиотеку, только если они его примут. Принятое останется у них, даже если вы их удалите. Нужна активная связь тренер–спортсмен.",
    "assignSelf": "Вы (автор)",
    "addAssignee": "Добавить",
    "removeAssignee": "Убрать",
    "removeAssigneeConfirm": "Убрать доступ?",
    "removeAssigneeHint": "Спортсмен потеряет это из своей библиотеки. Нажмите ещё раз, чтобы убрать.",
    "pendingAssigneeCaption": "Ожидает",
    "rosterSectionLabel": "Из вашего состава",
    "rosterEmpty": "В вашем составе пока нет спортсменов.",
    "rosterAllAssigned": "Все спортсмены из вашего состава уже назначены.",
    "shareTo": "Поделиться с",
    "shareToHelp": "Отправка создаёт предложение: оно попадёт в их библиотеку, только если они его примут, а принятое останется у них, даже если вы их удалите.",
    "shareSectionLabel": "Люди, с которыми можно поделиться",
    "shareEmpty": "Пока не с кем поделиться.",
    "shareAllShared": "У всех, с кем можно поделиться, это уже есть.",
    "emailSectionLabel": "По email",
    "assigneePlaceholder": "athlete@example.com",
    "invalidEmailFormat": "Это не похоже на действительный email.",
    "follow": "Следовать",
    "unfollow": "Не следовать",
    "followHint": "Следовать этой программе (появится в разделе Текущие)",
    "chipDraft": "Черновик",
    "chipFollowed": "Следую",
    "kindShortPercent": "%MAX",
    "kindShortHistory": "ИСТ",
    "kindShortRpe": "RPE",
    "kindShortRir": "RIR",
    "languageUndeclared": "Язык",
    "languageA11y": "Язык написания",
    "languageSwitchQuestion": "На каком языке вы пишете?",
    "languageDeclareQuestion": "На каком языке написана эта программа?",
    "languageFootnote": "Переводы необязательны: программа на одном языке полна.",
    "languageDeclareFootnote": "Ничего не переводится: это только указывает язык.",
    "languageAuto": "Машинный перевод",
    "languageNotYetWritten": "Версии на {{lang}} пока нет. Текст на {{original}} остаётся на месте.",
    "setBound": "Предел",
    "boundReps": "Повт.",
    "boundTime": "Время",
    "boundOpen": "Свободно",
    "workSeconds": "Работа (с)",
    "restSeconds": "Отдых (с)",
    "restSecondsPlaceholder": "авто",
    "restChip": "Отдых: {{value}}",
    "restChipSecs": "{{secs}} с",
    "setCol": "№",
    "prescribeTime": "Время",
    "prescribeTimeA11y": "Задать работу и отдых в секундах",
    "seconds": "Секунды",
    "amrapNotWithTime": "Подход на {{secs}} с не может быть AMRAP. Уберите + или время.",
    "workSecondsRequired": "Сколько секунд?",
    "descriptionAdd": "Добавить описание",
    "descriptionExpand": "Открывает описание для редактирования",
    "descriptionCollapse": "Свернуть описание",
    "undo": "Отменить действие",
    "redo": "Повторить действие",
    "saveStatus": {
      "saving": "Сохранение…",
      "unsaved": "Не сохранено",
      "queued": "Нет сети",
      "saved": "Сохранено"
    },
    "draftConflict": {
      "title": "Программа изменилась",
      "body": "Её изменили в другом месте после начала вашего черновика. Оставить ваш черновик или использовать обновлённую версию? Ничего не изменится, пока вы не нажмёте «Сохранить».",
      "keepDraft": "Оставить мой черновик",
      "useUpdated": "Использовать обновлённую версию"
    },
    "savedElsewhere": {
      "body": "Её изменили в другом месте после того, как вы её открыли. Ничего не сохранено. Если оставить ваш черновик, он заменит ту версию."
    },
    "savedStaysOpen": "Сохранено. Редактор остаётся открытым.",
    "savedQueuedStaysOpen": "В очереди: отправится, когда появится сеть.",
    "newDraft": {
      "title": "Незаконченный черновик",
      "body": "Черновик, начатый на этом устройстве {{when}}, так и не был сохранён. Продолжить его или начать заново и удалить черновик?",
      "bodyNoTime": "Черновик, начатый на этом устройстве, так и не был сохранён. Продолжить его или начать заново и удалить черновик?",
      "resume": "Продолжить",
      "startOver": "Начать заново"
    },
    "repsRange": "Диапазон",
    "repsRangeMin": "Мин. повт.",
    "repsRangeMax": "Макс. повт.",
    "prescribeRangeA11y": "Задать диапазон повторений для подходов",
    "amrapStop": {
      "title": "Остановка при RIR",
      "none": "Без правила",
      "technical": "Срыв техники",
      "rir": "RIR {{n}}",
      "a11yRir_one": "Остановиться с {{count}} повторением в запасе",
      "a11yRir_few": "Остановиться с {{count}} повторениями в запасе",
      "a11yRir_many": "Остановиться с {{count}} повторениями в запасе",
      "a11yRir_other": "Остановиться с {{count}} повторениями в запасе",
      "a11yTechnical": "Остановиться на первом повторении со срывом техники",
      "groupSet": "Где останавливается AMRAP в подходе {{n}}"
    },
    "pause": {
      "phase": {
        "eccentric": "Эксцентрическая",
        "concentric": "Концентрическая",
        "isometric": "Изометрическая"
      },
      "explain": {
        "eccentric": "Опускание веса. Мышца работает, удлиняясь. Опускайте медленно, указанное число секунд.",
        "concentric": "Подъём веса. Мышца работает, укорачиваясь. Поднимайте медленно, указанное число секунд.",
        "isometric": "Неподвижное удержание. Мышца работает без движения. Задержитесь на указанные секунды, обычно внизу."
      },
      "label": {
        "eccentric": "опускание {{sec}} с",
        "concentric": "подъём {{sec}} с",
        "isometric": "удержание {{sec}} с"
      },
      "tip": "{{phase}}: {{meaning}}",
      "none": "Нет",
      "title": "Пауза",
      "seconds": "Пауза (с)",
      "groupSet": "Пауза в повторах подхода {{n}}",
      "chipA11y": "Задать паузу внутри повторов",
      "explainerA11y": "Что значат эксцентрическая, концентрическая и изометрическая",
      "explainerTitle": "Пауза внутри повтора",
      "secondsSet": "Секунды паузы, подход {{n}}",
      "revealed": "Пауза добавлена под каждым подходом"
    }
  },
  "me": {
    "targets": {
      "title": "Цели",
      "historyByCoach": "Ваш тренер",
      "errNotFound": "Не удалось найти ваши цели. Вернитесь назад и повторите."
    }
  },
  "coach": {
    "title": "Тренер и спортсмены",
    "subtitle": "Спортсмены, которых вы тренируете, и тренеры, которые тренируют вас. Чтобы назначать программы, обе стороны должны принять приглашение.",
    "subLabel": "sub",
    "inviteAthleteLabel": "Пригласить спортсмена по email",
    "invitePlaceholder": "athlete@example.com",
    "inviteNotePlaceholder": "Заметка (необязательно)",
    "inviteSend": "Отправить приглашение",
    "inviteSending": "Отправка…",
    "inviteSent": "Приглашение отправлено. Спортсмен увидит его при следующем входе.",
    "athletesHeading": "Мои спортсмены",
    "coachesHeading": "Мои тренеры",
    "athletesEmpty": "Спортсменов пока нет. Пригласите выше.",
    "pendingInLabel": "Ждёт вашего ответа",
    "pendingOutLabel": "Ожидает их ответа",
    "activeLabel": "Активные",
    "accept": "Принять",
    "decline": "Отклонить",
    "cancel": "Отменить приглашение",
    "revoke": "Отозвать",
    "leave": "Покинуть тренера",
    "busy": "Выполняется…",
    "loading": "Загрузка…",
    "loadFailed": "Не удалось загрузить. Обновите страницу.",
    "grants": {
      "heading": "Что может этот тренер",
      "readOnly": "Тренер видит ваши тренировки и ничего не меняет, пока вы не разрешите это здесь.",
      "writeTargets": "Задавать ваши недельные цели",
      "writeTargetsSub": "Каждое изменение остаётся в истории ваших целей."
    },
    "errCode": {
      "invalid_email": "Неверный формат email.",
      "email_not_found": "Нет подтверждённого аккаунта с таким email.",
      "peer_required": "Укажите email или sub.",
      "edge_exists": "Вы уже связаны с этим человеком.",
      "userpool_not_configured": "Сервер настроен неверно: пул пользователей недоступен.",
      "io_error": "Ошибка сети или сервера. Попробуйте снова.",
      "not_pending": "Это приглашение больше не ожидает ответа.",
      "wrong_party": "Только другая сторона может принять это приглашение.",
      "missing_claims": "Сессия истекла. Войдите снова.",
      "table_not_configured": "Сервер настроен неверно: таблица недоступна.",
      "not_found": "Это приглашение больше не существует.",
      "not_athlete": "Только спортсмен может менять права тренера.",
      "edge_not_active": "Эта связь больше не активна."
    },
    "dashboard": {
      "title": "Обзор команды",
      "unnamedAthlete": "Спортсмен",
      "empty": "Пока нет спортсменов",
      "emptySub": "Пригласите спортсменов в разделе «Тренер и спортсмены», чтобы увидеть их здесь.",
      "loading": "Загрузка вашей команды…",
      "loadFailed": "Не удалось загрузить команду. Обновите, чтобы повторить.",
      "noProgram": "Нет программы",
      "kpiAssigned": "Спортсмены",
      "kpiActive": "Активны за последние 7 дней",
      "kpiAttention": "Требуют внимания",
      "kpiAdherence": "Средн. соблюдение",
      "kpiSessions": "Тренировки за последние 7 дней",
      "kpiNotLoaded": "Не загружено: {{count}}. Учтены только в «Спортсмены».",
      "adherence": "соблюдение",
      "lastNever": "тренировок не было",
      "flagStale": "Не тренируется",
      "flagUnderTarget": "Ниже цели",
      "flagOnTrack": "В графике",
      "flagNoProgram": "Нет программы"
    },
    "detail": {
      "back": "Назад к команде",
      "maxesTitle": "Текущие MAX",
      "maxesEmpty": "MAX ещё не записаны",
      "rhythmSummary": "в среднем {{avg}}/нед за {{weeks}} нед · прошлая неделя: {{last}}",
      "effortTitle": "Покрытие усилия",
      "effortLabel": "подходы с записанным RIR",
      "effortSummary": "{{tagged}} из {{counted}} засчитанных подходов, включая разминочные",
      "effortEra": "Данные об усилии начинаются {{date}} · {{count}} более ранних подходов не учтены",
      "effortNone": "Ни в одном подходе пока нет значения усилия. Число тяжёлых подходов и цели рассчитать нельзя.",
      "effortError": "Не удалось загрузить данные об усилии.",
      "maxesSeeAll": "Показать все (+{{count}})",
      "maxesShowFewer": "Показать меньше",
      "assignProgram": "Назначить программу"
    },
    "targets": {
      "eyebrow": "Недельные цели",
      "edit": "Изменить цели",
      "degradedHint": "У этого спортсмена пока нет недельных целей. Задайте их, чтобы оценивать его неделю относительно цели.",
      "noGrant": "Только чтение. Спортсмен не разрешил вам изменять цели.",
      "historyTitle": "История изменений",
      "historyEmpty": "Изменений пока нет.",
      "historyByYou": "Вы",
      "historyTruncated": "Показаны последние 1000 изменений.",
      "histGeneric": "Цели обновлены",
      "histSet": "задано: {{value}}",
      "histRemoved": "удалено",
      "histChanged": "{{from}} → {{to}}",
      "histLine": "{{label}} · {{metric}}: {{body}}",
      "historyLoading": "Загрузка…",
      "errLoad": "Не удалось загрузить эти цели. Вернитесь назад и повторите.",
      "errStale": "Эти цели изменились, пока вы редактировали. Перезагрузите и примените снова.",
      "errNoGrant": "Спортсмен не разрешил вам изменять цели.",
      "errNotCoach": "Вы не тренер этого спортсмена.",
      "errMultiAssignee": "Эта программа используется более чем одним спортсменом.",
      "errRetry": "Ещё загружается, повторите через мгновение.",
      "errNotFound": "Этой программы больше нет.",
      "errOffline": "Не удалось сохранить. Проверьте подключение и повторите."
    },
    "assignPicker": {
      "title": "Назначить {{name}}",
      "cancel": "Отмена",
      "rowA11y": "Назначить {{name}}",
      "assignedTitle": "Отправлено",
      "assignedBody": "Отправлено {{name}}, ожидает подтверждения.",
      "alreadyTitle": "Уже назначено",
      "alreadyBody": "У {{name}} уже есть это.",
      "errAssign": "Не удалось назначить. Попробуйте снова."
    },
    "sessions": {
      "title": "Тренировки",
      "setsTitle": "Подходы",
      "noSets": "В этой тренировке нет записанных подходов.",
      "setA11y": "Подход {{n}}: {{summary}}",
      "loadFailed": "Не удалось загрузить тренировки.",
      "unavailable": "Не удалось открыть эту тренировку. Вернитесь назад и попробуйте снова."
    }
  },
  "plans": {
    "assign": "Назначить",
    "title": "Планы",
    "help": "Составьте тренировку для себя. Цели можно задать в абсолютных кг или в процентах от вашего MAX, и они пересчитываются в кг при запуске плана.",
    "loading": "Загрузка планов…",
    "empty": "Планов пока нет. Добавьте один, чтобы подготовить тренировку заранее.",
    "todayPill": "Сегодня",
    "add": "Добавить план",
    "edit": "Изменить",
    "start": "Начать",
    "cancel": "Отмена",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "saved": "План сохранён.",
    "savedEdit": "План обновлён.",
    "deleted": "План удалён.",
    "delete": "Удалить",
    "deleting": "Удаление…",
    "deleteConfirm": "Удалить этот план?",
    "creatingTitle": "Новый план",
    "editingTitle": "Изменить план",
    "name": "Название",
    "namePlaceholder": "напр. День приседа",
    "scheduledFor": "Запланировано на (необязательно)",
    "pickDate": "Выберите дату",
    "pickDateHint": "Открывает выбор даты",
    "clearDate": "Очистить дату",
    "noDate": "Не задана",
    "notes": "Заметки (необязательно)",
    "rpeEnabledLabel": "Показывать колонку RPE в Логгере",
    "rpeEnabledHelp": "Когда включено, тренировки, запущенные из этого плана, открываются с видимой колонкой RPE. Спортсмен всё равно может переключать её для каждой тренировки.",
    "exercise": "Упражнение",
    "exercisePlaceholder": "Выберите упражнение",
    "exerciseN": "Упражнение {{n}}",
    "removeExercise": "Убрать упражнение",
    "addExercise": "Добавить ещё одно упражнение",
    "setsLegend": "Подходы",
    "targetReps": "Повт.",
    "targetWeight": "Вес",
    "targetKind": "Ед.",
    "targetRpe": "RPE",
    "noMaxYet": "нет MAX",
    "addSet": "Добавить подход",
    "removeSet": "Убрать подход",
    "statusDraft": "Черновик",
    "statusScheduled": "Запланирован",
    "statusCompleted": "Выполнен",
    "statusSkipped": "Пропущен",
    "errNotSignedIn": "Нужно войти в аккаунт.",
    "errNameRequired": "Назовите план.",
    "errPickExercise": "Выберите упражнение из каталога.",
    "errNoSets": "Добавьте хотя бы один корректный подход.",
    "errGroupKindMixed": "Все упражнения одной группы должны быть либо суперсетом, либо круговой тренировкой. Выберите одно и сохраните снова.",
    "errCode": {
      "invalid_email": "Похоже, этот email указан неверно.",
      "email_not_found": "Аккаунт с таким email не найден.",
      "too_many_assignees": "Не более 20 человек на одну программу."
    },
    "assignTo": "Назначить спортсменам",
    "assignToHelp": "Назначение отправляет предложение: оно попадёт в библиотеку спортсмена, только если он его примет. Принятое останется у него, даже если вы его удалите. Нужна активная связь с тренером.",
    "assignSelf": "Вы (автор)",
    "addAssignee": "Добавить",
    "removeAssignee": "Удалить",
    "removeAssigneeConfirm": "Убрать доступ?",
    "removeAssigneeHint": "Это исчезнет из библиотеки спортсмена. Нажмите ещё раз, чтобы убрать.",
    "pendingAssigneeCaption": "Ожидает",
    "rosterSectionLabel": "Из вашего состава",
    "rosterEmpty": "В вашем составе пока нет спортсменов.",
    "rosterAllAssigned": "Все спортсмены из вашего состава уже назначены.",
    "shareTo": "Поделиться с",
    "shareToHelp": "Отправка создаёт предложение: оно попадёт в их библиотеку, только если они его примут, а принятое останется у них, даже если вы их удалите.",
    "shareSectionLabel": "Люди, с которыми можно поделиться",
    "shareEmpty": "Пока не с кем поделиться.",
    "shareAllShared": "У всех, с кем можно поделиться, это уже есть.",
    "emailSectionLabel": "По email",
    "assigneePlaceholder": "name@example.com",
    "invalidEmailFormat": "Это не похоже на действительный email.",
    "exerciseNew": "Выберите упражнение",
    "setIndex": "Подход {{n}}",
    "cardMenu": "Меню карточки",
    "menuGroup": "Группа",
    "menuMoveUp": "Выше",
    "menuMoveDown": "Ниже",
    "groupNone": "Без группы",
    "groupJoinExisting": "Добавить в группу",
    "groupCreate": "Создать",
    "groupNewSuperset": "Новый суперсет",
    "groupNewCircuit": "Новый круг",
    "groupSupersetN": "Суперсет {{letter}}",
    "groupCircuitN": "Круг {{letter}}",
    "details": "Подробности",
    "exercisesLabel": "Упражнения",
    "editorEmpty": "Пока нет упражнений. Добавьте одно, чтобы начать составлять план.",
    "selectExercisePrompt": "Выберите упражнение, чтобы изменить его подходы.",
    "addExerciseCta": "Добавить упражнение",
    "removeExerciseConfirm": "Удалить это упражнение?",
    "removeExerciseHint": "Нажмите один раз для подтверждения, затем нажмите ещё раз, чтобы удалить.",
    "collapseExercise": "Свернуть упражнение",
    "supersetTag": "СУПЕРСЕТ",
    "exerciseNoteLabel": "Заметка к упражнению (необязательно)",
    "clear": "Очистить"
  },
  "maxes": {
    "title": "Максимумы",
    "countLabel_one": "{{count}} задан",
    "countLabel_few": "{{count}} заданы",
    "countLabel_many": "{{count}} задано",
    "countLabel_other": "{{count}} задано",
    "help": "MAX задаёте вы: это то, что вы можете поднять сегодня. Программы используют его как базу для процентов. Расчётный 1RM в разделе «Прогресс» только для справки.",
    "loading": "Загрузка максимумов…",
    "empty": "Максимумов пока нет. Добавьте один, чтобы работать с программами в процентах.",
    "add": "Добавить максимум",
    "edit": "Изменить",
    "delete": "Удалить",
    "deleteAction": "Удалить MAX",
    "deleting": "Удаление…",
    "deleted": "MAX удалён.",
    "deleteConfirm": "Удалить MAX для {{name}}? Его история тоже будет удалена. Позже его можно восстановить по вашим тренировкам.",
    "exercise": "Упражнение",
    "exercisePlaceholder": "Выберите упражнение",
    "value": "Значение",
    "source": "Источник",
    "sourceManual": "Задано вручную",
    "sourceTested": "Протестировано в зале",
    "sourceDerived": "Получено из записанного подхода",
    "sourceCalculated": "Оценено по истории",
    "sourceImported": "Импортировано",
    "notes": "Заметки (необязательно)",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "saved": "Максимум сохранён.",
    "cancel": "Отмена",
    "errPickExercise": "Выберите упражнение.",
    "errInvalidValue": "Введите значение от 0 до 2000.",
    "seed": {
      "start": "Предложить из истории",
      "loading": "Чтение истории…",
      "reviewIntro": "У {{count}} упражнений в истории есть достоверный лучший подход. Выберите, какие записать как MAX. Упражнения с уже заданным MAX пропускаются.",
      "selectAll": "Выбрать все",
      "selectNone": "Снять выделение",
      "fromSet": "по {{weight}} × {{reps}}",
      "cancel": "Отмена",
      "apply": "Записать {{count}} MAX",
      "applying": "Сохранение: {{done}} / {{total}}",
      "applied": "Записано {{count}} MAX из истории.",
      "noneApplicable": "Нечего задавать. Либо у всех упражнений уже есть MAX, либо весовой истории не найдено.",
      "close": "Закрыть"
    }
  },
  "progress": {
    "planGaps": {
      "bodyweightOnly": "Только упражнения с собственным весом",
      "bodyweightOnlySub": "Для сегодняшней тренировки: без снарядов",
      "noBodyweight": "Включён только собственный вес: нет упражнений для {{muscles}}.",
      "cycleBelowMev": "Ниже минимума за цикл: {{muscles}}",
      "button": "Запланировать пробелы на сегодня",
      "buttonHint": "Открывает черновик на сегодня в журнале. Программа не меняется.",
      "noGaps": "Ничего ниже минимума в цикле.",
      "leftOut": "Не вошли, не хватает времени: {{muscles}}.",
      "draftBodyweightOnly": "Только упражнения с собственным весом."
    },
    "coverageTitle": "Охват мышц",
    "coverageSeeAll": "Все мышцы (+{{count}})",
    "coverageShowFewer": "Свернуть",
    "coverageCompact": {
      "subtitle": "тяжёлые подходы за последние 7 дней относительно диапазона",
      "leadAboveMrv_one": "Выше максимально восстанавливаемого объёма: {{count}} мышца. Отдача выходит на плато.",
      "leadAboveMrv_few": "Выше максимально восстанавливаемого объёма: {{count}} мышцы. Отдача выходит на плато.",
      "leadAboveMrv_many": "Выше максимально восстанавливаемого объёма: {{count}} мышц. Отдача выходит на плато.",
      "leadAboveMrv_other": "Выше максимально восстанавливаемого объёма: {{count}} мышцы. Отдача выходит на плато.",
      "leadBelowMev_one": "Ниже минимального эффективного объёма: {{count}} мышца.",
      "leadBelowMev_few": "Ниже минимального эффективного объёма: {{count}} мышцы.",
      "leadBelowMev_many": "Ниже минимального эффективного объёма: {{count}} мышц.",
      "leadBelowMev_other": "Ниже минимального эффективного объёма: {{count}} мышцы."
    },
    "period": {
      "days": "{{days}} дн",
      "painDays": "7 / {{days}} дн"
    },
    "title": "Прогресс",
    "show": "Показать",
    "hide": "Скрыть",
    "help": "MAX вы задаёте сами; расчётный 1ПМ по Эпли используется как ориентир. Объём - сумма произведений веса на повторения за тренировку.",
    "e1rm": "Расчётный 1RM",
    "max": "MAX",
    "maxLabel": "MAX",
    "estimatedBadge": "расчётный 1RM пунктиром",
    "volume": "Объём",
    "sessions": "{{n}} тренировок",
    "prFound": "Личный рекорд: {{weight}}.",
    "prUpdating": "Обновление…",
    "viewByExercise": "По упражнению",
    "viewByTag": "По тегу",
    "noTags": "Пока нет тренировок с тегами. Добавьте теги к упражнениям в каталоге, чтобы увидеть здесь агрегированный объём.",
    "totalVolume": "Всего {{weight}}",
    "recordsScope": "Рекорды",
    "recordsAllTime": "За всё время",
    "recordsThisYear": "{{year}}",
    "filterPlaceholder": "Фильтр упражнений",
    "filterCount": "{{visible}} из {{total}}",
    "filterNoMatch": "Под фильтр ничего не подходит.",
    "coverageNoData": "Пока нечего оценивать: запишите тренировку или задайте недельную цель.",
    "volumeLandmark": {
      "source": {
        "rp": "Renaissance Periodization"
      },
      "citation": {
        "rp": "Опубликованные практические ориентиры. Индивидуальный разброс велик. Ваши данные сужают этот диапазон."
      },
      "zone": {
        "belowMev": "ниже MEV",
        "mevMav": "MEV–MAV",
        "mavMrv": "MAV–MRV",
        "aboveMrv": "выше MRV",
        "noBand": "нет опубликованного диапазона"
      },
      "yourTarget": "ваша цель {{v}}",
      "athleteTarget": "цель {{v}}",
      "sets_one": "{{n}} подход",
      "sets_few": "{{n}} подхода",
      "sets_many": "{{n}} подходов",
      "sets_other": "{{n}} подхода"
    },
    "chartGapShort": "+{{count}}д",
    "chartGapLong_one": "{{count}} день с предыдущей точки",
    "chartGapLong_few": "{{count}} дня с предыдущей точки",
    "chartGapLong_many": "{{count}} дней с предыдущей точки",
    "chartGapLong_other": "{{count}} дней с предыдущей точки",
    "chartMorePoints_one": "ещё {{count}} точка",
    "chartMorePoints_few": "ещё {{count}} точки",
    "chartMorePoints_many": "ещё {{count}} точек",
    "chartMorePoints_other": "ещё {{count}} точки",
    "chartWindowA11y": "с {{from}} по {{to}}",
    "chartSummaryA11y": "{{range}}, последнее {{last}}, {{window}}",
    "chartTapHint": "Нажмите на точку, чтобы увидеть значение",
    "chartCapped": "Показаны только самые свежие данные. Более старых данных на этом графике нет.",
    "muscleState": {
      "thin": "Слишком короткая история для темпа: {{n}} из {{needed}} тренировок",
      "none": "Тяжёлых подходов пока нет",
      "a11yOver": "недавняя нагрузка на {{pct}}% выше темпа за 28 дней",
      "a11yUnder": "недавняя нагрузка на {{pct}}% ниже темпа за 28 дней",
      "a11yLevel": "недавняя нагрузка на уровне темпа за 28 дней"
    },
    "gapProposal": {
      "toggle": "Закрыть разрыв",
      "toMev_one": "<num>{{n}}</num> подход/нед до MEV",
      "toMev_few": "<num>{{n}}</num> подхода/нед до MEV",
      "toMev_many": "<num>{{n}}</num> подходов/нед до MEV",
      "toMev_other": "<num>{{n}}</num> подхода/нед до MEV",
      "basis": "MEV {{mev}} − сред. {{avg}}/нед = {{gap}}/нед",
      "eachAlone": "Любое из этих упражнений закрывает его само по себе:",
      "alsoWorks": "также работают: {{muscles}}",
      "atPlace": "В {{place}}, без того, что вы отметили там как отсутствующее.",
      "noPlace": "Весь каталог: место по умолчанию не задано.",
      "wholeCatalog": "Весь каталог: где тренируется спортсмен, тренерам не сообщается.",
      "noneAtPlace": "В {{place}} ничего не осталось: все упражнения на эту мышцу отмечены там как отсутствующие.",
      "noneInCatalog": "В каталоге нет упражнений на эту мышцу.",
      "shortHistory_one": "Для оценки разрыва нужно 4 полные недели истории: пока {{n}}.",
      "shortHistory_few": "Для оценки разрыва нужно 4 полные недели истории: пока {{n}}.",
      "shortHistory_many": "Для оценки разрыва нужно 4 полные недели истории: пока {{n}}.",
      "shortHistory_other": "Для оценки разрыва нужно 4 полные недели истории: пока {{n}}.",
      "a11yToggle": "{{muscle}}: закрыть разрыв, {{gap}} подходов в неделю до MEV",
      "buildToday": "Собрать тренировку на сегодня из этих разрывов"
    }
  },
  "programModel": {
    "wizard": {
      "cut": {
        "row": "Убрано из-за времени",
        "rowUncovered_one": "Убрано из-за времени: {{muscles}} остаётся ниже MEV",
        "rowUncovered_few": "Убрано из-за времени: {{muscles}} остаются ниже MEV",
        "rowUncovered_many": "Убрано из-за времени: {{muscles}} остаются ниже MEV",
        "rowUncovered_other": "Убрано из-за времени: {{muscles}} остаются ниже MEV",
        "putBackHint": "Оно останется, а вместо него уберётся другое упражнение.",
        "summary_one": "{{minutes}} мин оставляют за бортом {{count}} упражнение, оно зачёркнуто ниже. Вернуть: вместо него уйдёт другое.",
        "summary_few": "{{minutes}} мин оставляют за бортом {{count}} упражнения, они зачёркнуты ниже. Вернуть одно: вместо него уйдёт другое.",
        "summary_many": "{{minutes}} мин оставляют за бортом {{count}} упражнений, они зачёркнуты ниже. Вернуть одно: вместо него уйдёт другое.",
        "summary_other": "{{minutes}} мин оставляют за бортом {{count}} упражнения, они зачёркнуты ниже. Вернуть одно: вместо него уйдёт другое.",
        "summaryCount_one": "{{minutes}} мин оставляют за бортом {{count}} упражнение.",
        "summaryCount_few": "{{minutes}} мин оставляют за бортом {{count}} упражнения.",
        "summaryCount_many": "{{minutes}} мин оставляют за бортом {{count}} упражнений.",
        "summaryCount_other": "{{minutes}} мин оставляют за бортом {{count}} упражнения."
      },
      "gaps": {
        "title": "Тяжёлые подходы в неделю, относительно диапазона",
        "bodyweightOnlyHint": "В предложениях только упражнения с собственным весом. Не сохраняется.",
        "belowTitle": "Ниже MEV",
        "aboveTitle": "Выше MRV",
        "aboveNote": "Только отмечено: ничего не убирается, чтобы снизить.",
        "noSuggestion": "Нет предложения: {{muscles}}.",
        "allWeeks": "ниже MEV каждую неделю",
        "noDay": "Ни один тренировочный день не может принять упражнение: {{muscle}} остаётся ниже MEV.",
        "noRoom": "Нет места: у дня {{day}} больше всего свободного времени, но {{exercise}} не помещается. {{muscle}} остаётся ниже MEV: увеличить минуты или убрать другое упражнение.",
        "suggested": "Предложение: {{exercise}}",
        "addTo": "Добавить в {{day}}",
        "addA11y": "Добавить {{exercise}} в {{day}}, для {{muscle}}",
        "added": "{{exercise}} добавлено в {{day}}."
      }
    }
  },
  "cohort": {
    "compare": "Сравнить с группой (анонимно)",
    "hide": "Скрыть сравнение",
    "loading": "Загрузка данных группы…",
    "empty": "Пока недостаточно данных для сравнения. Порог - десять человек в одной возрастной группе.",
    "contributors": "На основе данных {{n}} анонимных участников с указанной возрастной группой.",
    "yourGroup": "ваша группа"
  },
  "catalog": {
    "title": "Каталог упражнений",
    "empty": "Упражнений пока нет.",
    "region": "Зона",
    "region_lower": "Низ",
    "region_posterior": "Задняя цепь",
    "region_chest": "Грудь",
    "region_back": "Спина",
    "region_shoulders": "Плечи",
    "region_arms": "Руки",
    "region_core": "Кор",
    "region_cardio": "Кардио",
    "region_other": "Другое",
    "pattern": "Паттерн",
    "pattern_squat": "Присед",
    "pattern_hinge": "Тазобедренный сгиб",
    "pattern_horizontal-push": "Горизонтальный жим",
    "pattern_vertical-push": "Вертикальный жим",
    "pattern_horizontal-pull": "Горизонтальная тяга",
    "pattern_vertical-pull": "Вертикальная тяга",
    "pattern_lunge": "Выпад",
    "pattern_carry": "Перенос",
    "pattern_core": "Кор",
    "pattern_isolation": "Изоляция",
    "pattern_mobility": "Мобильность",
    "pattern_cardio": "Кардио",
    "pattern_other": "Другое",
    "equipment": "Снаряд",
    "equipment_barbell": "Штанга",
    "equipment_dumbbell": "Гантели",
    "equipment_kettlebell": "Гиря",
    "equipment_cable": "Блочный тренажёр",
    "equipment_machine": "Тренажёр",
    "equipment_bodyweight": "Своё тело",
    "equipment_band": "Резина",
    "equipment_other": "Другое",
    "tags": "Теги",
    "equipment_treadmill": "Беговая дорожка",
    "equipment_exercise-bike": "Велотренажёр",
    "equipment_elliptical": "Эллиптический тренажёр",
    "equipment_rower": "Гребной тренажёр",
    "equipment_stair-climber": "Степпер",
    "equipment_jump-rope": "Скакалка",
    "equipment_battle-ropes": "Боевые канаты",
    "equipment_sled": "Сани",
    "deletedExercise": "Удалённое упражнение"
  },
  "swap": {
    "title": "Заменить упражнение",
    "currentLabel": "Текущее",
    "searchPlaceholder": "Поиск в каталоге…",
    "showAll": "Показать все упражнения",
    "noMatches": "Нет упражнений по запросу.",
    "noSuggestions": "Похожих по тегам не найдено. Включите «Показать все», чтобы открыть весь каталог.",
    "close": "Закрыть",
    "reasonTags": "Общих тегов: {{count}}",
    "reasonPrimary": "Общих мышц: {{count}}",
    "reasonDifferentEquipment": "Другое оборудование",
    "suggestedSection": "Рекомендуемые",
    "allSection": "Все упражнения",
    "whichMachine": "Какой тренажёр?",
    "defaultMachine": "Тренажёр по умолчанию",
    "machineLabel": "Тренажёр {{letter}}",
    "setMachine": "Выбрать тренажёр",
    "machineChoices": "Известных тренажёров: {{count}}",
    "newMachine": "Новый тренажёр",
    "bandSession": "Тренировка",
    "bandCurrentExercise": "Это упражнение",
    "bandOtherExercises": "Перейти к другому упражнению",
    "equipmentKey": "Оборудование",
    "currentConsequence": "Уже записанные подходы останутся: изменится только оборудование, на котором они отмечены.",
    "unavailableTitle": "Здесь этого нет?",
    "unavailableBody": "Отметьте оборудование для «{{exercise}}», которого нет здесь: «{{place}}». Записывается только отмеченное.",
    "unavailableConfirm": "Сохранить",
    "unavailableOpen": "Оборудование здесь недоступно",
    "unavailableOpenHint": "Спрашивает, какого оборудования для этого упражнения нет.",
    "unavailableBadge": "Здесь нет",
    "unavailableRestore": "Снова доступно здесь",
    "unavailableErrorTitle": "Не удалось сохранить",
    "unavailableErrorBody": "Оборудование по-прежнему считается доступным здесь.",
    "unavailableConfirmHint": "Отметьте хотя бы одно, чтобы сохранить.",
    "pinDefaultMachine": "Всегда использовать тренажёр по умолчанию здесь",
    "pinMachine": "Всегда использовать {{machine}} здесь",
    "pinHint": "Перестанет спрашивать, какой тренажёр использовать в этом зале для этого упражнения.",
    "pinErrorTitle": "Не удалось сохранить",
    "pinErrorBody": "Тренажёр по умолчанию здесь не изменился.",
    "unpinDefaultMachine": "Больше не использовать здесь тренажёр по умолчанию",
    "unpinMachine": "Больше не использовать здесь {{machine}}",
    "pinnedFootnoteDefault": "Здесь всегда используется тренажёр по умолчанию.",
    "pinnedFootnoteMachine": "Здесь всегда используется {{machine}}.",
    "unpinHint": "Снова будет спрашивать, какой тренажёр использовать в этом зале для этого упражнения."
  },
  "tabs": {
    "workout": "Тренировка",
    "plan": "План",
    "progress": "Прогресс",
    "profile": "Профиль",
    "catalog": "Каталог",
    "admin": "Админ",
    "workoutEyebrow": "Тренировка на сегодня",
    "planEyebrow": "Планирование",
    "progressEyebrow": "Графики и отчёты",
    "profileEyebrow": "Аккаунт и максимумы",
    "catalogEyebrow": "Каталог упражнений",
    "adminEyebrow": "Админ-консоль",
    "progressEmpty": "Сначала запишите тренировку. Графики появятся, когда будут данные."
  },
  "shell": {
    "navAria": "Основная навигация"
  },
  "theme": {
    "aria": "Тема",
    "light": "Светлая",
    "dark": "Тёмная",
    "auto": "Авто"
  },
  "mobile": {
    "bodymap": {
      "muscle": {
        "chest": "Грудь",
        "biceps": "Бицепс",
        "triceps": "Трицепс",
        "forearm": "Предплечья",
        "front-deltoids": "Плечи",
        "back-deltoids": "Задние дельты",
        "trapezius": "Трапеции",
        "upper-back": "Спина",
        "lower-back": "Поясница",
        "abs": "Кор",
        "obliques": "Кор",
        "quadriceps": "Квадрицепс",
        "hamstring": "Бицепс бедра",
        "gluteal": "Ягодицы",
        "adductors": "Аддукторы",
        "abductors": "Абдукторы",
        "calves": "Икры",
        "tibialis": "Передняя большеберцовая",
        "neck": "Шея",
        "head": "Голова"
      }
    },
    "tabs": {
      "workouts": "Тренировки",
      "plan": "Главная",
      "progress": "Прогресс",
      "catalog": "Каталог",
      "profile": "Профиль",
      "settings": "Настройки",
      "inbox": "Входящие",
      "athletes": "Спортсмены",
      "library": "Библиотека",
      "me": "Я"
    },
    "me": {
      "sectionTraining": "Тренировки",
      "navTargets": "Цели",
      "navTargetsSub": "Ваши недельные цели"
    },
    "settings": {
      "title": "Настройки",
      "exercisesSection": "Упражнения",
      "navExercisesSub": "Максимумы, каталог, шкала усилия",
      "navCatalog": "Каталог упражнений",
      "selectPrompt": "Выберите настройку, чтобы открыть её.",
      "navCatalogSub": "Просмотр библиотеки упражнений",
      "navEffort": "Настройки усилия",
      "navEffortSub": "Шкала RIR / RPE + легенда",
      "navLicenses": "Лицензии open source",
      "navLicensesSub": "Библиотеки, на которых работает приложение",
      "sectionAccount": "Аккаунт",
      "sectionTraining": "Тренировка",
      "sectionBody": "Тело",
      "sectionPersonalDetails": "Личные данные",
      "sectionPrefs": "Настройки",
      "sectionAbout": "О приложении",
      "sectionHealthConnect": "Health Connect",
      "navHealthConnect": "Health Connect",
      "navHealthConnectSub": "Синхронизируйте тренировки и данные о здоровье с устройства"
    },
    "energySource": {
      "estimate": "оценка",
      "estimateRough": "приблизительная оценка",
      "pillLabel": "Об этой оценке",
      "projectionNote": "Включает подход, который вы вот-вот выполните: прогноз на всю тренировку, а не уже записанную работу."
    },
    "hc": {
      "title": "Health Connect",
      "intro": "Импортируйте активность с часов и телефона в $t(brand.product). Прогулки, походы и велозаезды становятся тренировками; пульс дополняет записанное вами кардио. Выключено, пока вы не подключите.",
      "notRead": "Мы не читаем калории и жировую массу: оценки устройств слишком неточны.",
      "checking": "Проверка…",
      "unavailable": "Health Connect недоступен на этом устройстве.",
      "updateRequired": "Обновите приложение Health Connect, чтобы продолжить.",
      "notConnected": "Не подключено.",
      "connect": "Подключить Health Connect",
      "connectHelp": "Вы выбираете, какие данные может читать $t(brand.product). Изменить можно в любой момент в Health Connect.",
      "connected": "Подключено",
      "reads": "Читает кардиотренировки с пульсом и дистанцией.",
      "syncNow": "Синхронизировать",
      "neverSynced": "Ещё не синхронизировано.",
      "lastSyncedAt": "Последняя синхронизация: {{when}}",
      "syncDelayNote": "Новой активности может понадобиться несколько минут, чтобы попасть в Health Connect с вашего устройства. Недавняя прогулка или поездка может появиться только при следующей синхронизации. Такая задержка нормальна.",
      "syncFullHistory": "Синхронизировать всю историю",
      "syncingFullHistory": "Синхронизация всей истории",
      "syncFullHistoryHelp": "Перепроверяет всю историю и заполняет пробелы в Health Connect. Используйте, если там не хватает прошлой правки. Можно повторять без риска.",
      "resultSummary": "{{imported}} импортировано · {{enriched}} дополнено · {{skipped}} пропущено",
      "error": "Что-то пошло не так. Попробуйте ещё раз.",
      "grantRefused": "Ваш аккаунт не записал это согласие, поэтому $t(brand.product) не будет читать Health Connect. Попробуйте подключиться позже.",
      "revokeRefused": "Health Connect отключён на этом телефоне, но ваш аккаунт не записал отзыв и всё ещё показывает ваше согласие. Попробуйте позже.",
      "revokedElsewhere": "Вы отозвали согласие на другом устройстве, поэтому Health Connect отключён на этом телефоне.",
      "manageInHc": "Управлять в Health Connect",
      "disconnect": "Отключить",
      "disconnectTitle": "Отключить Health Connect?",
      "disconnectBody": "$t(brand.product) перестанет читать ваши данные Health Connect. Уже импортированные тренировки останутся в истории.",
      "logoA11y": "Health Connect",
      "privacyTitle": "Ваши данные",
      "privacyBody": "$t(brand.product) читает только то, что вы разрешили в Health Connect, и только на этом телефоне после подключения. Данные хранятся в вашем личном аккаунте $t(brand.product), никогда не передаются и не продаются. Отключите в любой момент, чтобы остановить.",
      "explainerTitle": "Что читает $t(brand.product) и зачем",
      "explainerIntro": "Дальше Android спросит вас. Можно разрешить всё, часть или ничего и изменить это в любой момент в Health Connect.",
      "explainerContinue": "Перейти к Android",
      "explainerCancel": "Не сейчас",
      "consentGiven": "Согласие дано {{when}}.",
      "consentWithdrawn": "Согласие дано {{given}}, отозвано {{withdrawn}}.",
      "consentWithdrawnOnly": "Согласие отозвано {{withdrawn}}.",
      "consentBeforeRecord": "Согласие дано до того, как в $t(brand.product) появилась запись даты.",
      "consentCategories": "Что вы разрешили",
      "consentRecordNote": "Эта запись принадлежит вашему аккаунту и хранит каждое согласие и каждый отзыв с датой. Android даёт разрешение на каждом телефоне отдельно.",
      "explainerMore": "Ниже есть ещё, прокрутите, чтобы прочитать всё.",
      "deviceAllowed": "На этом телефоне: разрешено Android.",
      "deviceNotAllowed": "На этом телефоне: не разрешено Android.",
      "driftDeviceOff": "В вашем аккаунте есть ваше согласие, но Android больше не разрешает это на этом телефоне. Разрешите снова, чтобы синхронизировать здесь.",
      "driftNoRecord": "Android разрешает это на этом телефоне, но в вашем аккаунте нет действующего согласия. Посмотрите, что читает $t(brand.product), затем подтвердите в запросе Android. Аккаунт запишет согласие с сегодняшней датой.",
      "driftUndated": "У вашего согласия пока нет даты. Посмотрите, что читает $t(brand.product), затем подтвердите в запросе Android: аккаунт запишет согласие с сегодняшней датой.",
      "allowOnPhone": "Разрешить на этом телефоне",
      "confirmConsent": "Проверить и подтвердить",
      "permOther": "Другое разрешение",
      "perm": {
        "readExerciseSession": {
          "name": "Тренировки",
          "use": "Прогулка, пробежка или велопоездка, записанная часами или телефоном, появляется в вашей ленте как тренировка."
        },
        "readHeartRate": {
          "name": "Пульс",
          "use": "Средний и максимальный пульс показываются в вашем кардио и используются для оценки его калорий."
        },
        "readActiveCaloriesBurned": {
          "name": "Активные калории"
        },
        "readDistance": {
          "name": "Дистанция",
          "use": "Заполняет дистанцию в кардио-подходах тренировки с часов или телефона."
        },
        "readWeight": {
          "name": "Вес",
          "use": "Попадает в историю и график вашего веса в разделе «Тело»."
        },
        "readBodyFat": {
          "name": "Жировая масса"
        },
        "readLeanBodyMass": {
          "name": "Безжировая масса"
        },
        "readNutrition": {
          "name": "Питание",
          "use": "Углеводы за сегодня показываются на карточке «Метаболизм» рядом с глюкозой."
        },
        "readBloodGlucose": {
          "name": "Глюкоза",
          "use": "Ваши измерения показываются на карточке «Метаболизм» в виде кривой и последнего значения."
        },
        "writeBloodGlucose": {
          "name": "Запись глюкозы",
          "use": "Значение глюкозы, введённое в $t(brand.product), сохраняется и в Health Connect."
        },
        "writeWeight": {
          "name": "Запись веса",
          "use": "Взвешивание, введённое в $t(brand.product), сохраняется и в Health Connect."
        }
      },
      "bodyResult": "Тело: импортировано {{imported}} · пропущено {{skipped}}",
      "bodyNotGranted": "Данные здоровья ещё не разрешены. Нажмите «Разрешить данные здоровья».",
      "readsFull": "Читает кардиотренировки с пульсом и дистанцией, вес, глюкозу и питание. Записывает глюкозу и вес обратно в Health Connect.",
      "backfillTitle": "Импортировать историю с мая?",
      "backfillBody": "Просматривает историю Health Connect до мая и импортирует то, чего нет. Можно запускать повторно: уже импортированное пропускается.",
      "backfillNow": "Импортировать историю",
      "grantExtra": "Разрешить данные здоровья",
      "extraGrantBody": "Импортировать также вес, глюкозу и питание.",
      "metabolicResult": "Импортировано: глюкоза {{glucose}} · питание {{nutrition}}",
      "metabolicNotGranted": "Глюкоза и питание ещё не разрешены.",
      "writeGlucoseGrantBody": "Разрешить $t(brand.product) записывать глюкозу в Health Connect.",
      "grantWrite": "Разрешить запись",
      "syncGlucoseToHc": "Записать глюкозу в Health Connect"
    },
    "metabolic": {
      "title": "Метаболизм",
      "loading": "Загрузка…",
      "empty": "Подключите Health Connect и синхронизируйте, чтобы видеть здесь глюкозу и питание.",
      "glucoseEmpty": "Нет измерений глюкозы",
      "mgdl": "мг/дл",
      "targetBand": "Типичный целевой диапазон {{lo}}–{{hi}} {{unit}}.",
      "carbsToday": "Углеводы сегодня",
      "grams": "г",
      "glucoseTitle": "Глюкоза",
      "glucoseCurrent": "Последнее: {{value}} {{unit}}",
      "glucoseNone": "Запишите значение, чтобы отслеживать глюкозу.",
      "help": "Ваша глюкоза из Health Connect, ниже недавние углеводы. Коснитесь точки на графике, чтобы увидеть значение и время."
    },
    "exercisesScreen": {
      "back": "Назад"
    },
    "body": {
      "back": "Назад",
      "navSub": "Пол, возраст, фигура",
      "navPainMapSub": "Отметьте, где болит",
      "trendsWebHint": "Графики состава тела находятся в мобильном приложении.",
      "sexLabel": "Пол",
      "sexHelp": "Используется только для оценки процента жира. Фигура на карте мышц выбирается отдельно, ниже.",
      "sex_male": "Мужской",
      "sex_female": "Женский",
      "measurementsTitle": "Замеры",
      "measurementsSub": "Вес, обхваты, оценка процента жира",
      "measureTitle": "НОВЫЙ ЗАМЕР",
      "weight": "Вес",
      "field_heightCm": "Рост",
      "field_neckCm": "Шея",
      "field_chestCm": "Грудь",
      "field_waistCm": "Талия",
      "field_hipsCm": "Бёдра",
      "field_bicepsLCm": "Бицепс (Л)",
      "field_bicepsRCm": "Бицепс (П)",
      "field_forearmsLCm": "Предплечье (Л)",
      "field_forearmsRCm": "Предплечье (П)",
      "field_thighsLCm": "Бедро (Л)",
      "field_thighsRCm": "Бедро (П)",
      "field_calvesLCm": "Голень (Л)",
      "field_calvesRCm": "Голень (П)",
      "measureSave": "Сохранить введённые значения",
      "measureHelpC": "Заполняйте только то, что измерили. Пустые поля не сохраняются.",
      "useLastA11y": "Использовать прошлое значение {{value}}",
      "saveFailedTitle": "Не удалось сохранить",
      "saveFailedBody": "Замер не сохранён. Введённые значения остались. Нажмите «Сохранить», чтобы повторить.",
      "editTitle": "ИЗМЕНИТЬ: {{date}}",
      "saveChanges": "Сохранить изменения",
      "editCancelA11y": "Отменить изменение",
      "editRowA11y": "Изменить замер {{date}}",
      "editHelp": "Измените значение или очистите его, чтобы удалить из истории.",
      "trendsLabel": "ТРЕНДЫ",
      "trendsHint": "выбор метрик",
      "trendsExpandA11y": "Показать все метрики",
      "trendsCollapseA11y": "Свернуть метрики",
      "trendsPick": "Выберите замер выше, чтобы увидеть его тренд.",
      "metricComposition": "Состав",
      "metricBodyFat": "Жир",
      "metricLeanMass": "Сухая масса",
      "loadError": "Не удалось загрузить замеры. Проверьте соединение.",
      "navyTitle": "СОСТАВ ТЕЛА (NAVY)",
      "navyNeedsEntry": "Сохраните замер ниже, чтобы оценить процент жира.",
      "navyNeedsSex": "Укажите пол выше, чтобы оценить процент жира.",
      "navyNeedsInputs": "Добавьте рост, шею и талию (и бёдра для женской формулы), чтобы оценить процент жира.",
      "navyBodyFat": "Жир ≈ {{pct}}%",
      "navyLeanMass": "Сухая масса ≈ {{mass}}",
      "navyDisclaimer": "Оценка US Navy (~±3,5%). Смотрите на динамику, а не на одно число.",
      "historyEmpty": "Замеров пока нет. Сохраните один выше, чтобы начать отслеживание.",
      "historyTitle": "ИСТОРИЯ",
      "trendWeight": "ДИНАМИКА ВЕСА",
      "trendBodyFat": "ДИНАМИКА ЖИРА",
      "deleteTitle": "Удалить замер?",
      "deleteEmptyTitle": "Удалить этот замер?",
      "deleteEmptyBody": "Все его значения очищены, поэтому запись будет удалена.",
      "deleteCancel": "Отмена",
      "deleteConfirm": "Удалить",
      "ageLabel": "Возраст",
      "ageHelp": "Необязательно. Нажмите ещё раз, чтобы очистить.",
      "estimateSeriesName": "Оценка",
      "bodyFatProvenance": "Процент жира рассчитывается по обхвату талии и шеи.",
      "bodyFatProvenanceWithHips": "Процент жира рассчитывается по обхвату талии, шеи и бёдер.",
      "trendsHelp": "Один график на каждый выбранный выше показатель. Коснитесь точки на графике, чтобы увидеть значение и дату."
    },
    "effortSettings": {
      "back": "Назад",
      "title": "Усилие",
      "scaleLabel": "Шкала усилия",
      "scaleHelp": "Какую шкалу использует логгер. RIR = повторений в запасе; RPE = воспринимаемое усилие. RPE = 10 − RIR, то есть это одно усилие на двух шкалах."
    },
    "plan": {
      "currentBlockError": "Не удалось задать текущий блок. Попробуйте ещё раз.",
      "currentBlockOn": "Текущий блок: нажмите, чтобы открепить",
      "currentBlockOff": "Сделать текущим блоком",
      "currentBlockHint": "Выводит эту программу на первый план",
      "title": "План",
      "start": "Старт",
      "starting": "Запуск…",
      "programWeekSession": "Неделя {{week}}/{{cycle}} · {{session}}",
      "programLastCompleted": "Последняя: Н{{week}} · {{session}}",
      "programNextHeader": "Следующая",
      "programStartCta": "▶ Начать {{session}}",
      "programChangeLink": "Изменить неделю или сессию ›",
      "carouselPosition": "Программа {{n}} из {{total}}",
      "carouselPrev": "Предыдущая программа",
      "carouselNext": "Следующая программа",
      "programWeekLabel": "Неделя",
      "singleCycle": "Один цикл, каждая неделя одинаковая",
      "targetCoverage_one": "Покрывает <num>{{covered}}</num> из <num>{{count}}</num> цели",
      "targetCoverage_few": "Покрывает <num>{{covered}}</num> из <num>{{count}}</num> целей",
      "targetCoverage_many": "Покрывает <num>{{covered}}</num> из <num>{{count}}</num> целей",
      "targetCoverage_other": "Покрывает <num>{{covered}}</num> из <num>{{count}}</num> цели",
      "targetUncovered": "Не покрыты: {{muscles}}",
      "programSessionLabel": "Сессия",
      "programWeekShort": "Н{{n}}",
      "heatMoreWeeks": "Справа есть ещё недели: проведите по сетке в сторону.",
      "programDayShort": "Д{{n}}",
      "sessionN": "Сессия {{n}}",
      "sessionNShort": "С{{n}}",
      "programConfirm": "Старт Н{{week}} · {{session}}",
      "cancel": "Отмена",
      "newWorkout": "Новая тренировка",
      "programsHint": "Многонедельные циклы, которые автоматически продвигаются по мере записи тренировок.",
      "planDeleteTitle": "Удалить план?",
      "programDeleteTitle": "Удалить программу?",
      "programStatusError": "Не удалось обновить программу. Попробуйте снова.",
      "view": "Показать",
      "hide": "Скрыть",
      "programUnfollowHint": "Перестать следовать программе (останется в «Мои программы»)",
      "programNextInline": "Далее: Н{{week}} · {{session}}",
      "programStartA11y": "Начать {{session}}",
      "startPlanA11y": "Начать {{name}}"
    },
    "preview": {
      "muscles": "Мышцы",
      "noSets": "Подходы не заданы",
      "alternates": "Альтернативы: {{names}}",
      "gridTitle": "Интенсивность · день × неделя",
      "gridHint": "Коснитесь дня, чтобы увидеть упражнения.",
      "matrixTitle": "Интенсивность · по подходам",
      "matrixHint": "Коснитесь упражнения, чтобы увидеть подходы.",
      "intensity": {
        "work": "работа",
        "moderate": "умеренно",
        "heavy": "тяжело",
        "max": "Макс",
        "free": "свободно"
      }
    },
    "catalog": {
      "title": "Каталог",
      "search": "Поиск упражнений",
      "empty": "Нет подходящих упражнений.",
      "back": "Назад",
      "notFound": "Упражнение не найдено.",
      "metaPrimaryMuscle": "Основная мышца",
      "metaPattern": "Паттерн",
      "metaEquipment": "Оборудование",
      "metaP1RM": "Программируемое",
      "metaP1RMYes": "Да",
      "metaP1RMNo": "Нет",
      "metaDefaultBar": "Гриф по умолчанию",
      "metaBarLoading": "Загрузка",
      "metaBarLoadingSingleSide": "Только одна сторона",
      "aliasesLabel": "Также известно как",
      "tagsLabel": "Теги",
      "historyLabel": "Недавние тренировки",
      "historyEmpty": "Нет прошлых тренировок по этому упражнению.",
      "historyError": "Не удалось загрузить историю.",
      "historyBodyweight": "{{reps}} повт., свой вес",
      "recordsLabel": "Рекорды",
      "recordsEmpty": "Пока нет рекордов.",
      "selectPrompt": "Выберите упражнение, чтобы увидеть детали.",
      "recordsError": "Не удалось загрузить рекорды.",
      "refreshing": "Обновление…"
    },
    "maxes": {
      "title": "MAX",
      "back": "Назад",
      "search": "Поиск упражнений",
      "empty": "Нет подходящих упражнений.",
      "editCancel": "Отмена",
      "editSave": "Сохранить",
      "errInvalid": "Введите корректный вес.",
      "clearAction": "Убрать MAX",
      "clearTitle": "Убрать этот MAX?",
      "clearBody": "Значение и история сохранятся на сервере, но MAX будет считаться неустановленным.",
      "clearCancel": "Отмена",
      "clearConfirm": "Убрать",
      "selectPrompt": "Выберите упражнение, чтобы задать его MAX.",
      "unitChipLabel": "Единица веса: {{unit}}",
      "unitKg": "килограммы",
      "unitLb": "фунты",
      "unitChipHint": "Меняет единицу и пересчитывает значение",
      "notSet": "Не задан",
      "loadFailed": "Не удалось загрузить",
      "valueUnknown": "{{exercise}}, значение неизвестно",
      "saveFailed": "Не удалось сохранить. Повторите."
    },
    "login": {
      "title": "$t(brand.product)",
      "subtitle": "Войдите в свой аккаунт",
      "submit": "Войти"
    },
    "workouts": {
      "title": "Тренировки",
      "empty": "Тренировок пока нет.",
      "fallbackName": "Тренировка",
      "endOfList_one": "{{count}} тренировка, конец списка.",
      "endOfList_few": "{{count}} тренировки, конец списка.",
      "endOfList_many": "{{count}} тренировок, конец списка.",
      "endOfList_other": "{{count}} тренировок, конец списка.",
      "newButton": "Новая",
      "queueDismissCancel": "Отмена",
      "editUnsupportedTitle": "Редактирование пока недоступно на мобильном",
      "editUnsupportedBody": "Эта тренировка содержит типы упражнений (P1RM, переноска груза), которые мобильный логгер пока не редактирует. Откройте её в веб-приложении.",
      "editUnsupportedAck": "OK",
      "repeat": "Повторить тренировку",
      "resumePillAction": "Продолжить",
      "resumePillFallback": "Тренировка идёт",
      "cancel": "Отмена",
      "loadOlder": "Загрузить более ранние месяцы",
      "kindFilter": "Показать",
      "kindEmpty": "{{kind}}: нет тренировок на загруженных страницах",
      "kindAnnounce_one": "{{kind}}: загружена {{count}} тренировка",
      "kindAnnounce_few": "{{kind}}: загружено {{count}} тренировки",
      "kindAnnounce_many": "{{kind}}: загружено {{count}} тренировок",
      "kindAnnounce_other": "{{kind}}: загружено {{count}} тренировок",
      "selectPrompt": "Выберите тренировку, чтобы увидеть сводку.",
      "loadError": "Не удалось загрузить эту тренировку.",
      "importedBadge": "Импортировано",
      "dayN": "День {{n}}",
      "holdToSelect": "Удерживайте, чтобы выбрать",
      "createProgram": "Создать программу",
      "plan": "Запланировать",
      "planAgain": "Запланировать снова",
      "selectedCount_one": "Выбрана {{count}}",
      "selectedCount_few": "Выбрано {{count}}",
      "selectedCount_many": "Выбрано {{count}}",
      "selectedCount_other": "Выбрано {{count}}",
      "selectHintTooMany": "В программе не больше {{max}} дней.",
      "modeList": "Список",
      "modeCalendar": "Календарь",
      "selectA11y": "Выбрать тренировки",
      "selectDoneA11y": "Завершить выбор тренировок",
      "pickedEmpty": "В «{{name}}» нет упражнений для дня программы.",
      "pickedTitle": "Выбрано, в порядке дней",
      "pickedNoteOne": "Одна тренировка: «Запланировать» ставит её на день в календаре. Программа не создаётся.",
      "pickedNoteMany": "«Создать программу» создаёт по одному дню на каждую тренировку, в этом порядке.",
      "pickedDays_one": "{{count}} день, в выбранном порядке",
      "pickedDays_few": "{{count}} дня, в выбранном порядке",
      "pickedDays_many": "{{count}} дней, в выбранном порядке",
      "pickedDays_other": "{{count}} дня, в выбранном порядке",
      "pickedWrongOrder": "Не тот порядок? Отмените, снимите выбор и выберите заново.",
      "deletedSome_one": "Удалено {{done}} из {{count}} тренировки. Остальные остаются выбранными.",
      "deletedSome_few": "Удалено {{done}} из {{count}} тренировок. Остальные остаются выбранными.",
      "deletedSome_many": "Удалено {{done}} из {{count}} тренировок. Остальные остаются выбранными.",
      "deletedSome_other": "Удалено {{done}} из {{count}} тренировки. Остальные остаются выбранными.",
      "deletedNone_one": "Не удалось удалить эту тренировку. Она остаётся выбранной.",
      "deletedNone_few": "Не удалось удалить эти {{count}} тренировки. Они остаются выбранными.",
      "deletedNone_many": "Не удалось удалить эти {{count}} тренировок. Они остаются выбранными.",
      "deletedNone_other": "Не удалось удалить эти {{count}} тренировки. Они остаются выбранными."
    },
    "outboxDetail": {
      "errCorrectionTooBig": "Для сервера изменено слишком много подходов сразу.",
      "errCorrectionBusy": "Сервер был занят этой тренировкой.",
      "errCorrectionConflict": "Эта тренировка изменена на другом устройстве.",
      "errCorrectionStale": "Эта тренировка сохранена ещё раз после начала исправления.",
      "errCorrectionTimes": "Тренировка заканчивается раньше, чем начинается.",
      "errCorrectionGone": "Эта тренировка удалена на другом устройстве.",
      "errSetsUnknownExercise": "Сервер не распознал одно из упражнений этой тренировки.",
      "errSetsInvalidTag": "Сервер не принял тег у подхода в этой тренировке.",
      "errSetsInvalid": "Сервер счёл неверными некоторые подходы этой тренировки.",
      "errSetsNotSaved": "Не все подходы дошли до сервера.",
      "close": "Закрыть",
      "empty": "Отправлять больше нечего.",
      "statusQueued": "В очереди",
      "statusSending": "Отправка",
      "statusFailed4xx": "Сервер отклонил",
      "statusPermanentFail": "Остановлено",
      "attempts_one": "{{count}} попытка",
      "attempts_few": "{{count}} попытки",
      "attempts_many": "{{count}} попыток",
      "attempts_other": "{{count}} попыток",
      "dismissOne": "Отбросить",
      "dismissOneTitle": "Отбросить эту тренировку?",
      "dismissOneBody": "Тренировка от {{date}} будет удалена без сохранения.",
      "dismissCancel": "Отмена",
      "dismissConfirm": "Отбросить",
      "retryAll": "Повторить все",
      "queueWorkout": "Тренировка",
      "queueWorkoutNote": "Заметка к тренировке",
      "queueMeasurement": "Измерение",
      "queueMax": "Максимум",
      "queueProfile": "Профиль",
      "queueHealth": "Данные здоровья",
      "queueMetabolic": "Метаболические данные",
      "queueRequest": "Изменение",
      "stuckTitle": "Незавершённые записи"
    },
    "progress": {
      "title": "Прогресс",
      "windowAll": "Всего тренировок",
      "window30d": "Последние 30 дней",
      "window7d": "Последние 7 дней",
      "lastSession": "Последняя тренировка",
      "frequencyTitle": "Недельная частота",
      "rhythmThisWeek": "На этой неделе пока: {{n}}",
      "rhythmAverageWeeks_one": "В среднем за {{count}} полную неделю: {{avg}}",
      "rhythmAverageWeeks_few": "В среднем за {{count}} полные недели: {{avg}}",
      "rhythmAverageWeeks_many": "В среднем за {{count}} полных недель: {{avg}}",
      "rhythmAverageWeeks_other": "В среднем за {{count}} полной недели: {{avg}}",
      "rhythmKind": {
        "title": "Учитываемые тренировки",
        "strength": "Силовые",
        "cardio": "Кардио",
        "all": "Все",
        "announce": "{{kind}}: всего {{total}}, за последние 30 дней {{last30d}}"
      },
      "weekBars": {
        "thisWeek": "эта неделя на сегодня",
        "weekOf": "неделя с {{date}}",
        "sessions": "Тренировки"
      },
      "weekStreakCurrent": "Текущая серия",
      "weekStreakBest": "Лучшая серия",
      "weekStreakWeeks_one": "неделя",
      "weekStreakWeeks_few": "недели",
      "weekStreakWeeks_many": "недель",
      "weekStreakWeeks_other": "недели",
      "weekStreakStatA11y_one": "{{label}}: {{count}} неделя",
      "weekStreakStatA11y_few": "{{label}}: {{count}} недели",
      "weekStreakStatA11y_many": "{{label}}: {{count}} недель",
      "weekStreakStatA11y_other": "{{label}}: {{count}} недели",
      "weekStreakWithThisWeek_one": "{{count}} неделя подряд хотя бы с одной тренировкой, включая эту.",
      "weekStreakWithThisWeek_few": "{{count}} недели подряд хотя бы с одной тренировкой, включая эту.",
      "weekStreakWithThisWeek_many": "{{count}} недель подряд хотя бы с одной тренировкой, включая эту.",
      "weekStreakWithThisWeek_other": "{{count}} недели подряд хотя бы с одной тренировкой, включая эту.",
      "weekStreakUpToLastWeek_one": "{{count}} неделя подряд хотя бы с одной тренировкой, до прошлой недели. Эта неделя ещё не закончилась.",
      "weekStreakUpToLastWeek_few": "{{count}} недели подряд хотя бы с одной тренировкой, до прошлой недели. Эта неделя ещё не закончилась.",
      "weekStreakUpToLastWeek_many": "{{count}} недель подряд хотя бы с одной тренировкой, до прошлой недели. Эта неделя ещё не закончилась.",
      "weekStreakUpToLastWeek_other": "{{count}} недели подряд хотя бы с одной тренировкой, до прошлой недели. Эта неделя ещё не закончилась.",
      "weekStreakNone": "На прошлой неделе тренировок не было, на этой пока тоже. Эта неделя ещё не закончилась.",
      "weekStreakEmpty": "Тренировок пока нет.",
      "recordsTitle": "Рекорды",
      "recordsHelp": "Лучшие результаты для каждого числа повторений по упражнениям. Сначала свежие.",
      "recordsAllTime": "За всё время",
      "recordsThisYear": "{{year}}",
      "recordsSearch": "Фильтр по упражнению",
      "recordsNoMatch": "Под фильтр ничего не подходит.",
      "tagVolumeTitle": "Объём по тегам",
      "tagVolumeWeeksHelp": "Тренировочный объём одной мышцы по неделям. Выберите мышцу.",
      "recordsEmpty": "Пока нет рекордов. Запишите подходы с весом, чтобы заполнить список.",
      "chartE1rm": "Расчётный 1RM",
      "chartVolume": "Объём",
      "chartLoadFailed": "Не удалось загрузить график.",
      "chartEmpty": "Нет подходов с весом в недавнем окне.",
      "viewByExercise": "По упражнению",
      "viewByTag": "По тегу",
      "noTags": "Нет объёма ни по одной мышце за последние недели.",
      "chartMax": "МАКС (кг)",
      "chartEstimatedBadge": "наложение e1RM",
      "prFound": "Новый рекорд: {{weight}}",
      "prUpdating": "Обновление…",
      "painSeverity": {
        "red": "красный",
        "yellow": "жёлтый",
        "green": "зелёный"
      },
      "balance": {
        "title": "Баланс паттернов движений",
        "help": "Подходы и объём по каждому паттерну движения за {{days}} дн., отсортированные по числу подходов. Маленькое число «X/7д» считает последние 7 из этих дней. Оно показывает недавний рост или спад, который скрывает более длинное окно."
      },
      "empty": "Нет недавней активности для сравнения",
      "pain": {
        "title": "Боль × объём",
        "help": "Для каждой мышцы, отмеченной на вашей карте боли, показана недавняя тренировочная нагрузка. Красная точка = боль красного уровня (избегайте тяжёлых нагрузок), жёлтая = осторожно, зелёная = наблюдайте. Два числа объёма: нагрузка на эту мышцу за последние 7 дней и за всё окно в {{days}} дн. Самый рискованный сигнал на этой странице: устойчивая тяжёлая нагрузка на красную мышцу.",
        "noPain": "Нет мышц, отмеченных на вашей карте боли",
        "sevRed": "Избегать",
        "sevYellow": "Осторожно",
        "sevGreen": "Наблюдать"
      },
      "trends": {
        "a11yUp": "прогресс",
        "a11yFlat": "плато",
        "a11yDown": "регресс",
        "title": "Тренды e1RM",
        "help": "Для каждого паттерна движения (присед, становая тяга, жим, тяга, …) показано упражнение с наивысшим e1RM; учитываются только упражнения с читаемым трендом: минимум {{points}} точек на промежутке не менее {{spanDays}} дн. График: точки e1RM за {{days}} дн. (нажмите точку, чтобы увидеть значение и дату). Стрелка: тренд за эти дни: ↗ прогресс, → плато, ↘ регресс. Паттерн, который тренировался, но где ни одно упражнение не достигает этого порога, так и говорит, вместо того чтобы показать число. Упражнение, которое не тренировалось более {{freshDays}} дн., уступает свой паттерн текущему и остаётся за ним на графике.",
        "fewData": "Мало данных за {{days}} дн.",
        "noEligible": "Нет упражнений минимум с {{points}} точками за {{spanDays}} дней.",
        "notMeasurable": "Пока не измеримо: ни один подход {{name}} не дошёл до предела. Подход, доведённый почти до отказа (AMRAP), показал бы здесь силу.",
        "machineNotMeasurable": "{{value}}, пока не измеримо",
        "machineMore": "{{machine}} · +{{count}}",
        "machineA11y_one": "{{exercise}}, {{machine}}. Показать другой тренажёр.",
        "machineA11y_few": "{{exercise}}, {{machine}}. Показать ещё {{count}} тренажёра.",
        "machineA11y_many": "{{exercise}}, {{machine}}. Показать ещё {{count}} тренажёров.",
        "machineA11y_other": "{{exercise}}, {{machine}}. Показать ещё {{count}} тренажёра.",
        "machineSessions_one": "{{count}} тренировка",
        "machineSessions_few": "{{count}} тренировки",
        "machineSessions_many": "{{count}} тренировок",
        "machineSessions_other": "{{count}} тренировок",
        "compareCtaA11y": "Изменить упражнение для сравнения с {{pattern}}",
        "compareSeparator": "против",
        "compareClearA11y": "Убрать своё сравнение для {{pattern}} и вернуться к предложенному",
        "comparedManualA11y": "{{current}} в сравнении с {{name}}, ваш выбор",
        "comparedWithA11y": "{{current}} в сравнении с {{name}}, ранее занимавшее этот паттерн"
      },
      "rirAtLoad": {
        "rirTitle": "Повторов в запасе",
        "title": "Запас на одном и том же весе",
        "help": "То же упражнение, тот же вес, те же повторы: сколько повторов оставалось в запасе, неделя за неделей на протяжении {{weeks}} нед. Если столбцы падают, та же работа обходится дороже и накапливается усталость. Считаются только подходы с отмеченным усилием; неделя без них не имеет столбца, это не ноль.",
        "period": "{{weeks}} нед.",
        "empty_one": "Нужны то же упражнение, вес и повторы с отмеченным усилием в {{count}} неделе",
        "empty_few": "Нужны то же упражнение, вес и повторы с отмеченным усилием в {{count}} разных неделях",
        "empty_many": "Нужны то же упражнение, вес и повторы с отмеченным усилием в {{count}} разных неделях",
        "empty_other": "Нужны то же упражнение, вес и повторы с отмеченным усилием в {{count}} разных неделях",
        "readout": "{{rir}} RIR",
        "weekSets_one": "неделя с {{date}}, {{count}} подход",
        "weekSets_few": "неделя с {{date}}, среднее по {{count}} подходам",
        "weekSets_many": "неделя с {{date}}, среднее по {{count}} подходам",
        "weekSets_other": "неделя с {{date}}, среднее по {{count}} подхода",
        "skipped_one": "{{count}} неделя без данных",
        "skipped_few": "{{count}} недели без данных",
        "skipped_many": "{{count}} недель без данных",
        "skipped_other": "{{count}} недели без данных",
        "setLabel": "{{name}}: {{reps}} × {{load}}"
      },
      "repsAtLoad": {
        "a11yUp": "рост",
        "a11yFlat": "ровно",
        "a11yDown": "спад",
        "title": "Повторы при фиксированном весе",
        "help": "Для упражнений, где вы повторяете один и тот же вес, показывает, как меняются повторы при этом фиксированном весе за {{days}} дн.: прирост силы, который график e1RM не видит на многоповторной работе и тренажёрах. Столбцы: повторы при весе, по одному на тренировку (нажмите столбец, чтобы увидеть дату). Стрелка: тренд: ↗ рост, → ровно, ↘ спад. Учитываются только подходы с отмеченным усилием, поэтому больше повторов не может означать просто более лёгкий день.",
        "repsValue": "{{reps}} × {{load}}",
        "fewData": "Мало данных за {{days}} дн.",
        "notMeasurable": "Пока не измеримо: у ваших подходов {{name}} с весом {{load}} не отмечено усилие, поэтому больше повторов может означать просто более лёгкий день. Подход, доведённый почти до отказа, или отмеченное усилие, показал бы здесь вашу силу."
      },
      "period": {
        "all": "всё"
      },
      "loadFailed": "Не удалось загрузить",
      "loadOffline": "Нет сети: на устройстве пока нет данных",
      "density": {
        "title": "Плотность",
        "help": "Объём, делённый на длительность тренировки, кг/мин. Читается как «насколько плотной была тренировка»: рост означает ту же нагрузку за меньшее время (лучше выносливость) или большую нагрузку за то же время (лучше сила). Резкое падение без изменения программы часто говорит об усталости: отдых растянулся, даже если это не планировалось.",
        "empty": "Нужно от 3 тренировок с замером времени для графика плотности",
        "a11yUp": "рост",
        "a11yFlat": "ровно",
        "a11yDown": "спад"
      },
      "frequency": {
        "title": "Самые забытые упражнения",
        "help": "Топ-8 упражнений, отсортированных по числу дней с последнего выполнения, самые забытые первыми. Суффикс X/{{days}}д считает подходы за последние {{days}} дн. Долгий перерыв значит: либо упражнение убрали сознательно, либо программа сдвинулась. Полезно, чтобы заметить вспомогательную работу, которая тихо исчезла."
      },
      "intensityHeatmap": {
        "title": "Тепловая карта интенсивности",
        "help": "Сетка выполненных подходов по упражнениям, отсортированная по диапазону повторений и интенсивности (% от 1RM). Силовой диапазон (85%+) в правом нижнем углу, гипертрофия в центре, выносливость в левом верхнем. Выберите упражнение выше, чтобы увидеть, где сосредоточены его подходы.",
        "exerciseLabel": "Упражнение",
        "choosePrompt": "Выберите упражнение",
        "noEligible": "Зафиксируйте 1RM хотя бы для одного упражнения, чтобы рассчитать интенсивность.",
        "noMax": "Для этого упражнения 1RM ещё не записан.",
        "totalSets": "{{n}} подх. · 1RM {{max}}",
        "clear": "Нет"
      },
      "prTimeline": {
        "title": "Хронология рекордов",
        "help": "Максимумы во времени, сначала новые. «Проверено» значит подтверждённый рекорд в одном повторении, любая другая метка это стартовая оценка, а не проверенный максимум.",
        "empty": "Максимумы ещё не записаны.",
        "rowA11y": "{{name}}, {{value}}, {{date}}, {{source}}",
        "truncated_one": "Показаны последние {{cap}} из {{count}} MAX",
        "truncated_few": "Показаны последние {{cap}} из {{count}} максимумов",
        "truncated_many": "Показаны последние {{cap}} из {{count}} максимумов",
        "truncated_other": "Показаны последние {{cap}} из {{count}} максимума",
        "source": {
          "manual": "Вручную",
          "tested": "Проверено",
          "derived": "Получено",
          "calculated_seed": "Начальное значение",
          "imported": "Импортировано",
          "unknown": "Неизвестно"
        },
        "helpPeriod": "Максимумы, установленные в этот период, сначала новые. «Проверено» значит подтверждённый рекорд в одном повторении, любая другая метка это стартовая оценка, а не проверенный максимум.",
        "emptyPeriod": "В этот период максимумы не устанавливались."
      },
      "a11y": {
        "severityAlarm": "Тревога",
        "severityWarn": "Предупреждение",
        "severityInfo": "Инфо"
      },
      "tracker": {
        "title": "Отслеживание упражнений",
        "help": "Следите за динамикой до {{max}} упражнений. Каждый график показывает выбранные показатели как изменение с первой тренировки периода, поэтому килограммы и повторения делят одну ось. Нажмите на точку, чтобы увидеть реальные значения этой тренировки.",
        "rangeTitle": "Период",
        "statsTitle": "Показатели",
        "stat": {
          "e1rm": "e1RM",
          "topWeight": "Топ-подход",
          "volume": "Объём",
          "topReps": "Повторы топ-подхода"
        },
        "range": {
          "30d": "30д",
          "12w": "12нед",
          "6m": "6мес",
          "12m": "12мес"
        },
        "rangeA11y": {
          "30d": "Последние 30 дней",
          "12w": "Последние 12 недель",
          "6m": "Последние 6 месяцев",
          "12m": "Последние 12 месяцев"
        },
        "noStats": "Выберите хотя бы один показатель.",
        "nothing": "Запишите упражнение с отягощением, чтобы следить за ним здесь.",
        "noData": "Нет тренировок за этот период.",
        "noStatData": "Ни один из выбранных показателей не записан для этого упражнения за этот период.",
        "remove": "Больше не отслеживать {{name}}",
        "full": "Не больше {{max}} упражнений.",
        "add": "Добавить упражнение",
        "premiumHint": "Другие периоды, показатели и больше упражнений доступны в Премиум.",
        "saveError": "Не удалось сохранить выбор. Попробуйте ещё раз.",
        "axis": "Каждая кривая показывает изменение с её первой тренировки периода.",
        "statValue": "{{stat}} {{value}}",
        "onMachine": "{{exercise}} · {{machine}}",
        "lineEntry": "{{line}}: {{stat}}",
        "line": {
          "solid": "сплошная линия",
          "dashed": "штриховая линия",
          "dotted": "пунктирная линия",
          "dashDot": "штрихпунктирная линия"
        },
        "change": "{{value}}%"
      },
      "config": {
        "title": "Настроить прогресс",
        "open": "Настроить прогресс",
        "saveError": "Не удалось сохранить расположение блоков прогресса. Попробуйте ещё раз.",
        "widget": {
          "rhythm": "Ритм тренировок",
          "prTimeline": "Хронология рекордов",
          "weekStreak": "Серия без пропусков"
        }
      },
      "coverageRefreshing": "Обновление…",
      "report": {
        "open": "Создать отчёт",
        "title": "Отчёт о тренировках",
        "titleOf": "Отчёт о тренировках: {{name}}",
        "period": "с {{from}} по {{to}}",
        "from": "С",
        "to": "По",
        "pickA11y": "{{label}}: {{value}}. Изменить дату",
        "periodHint": "Любой период до {{days}} дн., в том числе в прошлом.",
        "chooseSections": "Выбрать разделы",
        "shareImage": "Поделиться картинкой",
        "advanced": "Расширенный отчёт",
        "pdfExport": "Экспорт в PDF",
        "comparePeriods": "Сравнить два периода",
        "sectionsTitle": "Разделы отчёта",
        "advancedSections": "Расширенные разделы",
        "noSections": "Разделы не выбраны. Выберите разделы, чтобы увидеть отчёт.",
        "sessions": "Тренировок за период",
        "frequencyHelp": "Тренировки в неделю за период.",
        "premiumHint": "Опции Премиум не входят в базовый отчёт.",
        "shareNeedsSection": "Выберите хотя бы один раздел, чтобы поделиться отчётом.",
        "pagesTruncated": "Общий отчёт ограничен {{max}} изображениями. Выберите меньше разделов, чтобы поделиться остальным.",
        "preparing": "Подготовка изображения {{page}}…",
        "pagesReady": "Изображения готовы к отправке.",
        "adjustedToday": "Отчёт заканчивается не позже сегодняшнего дня: дата перенесена на сегодня.",
        "adjustedOther": "Другая дата сдвинулась, чтобы сохранить порядок дат.",
        "adjustedCapped": "Отчёт охватывает не более {{days}} дн.: другая дата сдвинулась.",
        "emptyPeriod": "За этот период тренировок нет."
      },
      "coverageNotConfirmed": "Не удалось обновить. Показаны последние сохранённые данные."
    },
    "profile": {
      "title": "Профиль",
      "navMaxes": "MAX",
      "navMaxesSub": "Устанавливайте, изменяйте и просматривайте свои MAX по упражнениям.",
      "navCatalogSub": "Просмотр упражнений, рекордов и истории.",
      "navRestTimer": "Таймеры",
      "navRestTimerSub": "Отдых + удержание по умолчанию, звук, по упражнению",
      "labelEmail": "EMAIL",
      "labelApp": "ВЕРСИЯ ПРИЛОЖЕНИЯ",
      "labelBackend": "ВЕРСИЯ БЭКЕНДА",
      "labelPrivacy": "КОНФИДЕНЦИАЛЬНОСТЬ",
      "privacyHelp": "Экспортируйте всё в JSON, отзовите заявление о возрасте или удалите аккаунт навсегда.",
      "legalLinkHint": "Откроется в браузере",
      "exportButton": "Экспорт моих данных",
      "deleteButton": "Удалить мой аккаунт",
      "deleteAlertTitle": "Удалить аккаунт",
      "deleteAlertBody": "Ваш аккаунт, тренировки, планы, программы и максимумы будут удалены навсегда. Удаление необратимо.",
      "deleteAlertCancel": "Отмена",
      "deleteAlertConfirm": "Удалить",
      "signOut": "Выйти",
      "exportShareTitle": "Экспорт $t(brand.product) {{date}}",
      "labelLanguage": "Язык",
      "languageHelp": "Выберите язык приложения. Сохраняется на этом устройстве.",
      "languageCancel": "Закрыть"
    },
    "timeline": {
      "setNumber": "Подход {{n}}",
      "fail": "Не выполнен",
      "failTip": "«Не выполнен» записывает подход как попытку без завершения. Он всё равно считается выполненным (запускается таймер отдыха), показывает ✕ в ленте и не учитывается в вашем e1RM.",
      "failTipA11y": "Что значит «Не выполнен»?",
      "e1rmValue": "e1RM {{value}}",
      "e1rmPctOfBest": "{{pct}}% от лучшего",
      "e1rmNewBest": "рекорд",
      "e1rmLegend": "e1RM",
      "setVolume": "Σ {{value}} {{unit}}",
      "myorepTag": "Миореп",
      "dropsetTag": "Дроп",
      "myorepA11y": "Миореп-подход",
      "dropsetA11y": "Дропсет",
      "setVolumeA11y": "Объём подхода {{value}} {{unit}}",
      "noBodyweight": "Вес тела пока не указан",
      "approachBadge": "Разминка",
      "approachBadgeA11y": "разминочный подход, не засчитывается как рабочий",
      "setSummaryBothSidesA11y": "{{reps}} повторений по {{weight}} {{unit}} на сторону, учтены обе стороны",
      "e1rmLegendA11y": "Что такое e1RM?",
      "e1rmTip": "e1RM: расчётный максимум на 1 повтор для подхода (Эпли, повторы ≤ 12). «% от лучшего» сравнивает его с вашим лучшим e1RM за всё время: ниже: есть запас, чтобы прибавить; ↑ рекорд: новый расчётный максимум.",
      "durationLabel": "Длительность",
      "hourShort": "ч",
      "minShort": "мин",
      "secShort": "сек",
      "started": "Тренировка начата",
      "addSet": "Добавить подход",
      "insertSetBefore": "Вставить подход перед подходом {{n}}",
      "removeSet": "Убрать подход",
      "prevSet": "Предыдущий подход",
      "nextSet": "Следующий подход",
      "allLogged": "Все подходы записаны. Нажмите +, чтобы добавить ещё.",
      "rosterLabel": "Упражнения",
      "rosterHint": "нажмите для переключения",
      "focusEmptyHasRoster": "Выберите упражнение выше, чтобы начать, или добавьте новое.",
      "focusAllLogged": "Все подходы записаны. Добавьте упражнение выше или сохраните ниже.",
      "cueNextSet": "→ Подход {{n}}/{{total}}",
      "cueNextExercise": "→ {{name}}",
      "rosterExpandA11y": "Развернуть список упражнений",
      "rosterCollapseA11y": "Свернуть список упражнений",
      "rosterState": {
        "done": "готово",
        "inProgress": "в процессе",
        "notDone": "не начато"
      },
      "rosterOccurrenceA11y": "{{label}} ({{index}} из {{count}})",
      "exerciseNote": "Заметка к упражнению",
      "notePlaceholder": "Добавить заметку в ленту…",
      "noteSend": "Отправить заметку",
      "noteExpandA11y": "Заметка: нажмите, чтобы прочитать полностью",
      "noteDeleteA11y": "Удалить заметку",
      "uncompleteSetA11y": "Отметить подход {{n}} ({{exercise}}) как невыполненный",
      "dropsetActive": "Дропсет: измените шаги ниже.",
      "editingLogged": "Редактирование записанного подхода {{n}}. Изменения сохранятся вместе с тренировкой.",
      "addSetLocked": "Редактирование прошлой тренировки: нельзя добавлять подходы. Исправьте значения или удалите подход.",
      "setRowA11y": "Подход {{n}}: {{exercise}}",
      "refreshingA11y": "Обновление",
      "createGroupLocked": "Редактирование прошлой тренировки: нельзя создать суперсет.",
      "splitGroupLocked": "Редактирование прошлой тренировки: нельзя расформировать суперсет.",
      "setTypeLocked": "Редактирование прошлой тренировки: нельзя изменить тип подхода (дропсет/миореп).",
      "addStepLocked": "Редактирование прошлой тренировки: нельзя добавить шаг дропсета.",
      "setState": {
        "pending": "Подход {{n}} из {{total}}, не выполнен",
        "done": "Подход {{n}} из {{total}}, выполнен",
        "pr": "Подход {{n}} из {{total}}, личный рекорд",
        "failed": "Подход {{n}} из {{total}}, срыв"
      },
      "holdLabel": "Удержание"
    },
    "summary": {
      "prBadge": "личный рекорд"
    },
    "logger": {
      "autoName": {
        "region_lower": "Ноги",
        "title": "{{label}} -⁠ {{date}}",
        "pair": "{{a}} & {{b}}",
        "upper": "Верх",
        "lower": "Низ",
        "fullBody": "Всё тело",
        "deload": "Разгрузка",
        "mobility": "Мобильность",
        "cardio": "Кардио"
      },
      "title": "Новая тренировка",
      "cancel": "Отмена",
      "swapKindTitle": "Сменить тип упражнения?",
      "swapKindBody": "Это упражнение записывается иначе, поэтому уже внесённые здесь подходы будут удалены.",
      "swapKindConfirm": "Сменить и очистить",
      "failConfirmTitle": "Чистые повторы",
      "failConfirmBody_one": "Сохраняю {{count}} чистый повтор. Сорванный не считается.",
      "failConfirmBody_few": "Сохраняю {{count}} чистых повтора. Сорванный не считается.",
      "failConfirmBody_many": "Сохраняю {{count}} чистых повторов. Сорванный не считается.",
      "failConfirmBody_other": "Сохраняю {{count}} чистых повторов. Сорванный не считается.",
      "failConfirmHint": "Поправьте, если сделали больше или меньше.",
      "failConfirmStepDown": "На один чистый повтор меньше",
      "failConfirmStepUp": "На один чистый повтор больше",
      "failConfirmSave": "Сохранить",
      "amrapNeedsReps": "Введите число повторений, чтобы записать подход.",
      "amrapBadgeWithFloor": "AMRAP ≥ {{reps}}",
      "amrapPrescribedFloorA11y": "AMRAP: минимум {{reps}} повторений, затем как можно больше",
      "amrapFloorPlaceholder": "≥ {{reps}}",
      "amrapTestFromTestedMax": "Тест AMRAP: {{load}}, {{pct}}% от проверенного 1RM ({{max}}). Минимум {{floor}} повторений. Нажмите AMRAP для отмены.",
      "amrapTestFromMax": "Тест AMRAP: {{load}}, {{pct}}% от вашего MAX ({{max}}). Минимум {{floor}} повторений. Нажмите AMRAP для отмены.",
      "amrapTestFromLastSet": "Тест AMRAP: {{load}}, {{pct}}% от 1RM последнего подхода ({{max}}). Минимум {{floor}} повторений. Нажмите AMRAP для отмены.",
      "amrapTestNoLoadBodyweight": "AMRAP: максимум повторений. С собственным весом нагрузка остаётся как есть. Нажмите AMRAP ещё раз, чтобы отменить.",
      "amrapTestNoLoadNoBasis": "AMRAP: максимум повторений. Нет ни MAX, ни недавнего подхода для расчёта веса. Нажмите AMRAP для отмены.",
      "amrapTestNoLoadKept": "AMRAP: максимум повторений. Этот подход сохраняет свой вес. Нажмите AMRAP ещё раз, чтобы отменить.",
      "amrapTestRestored": "AMRAP выключен: прежние значения вернулись.",
      "failBadge": "Срыв",
      "failBadgeA11y": "неудачный подход",
      "save": "Сохранить",
      "remove": "Убрать",
      "replace": "Заменить",
      "addExercise": "Добавить упражнение",
      "addSet": "Добавить подход",
      "addRound": "Добавить круг",
      "pickerTitle": "Выбрать упражнение",
      "pickerSearch": "Поиск упражнений",
      "pickerResultsN_one": "{{count}} результат",
      "pickerResultsN_few": "{{count}} результата",
      "pickerResultsN_many": "{{count}} результатов",
      "pickerResultsN_other": "{{count}} результата",
      "pickerEmpty": "Упражнения не найдены.",
      "pickerClearFilters": "Очистить фильтры",
      "pickerFilters": "Фильтры",
      "pickerFiltersN": "Фильтры ({{n}})",
      "empty": "Упражнений нет. Добавьте, чтобы начать.",
      "setReps": "ПОВТ",
      "setPercentOfMax": "%",
      "prescribedLoadTip": "Нагрузка, которую вы задаёте, в единицах программы: килограммы или % от максимума. Выбор чуть ниже.",
      "setPercentOfMaxA11y": "Процент от максимума",
      "stepAdd": "Увеличить",
      "stepSubtract": "Уменьшить",
      "amrapChipPrescribe": "Задать максимум повторений",
      "tipAmrapPrescribe": "Просит атлета сделать максимум повторений в этом подходе. Число повторений остаётся минимумом.",
      "entryNoteEdit": "Изменить заметку упражнения",
      "entryNoteAdd": "＋ Заметка упражнения",
      "setWeightBothSidesA11y": "Вес одной стороны, учтены обе стороны ({{unit}})",
      "setTypeWorking": "Рабочий",
      "setTypeDropset": "Дропсет",
      "setTypeMyorep": "Мио-повтор",
      "setCommentLabel": "Комментарий к подходу",
      "unitLabel": "Единица",
      "discardTitle": "Отменить тренировку?",
      "discardBody": "Введённые подходы будут потеряны.",
      "discardCancel": "Продолжить",
      "discardConfirm": "Удалить",
      "discardEditTitle": "Отменить изменения?",
      "discardEditBody": "Сохранённая тренировка останется прежней.",
      "discardEditCancel": "Продолжить редактирование",
      "errNoEntries": "Добавьте хотя бы одно упражнение.",
      "errNoSets": "У каждого упражнения должен быть хотя бы один подход с повторениями и весом.",
      "errZeroWorkSet": "В одном подходе 0 повторений и нет веса. Укажите их или удалите подход.",
      "errInvalid": "Тренировку нельзя сохранить в таком виде.",
      "errSaveFailed": "Сохранение не удалось. Тренировка на месте: нажмите «Сохранить» ещё раз.",
      "errNotSignedIn": "Вход не выполнен. Тренировка остаётся здесь: сохраните её после повторного входа.",
      "errSetsUnknownExercise": "Одно из упражнений этой тренировки не распознано. Замените его и сохраните ещё раз.",
      "errSetsInvalidTag": "Тег у одного подхода не принят. Уберите его и сохраните ещё раз.",
      "errSetsInvalid": "Некоторые подходы заполнены неверно. Проверьте вес и повторения, затем сохраните ещё раз.",
      "errSetsNotSaved": "Некоторые подходы не дошли до сервера. Попробуйте сохранить ещё раз.",
      "errCorrectionTooBig": "Слишком много подходов изменено сразу. Сохраните меньше изменений, затем остальное.",
      "errCorrectionBusy": "Тренировка сейчас обрабатывается. Подождите немного и сохраните снова.",
      "errCorrectionConflict": "Тренировку изменили на другом устройстве. Закройте её, откройте снова и исправьте ещё раз.",
      "errCorrectionStale": "Тренировку сохранили ещё раз после того, как вы её открыли. Закройте её, откройте снова и исправьте ещё раз.",
      "errCorrectionTimes": "Тренировка заканчивается раньше, чем начинается. Проверьте начало и конец, затем сохраните.",
      "errCorrectionImport": "Эта тренировка пришла из Health Connect, здесь её не исправить. Исправьте её в Health Connect.",
      "errCorrectionGone": "Эту тренировку удалили на другом устройстве. Исправление не потеряно: найдите его вверху раздела «Тренировки» и нажмите «Сохранить как новую».",
      "errCorrectionGoneHere": "Эту тренировку удалили на другом устройстве. Исправление не потеряно: нажмите «Сохранить как новую», чтобы оставить его как новую тренировку.",
      "correctionToBell": "Предыдущее исправление этой тренировки отклонено, и это исправление добавлено к нему. Оно не потеряно: найдите его вверху раздела «Тренировки» и нажмите «Сохранить как новую».",
      "setNumberHeader": "ПОДХОД",
      "removeSetA11y": "Удалить этот подход",
      "serverErrorTitle": "СЕРВЕР ОТКЛОНИЛ СОХРАНЕНИЕ",
      "serverErrorHint": "Поправьте тренировку и попробуйте снова. Если сообщение непонятно, перешлите его тренеру.",
      "setExtra": "ДОП",
      "setWeightTip": "Вес за подход. Переключайте кг/фунты чипом единиц в каждой строке.",
      "setExtraTip": "Помощь или добавленный вес для упражнений с собственным весом. Нажмите «С помощью» для помощи резиной/тренажёром (в поле появится − и оно станет янтарным); пояс/блин дают положительное значение.",
      "setExtraAssistA11y": "Дополнительно, помощь при весе собственного тела",
      "setExtraAssisted": "С помощью",
      "setWeightMixedTip": "Смешанная группа: вес штанги/стека в силовых строках, ± добавка в строках с собственным весом (минус = помощь).",
      "editTitle": "Изменить тренировку",
      "planTitle": "План",
      "programTitle": "Программа",
      "repeatTitle": "Повторить тренировку",
      "minimize": "Свернуть тренировку",
      "closeWorkout": "Закрыть тренировку",
      "saveWorkout": "Сохранить тренировку",
      "bilateral": "Билатерально",
      "unilateral": "Унилатерально",
      "plates": "Блины",
      "numInvalid": "Неверное число",
      "numRange": "{{label}} {{min}}–{{max}}",
      "setRpeHint": "Усилие 1–10",
      "setNoteLabel": "Заметка",
      "setNotePlaceholder": "Подсказка, техника, ощущения…",
      "totalsSets_one": "{{count}} подход",
      "totalsSets_few": "{{count}} подхода",
      "totalsSets_many": "{{count}} подходов",
      "totalsSets_other": "{{count}} подходов",
      "totalsReps_one": "{{count}} повтор",
      "totalsReps_few": "{{count}} повтора",
      "totalsReps_many": "{{count}} повторов",
      "totalsReps_other": "{{count}} повторов",
      "totalsTitle": "Итоги тренировки",
      "totalsVolume": "Объём",
      "totalsSetsShort": "Подходы",
      "totalsRepsShort": "Повторы",
      "totalsByMuscle": "Нагрузка по мышцам",
      "restRest": "Отдых",
      "startRestManual": "Запустить отдых",
      "restSkip": "Пропустить",
      "restWord": "Отдых",
      "restAddStep": "+{{n}} секунд",
      "restSubtractStep": "−{{n}} секунд",
      "restStartedA11y": "Отдых начался, {{time}}.",
      "restEndedA11y": "Отдых окончен.",
      "restInviteLabel": "Отдохнуть подольше?",
      "restInviteAdd": "+{{time}}",
      "restInviteAddA11y": "Добавить {{time}} к отдыху",
      "restInviteA11y": "Отдохнуть подольше? Можно добавить {{time}}.",
      "setsCarriedOverA11y": "Подходы перенесены с прошлого раза.",
      "restInviteTipTitle": "Зачем отдыхать дольше?",
      "restInviteTipBody": "Этот подход закончился отказом или почти отказом. В исследованиях более долгий отдых после таких подходов сохранял больше силы для следующего: около 3 мин, до 5 с большими весами. Сколько отдыхать, решаете вы.",
      "loadBarA11y": "Управление весом",
      "restBarA11y": "Таймер отдыха",
      "restRemainingA11y": "осталось отдыха: {{time}}",
      "restEditA11y": "Задать отдых по умолчанию для этого упражнения",
      "restRestoreLearnedA11y": "Вернуть отдых по умолчанию (сейчас {{time}})",
      "restEditTitle": "Отдых по умолчанию",
      "restEditBody": "Сохранить этот отдых как стандартный для {{name}}",
      "restEditSave": "Сохранить",
      "restEditSaving": "Сохранение…",
      "restEditError": "Не удалось сохранить отдых по умолчанию. Попробуйте снова.",
      "restEditCancel": "Отмена",
      "restEditSaveAsGlobal": "Использовать как глобальный стандарт",
      "restStepMinus": "Уменьшить на {{step}} секунд",
      "restStepPlus": "Увеличить на {{step}} секунд",
      "restPause": "Пауза",
      "restResume": "Продолжить",
      "restExpiredTitle": "Отдых окончен",
      "holdExpiredTitle": "Время вышло",
      "restExpiredBody": "Пора к следующему подходу.",
      "holdExpiredBody": "Коснитесь шкалы усилия, чтобы записать подход.",
      "boutExpiredTitle": "Интервал завершён",
      "boutExpiredBody": "Подход записан автоматически.",
      "workStartedTitle": "Начали",
      "cueLeadInWork": "Работа: {{n}} с",
      "cueLeadInRest": "Отдых: {{n}} с",
      "cueChannel": {
        "tick": "Сигналы отсчёта",
        "work": "Начало работы"
      },
      "boutAutoLoggedA11y": "Интервал завершён, записано {{time}}.",
      "workoutFgsTitle": "Тренировка идёт",
      "workoutFgsBodyNamed": "{{name}} · нажмите, чтобы продолжить",
      "workoutFgsBody": "Нажмите, чтобы продолжить тренировку",
      "idleAskTitle": "Вы ещё тренируетесь?",
      "idleAskBody": "Если не ответить в течение 15 минут, тренировка сохранится и закроется.",
      "idleContinue": "Продолжить",
      "idleSaveClose": "Сохранить",
      "descriptionToggle": "Показать / скрыть описание",
      "notesToggle": "Заметки к этой тренировке",
      "infoButton": "Инфо",
      "notesEmpty": "Нет заметок к этой тренировке",
      "notesProgramLabel": "Программа",
      "notesWorkoutLabel": "Эта тренировка",
      "note": "Заметка",
      "rpeChip": "RPE",
      "historyChip": "История",
      "more": "Другие действия",
      "addGroup": "Создать суперсет с другим упражнением",
      "cardioDuration": "Длительность",
      "cardioDurationPlaceholder": "Секунды",
      "cardioDistance": "Дистанция",
      "cardioWeight": "Вес",
      "cardioHr": "ЧСС ср.",
      "cardioCalories": "Калории",
      "cardioOptionalsShow": "Показать другие поля",
      "cardioOptionalsHide": "Скрыть другие поля",
      "dateEditor": "Дата и длительность",
      "dateLabel": "Дата",
      "startTimeLabel": "Начало",
      "endTimeLabel": "Конец",
      "durationLabel": "Длительность",
      "historyToggle": "История",
      "historyBest": "Лучшая",
      "historyCopy": "Копировать",
      "historyBodyweight": "{{reps}} повт. с весом тела",
      "historyEstimateHeader": "Оценка по похожему упражнению",
      "historyEstimatedFrom": "Из {{name}}",
      "historyNoEstimate": "Истории пока нет, и нет похожего упражнения для оценки.",
      "copyDialogTitle": "Копировать тренировку",
      "copyDialogBody": "Заменить незавершённые подходы или добавить к существующим?",
      "copyOverwrite": "Заменить",
      "copyAppend": "Добавить",
      "resumeDiscard": "Удалить",
      "conflictTitle": "Тренировка продолжается",
      "conflictBody": "Вы уже записываете тренировку. Продолжите её или откройте, чтобы сохранить или отменить.",
      "nameLabel": "Название тренировки",
      "namePlaceholder": "Название: напр. Push…",
      "editNameA11y": "Изменить название тренировки",
      "setStateA11y": "подход {{index}} {{state}}",
      "rpePlaceholder": "RPE",
      "unitA11y": "единица {{unit}}",
      "stepperPositive": "плюс",
      "stepperNegative": "минус",
      "rirPlaceholder": "RIR",
      "effortMeterEasy": "Легко",
      "effortMeterHard": "Тяжело",
      "effortWord": "Усилие",
      "holdSlotDone": "ГОТОВО",
      "holdSlotHeld": "УДЕРЖАНО",
      "holdSlotDoneA11y": "{{time}} выполнено",
      "holdSlotFailedA11y": "{{time}}, не выполнено",
      "holdSlotHeldA11y": "{{time}} удержано",
      "effortMeterFail": "Отказ",
      "effortMeterTargetWord": "цель",
      "effortQuestionRir": "Повторов в запасе?",
      "effortQuestionRpe": "Насколько тяжело?",
      "effortQuestionHint": "Открывает шкалу усилия: как она устроена и как её сменить",
      "effortMeterHintLog": "Также записывает подход как выполненный",
      "effortMeterHintRunning": "Остановит таймер и запишет подход",
      "effortMeterHintEdit": "Обновляет усилие этого записанного подхода",
      "effortMeterFailHintLog": "Записывает подход как невыполненный",
      "effortMeterFailHintEdit": "Переключает подход между выполненным и невыполненным",
      "effortMeterTapCta": "Нажмите для записи",
      "effortMeterStopCta": "Нажмите, чтобы остановить и записать",
      "effortNudgeOptOut": "Отключить напоминание",
      "effortNudgeOptOutHint": "Сначала спросит подтверждение. Снова включить можно в настройках.",
      "effortNudgeOptOutConfirmTitle": "Отключить это напоминание?",
      "effortNudgeOptOutConfirmBody": "Включить снова можно в любой момент в настройках.",
      "effortNudgeOptOutConfirmButton": "Отключить",
      "amrapChip": "Максимум повторений",
      "burnPlus": "Burn+",
      "burnPlusChip": "Техника интенсивности Burn+ (дропсет / мио-повтор)",
      "loadAxisTitle": "Что определяет нагрузку",
      "loadAxisNone": "Без интенсивности",
      "timedChip": "На время",
      "noteChip": "Заметка",
      "noteClose": "Готово",
      "effortLegendA11y": "Справка по шкале усилия",
      "rirLegendTitle": "RIR: повторений в запасе",
      "rirLegendBody": "0 = нет повторов в запасе\n1 = 1 повтор в запасе\n2 = 2 повтора\n3 = хороший запас, всё ещё рабочий подход\n4–5 = лёгкая работа, не засчитывается\n6+ = разминка",
      "rpeLegendTitle": "RPE: воспринимаемое усилие",
      "rpeLegendBody": "10 = нет повторов в запасе\n9 = 1 повтор в запасе\n8 = 2 повтора\n7 = хороший запас, всё ещё рабочий подход\n5–6 = лёгкая работа, не засчитывается\n4 и меньше = разминка",
      "timerStartCountdown": "Запустить обратный отсчёт",
      "timerStartCountup": "Запустить секундомер",
      "timerSettings": "Настройки таймера для этого упражнения",
      "holdHeaderHours": "ч",
      "holdHeaderMinutes": "мин",
      "holdHeaderSeconds": "с",
      "holdHours": "Часы",
      "holdMinutes": "Минуты",
      "holdSeconds": "Секунды",
      "holdSubTen": "-10 с",
      "holdAddTen": "+10 с",
      "holdCancel": "Отмена",
      "holdClockElapsedA11y": "прошло {{time}}",
      "holdClockOvertimeA11y": "{{time}} сверх цели",
      "pausedReadoutA11y": "{{label}}, на паузе",
      "holdClockRemainingA11y": "осталось {{time}}",
      "holdFlip": "Сменить направление",
      "holdExtraWeight": "Доп.",
      "lateralityTipUni": "UNI · запишите одну сторону; объём считается ×2.",
      "lateralityTipBi": "BI · билатеральная нагрузка; объём считается ×1.",
      "tabExercises": "Упражнения",
      "tabSuperset": "Суперсет",
      "pickerAddN": "Добавить {{n}}",
      "pickerAlreadyInWorkout": "Уже в этой тренировке",
      "pickerAlreadyInBlock": "Уже в этом блоке",
      "pickerPin": "В избранное",
      "pickerUnpin": "Убрать из избранного",
      "noteReadA11y": "Заметка к упражнению: нажмите, чтобы прочитать целиком",
      "prescriptionReadA11y": "Указание к подходу: нажмите, чтобы прочитать целиком",
      "tipAmrap": "AMRAP: этот подход становится тестом, до последнего возможного повторения. В обычном подходе предлагается тестовый вес; нажмите ещё раз, чтобы отменить.",
      "tipBurnPlus": "Техники интенсивности: откройте Dropset или Myo-rep, чтобы продлить подход за пределы отказа.",
      "targetEyebrow": "Цель",
      "historySetCount": "последние {{n}} подх.",
      "historyBlinkToggle": "Мигать, если упражнение долго не выполнялось",
      "historyCopyLast": "Скопировать последнюю тренировку",
      "historyLooking": "Ищу это упражнение…",
      "historyUnavailable": "Сейчас не удаётся получить историю. Это не значит, что её нет.",
      "historyBlinkOn": "Мигание вкл.",
      "historyBlinkOff": "Мигание выкл.",
      "historyToggleAged": "История, в последний раз {{age}}",
      "maxEditNoneA11y": "Задать свой максимум для этого упражнения",
      "maxEditA11y": "Изменить свой максимум",
      "maxEditStaleA11y": "Изменить свой максимум, в последний раз {{age}}",
      "maxEditEstimatedA11y": "Изменить свой максимум, он оценён и ни разу не измерялся",
      "maxHeaderNone": "Пока нет MAX",
      "maxHeaderValue": "MAX {{weight}}",
      "maxHeaderStale": "MAX {{weight}} · {{age}}",
      "maxHeaderEstimated": "MAX {{weight}} · оценочно",
      "proposedWeightTipTestedMax": "Предложено, чтобы этот подход вышел на {{effort}}, рассчитано от протестированного 1RM. Это отправная точка, а не предписание: меняйте.",
      "proposedWeightTipMax": "Предложено, чтобы этот подход вышел на {{effort}}, рассчитано от записанного максимума. Это отправная точка, а не предписание: меняйте.",
      "proposedWeightTipHistory": "Предложено, чтобы этот подход вышел на {{effort}}, рассчитано от вашего последнего подхода в этом упражнении. Это отправная точка, а не предписание: меняйте.",
      "proposedWeightTipHistoryFallback": "Последний использованный вес: по вашему последнему подходу нельзя оценить максимум. Это отправная точка, а не предписание: измените его.",
      "historySectionComputed": "Откуда этот вес",
      "historyProposalSource_one": "Из {{count}} последней тренировки: {{name}}",
      "historyProposalSource_few": "Из {{count}} последних тренировок: {{name}}",
      "historyProposalSource_many": "Из {{count}} последних тренировок: {{name}}",
      "historyProposalSource_other": "Из {{count}} последних тренировок: {{name}}",
      "historyProposalAxisReps": "Больше повторений, тот же вес",
      "historyProposalAxisLoad": "Больше веса, те же повторения",
      "historyProposalAxisTrade": "Обмен: больше веса, меньше повторений",
      "historyInUse": "используется",
      "historyCopyWeightA11y": "Взять этот вес в текущий подход",
      "historyCopySetA11y": "Скопировать этот подход в текущий",
      "historyNone": "Это упражнение вы ещё не записывали.",
      "historySourceTestedMax": "Чтобы выйти на {{effort}}: из протестированного 1RM",
      "historySourceMax": "Чтобы выйти на {{effort}}: из записанного максимума",
      "historySourceLastSet": "Чтобы выйти на {{effort}}: из последнего подхода здесь",
      "historySourcePercent": "Процент от вашего максимума, заданный программой",
      "historySourcePrescribed": "Вес, записанный в программе",
      "historySourceLastWeight": "Последний вес, который вы здесь действительно использовали",
      "historySourceManual": "Этот вы ввели сами",
      "historySourcePercentOf": "{{pct}}% от вашего максимума, задано программой",
      "draftToday": {
        "status": "Черновик · не сохранён",
        "exercises_one": "{{count}} упражнение",
        "exercises_few": "{{count}} упражнения",
        "exercises_many": "{{count}} упражнений",
        "exercises_other": "{{count}} упражнения",
        "scope": "Для мышц ниже минимального объёма, которые вы не тренировали последние {{hours}} ч.",
        "scopeMav": "Для мышц ниже минимального объёма, затем ниже MAV, которые вы не тренировали последние {{hours}} ч.",
        "scopeAnyway": "Отдых не учитывается: сначала мышцы, которые вы дольше всего не тренировали.",
        "reason_one": "<b>{{muscle}}</b>: {{n}} подход до минимума на этой неделе",
        "reason_few": "<b>{{muscle}}</b>: {{n}} подхода до минимума на этой неделе",
        "reason_many": "<b>{{muscle}}</b>: {{n}} подходов до минимума на этой неделе",
        "reason_other": "<b>{{muscle}}</b>: {{n}} подхода до минимума на этой неделе",
        "reasonMav_one": "<b>{{muscle}}</b>: на {{n}} подход ниже MAV на этой неделе",
        "reasonMav_few": "<b>{{muscle}}</b>: на {{n}} подхода ниже MAV на этой неделе",
        "reasonMav_many": "<b>{{muscle}}</b>: на {{n}} подходов ниже MAV на этой неделе",
        "reasonMav_other": "<b>{{muscle}}</b>: на {{n}} подхода ниже MAV на этой неделе",
        "lastTrained": "последний раз {{age}}",
        "noHistory": "Ещё не выполнялось · повторов и кг пока нет",
        "notOnDevice": "Истории нет на устройстве · без повторов и кг",
        "loadsCached": "Повторы и веса взяты из истории, сохранённой на этом устройстве.",
        "loadsPartial": "Повторы и веса взяты с этого устройства; у некоторых упражнений здесь нет истории.",
        "reps": "повт.",
        "painVeto": "Исключено, чтобы поберечь {{parts}} (карта боли): {{muscles}}.",
        "source": "Повторы: ваш лучший подход за последние 8 недель. Кг: рассчитаны так, чтобы оставалось 3 повтора в запасе. Ничего не сохраняется, пока вы не начнёте.",
        "discard": "Удалить черновик",
        "timeA11y": "Доступное время",
        "minutes": "{{n}} мин",
        "estimate": "~{{n}} мин",
        "shuffleRowA11y": "Другое упражнение для: {{muscle}}",
        "shuffleAllA11y": "Другие упражнения для каждой мышцы",
        "shuffleAll": "Перемешать все",
        "allSets_one": "относится ко всем {{n}} подходу",
        "allSets_few": "относится ко всем {{n}} подходам",
        "allSets_many": "относится ко всем {{n}} подходам",
        "allSets_other": "относится ко всем {{n}} подходам",
        "intensityChoice": "{{n}}%",
        "intensityA11y": "Интенсивность: доля недельного объёма",
        "intensityChipA11y": "{{n}}% недельного объёма",
        "intensityToday": "сегодня на {{n}}%",
        "surprise": "Удивите меня",
        "surpriseHint": "Случайные упражнения вместо тех, что вы делаете чаще всего",
        "anchorOwn": "По вашему лучшему подходу, {{date}} · {{age}}",
        "anchorSimilar": "Повторы из упражнения «{{name}}» · для этого упражнения кг пока нет",
        "timeTitle": "Время (мин)",
        "intensityTitle": "Интенсивность",
        "restTitle": "Отдых",
        "restChoice": "{{n}} ч",
        "restA11y": "Отдых: мышцы, тренированные в этот период, не предлагаются",
        "restChipA11y_one": "{{count}} час",
        "restChipA11y_few": "{{count}} часа",
        "restChipA11y_many": "{{count}} часов",
        "restChipA11y_other": "{{count}} часа",
        "restingUntil": "{{muscles}}: отдых до {{day}}",
        "atMinimum": "Каждая мышца на своём недельном минимуме.",
        "buildAnyway": "Всё равно собрать",
        "newWorkout": "Новая тренировка"
      },
      "pin": "Закрепить",
      "pinned": "закреплено",
      "hintTitle": "Нажмите, чтобы заменить это упражнение.",
      "hintHowTo": "Как выполнять это упражнение.",
      "hintTarget": "Подходы за последние 7 дней по мышцам.",
      "hintTrash": "Убирает это упражнение из тренировки.",
      "hintClock": "Прошлые подходы этого упражнения.",
      "hintEffortTarget": "Назначено планом.",
      "hintEffortTargetAmrap": "Цель AMRAP: последнее повторение, которое вы можете сделать.",
      "hintSuperset": "Суперсет: объедините с другим упражнением и чередуйте подходы.",
      "hintSupersetCue": "Суперсет: нажмите, чтобы перейти к следующему упражнению.",
      "hintSupersetMenu": "Опции суперсета: добавить, упорядочить, убрать или расформировать.",
      "hintWeek": "Нажмите для следующей недели. Проведите по сетке, чтобы вернуться.",
      "hintTimed": "На время: подход держится по времени, повторения не считаются.",
      "hintAssisted": "С помощью: резина или тренажёр снимают нагрузку. Считается как минус.",
      "hintNote": "Заметка: напишите подсказку к этому подходу.",
      "hintDropsetRemove": "Вернуться к одному рабочему подходу.",
      "hintPinOn": "Закреплено: остаётся в фокусе после отдыха. Нажмите, чтобы открепить.",
      "hintPinOff": "Закрепить: после отдыха фокус останется на этом упражнении.",
      "holdHintIntro": "Удерживайте кнопку, чтобы узнать, что она делает.",
      "showHint": "Показать подсказку",
      "pickerInDays": "В какие дни",
      "pickerAddNInDays_one": "Добавить {{n}} в {{count}} день",
      "pickerAddNInDays_few": "Добавить {{n}} в {{count}} дня",
      "pickerAddNInDays_many": "Добавить {{n}} в {{count}} дней",
      "pickerAddNInDays_other": "Добавить {{n}} в {{count}} дня",
      "repsRangeA11y": "Диапазон повторений от {{min}} до {{max}}",
      "calibration": {
        "offer": "MAX пока нет, поэтому у этого % нет веса. Откалибровать сегодня?",
        "accept": "Откалибровать",
        "decline": "Не сегодня",
        "toCalibrate": "Нужна калибровка: MAX пока нет, вес не предлагается.",
        "first": "Калибровка: подходы по 5. Впишите лёгкий первый вес, остальные предложит $t(brand.product).",
        "ramp_one": "Подход калибровки {{n}}: больше веса. Остановка на {{effort}} или после {{count}} подхода.",
        "ramp_few": "Подход калибровки {{n}}: больше веса. Остановка на {{effort}} или после {{count}} подходов.",
        "ramp_many": "Подход калибровки {{n}}: больше веса. Остановка на {{effort}} или после {{count}} подходов.",
        "ramp_other": "Подход калибровки {{n}}: больше веса. Остановка на {{effort}} или после {{count}} подхода.",
        "done": "Калибровка готова. Сохраните, и новый MAX будет ждать в «Уведомлениях»."
      },
      "moreTime": {
        "title": "Больше времени",
        "minutesTitle": "Дополнительные минуты",
        "minutesA11y_one": "Ещё {{count}} минута",
        "minutesA11y_few": "Ещё {{count}} минуты",
        "minutesA11y_many": "Ещё {{count}} минут",
        "minutesA11y_other": "Ещё {{count}} минуты",
        "none": "За {{minutes}} мин ничего не помещается.",
        "spent": "+{{spent}} ничего не добавляет к +{{minutes}} мин.",
        "spentBoth": "+{{a}} и +{{b}} ничего не добавляют к +{{minutes}} мин.",
        "spentA11y": "То же, что +{{minutes}} мин, добавить нечего.",
        "total": "Примерно ещё {{minutes}} мин",
        "todayOnly": "Меняется только сегодняшняя тренировка. Программа остаётся прежней.",
        "confirm": "Подтвердить",
        "failed": "Не удалось добавить. Попробуйте ещё раз.",
        "addSet": "+1 подход",
        "addRound": "+1 подход каждому",
        "addReps_one": "+{{count}} повторение",
        "addReps_few": "+{{count}} повторения",
        "addReps_many": "+{{count}} повторений",
        "addReps_other": "+{{count}} повторения",
        "addRow_one": "Возвращается: {{count}} подход",
        "addRow_few": "Возвращается: {{count}} подхода",
        "addRow_many": "Возвращается: {{count}} подходов",
        "addRow_other": "Возвращается: {{count}} подхода"
      },
      "errOffline": "Нет сети. Сохраните ещё раз, когда появится связь.",
      "pauseRow": "{{phase}}: {{label}}",
      "pauseA11y": "Пауза в каждом повторе: {{row}}"
    },
    "coachEdges": {
      "empty": "Связей с тренером пока нет. Тренер может пригласить вас из веб-приложения."
    },
    "recovery": {
      "banner": "Восстановленная тренировка",
      "orphanedBanner": "Вы исправили эту тренировку, но она была удалена на другом устройстве. Нажмите «Сохранить как новую», чтобы оставить исправление как новую тренировку.",
      "tooBigBanner": "Исправление меняло слишком много подходов сразу, тренировка осталась прежней. Нажмите «Сохранить как новую», чтобы оставить свою версию как новую тренировку.",
      "conflictBanner": "Тренировку изменили на другом устройстве раньше вашего исправления, она осталась прежней. Нажмите «Сохранить как новую», чтобы оставить исправление как новую тренировку.",
      "timesBanner": "В исправлении конец раньше начала, тренировка осталась прежней. Нажмите «Сохранить как новую», поправьте время и сохраните.",
      "staleBanner": "Тренировку сохранили ещё раз после начала исправления. Она осталась прежней. Нажмите «Сохранить как новую», чтобы оставить исправление.",
      "refusedBanner": "Сервер отклонил исправление, тренировка осталась прежней. Нажмите «Сохранить как новую», чтобы оставить свою версию как новую тренировку.",
      "saveAsNew": "Сохранить как новую",
      "title": "Восстановленная тренировка",
      "openBody": "Эта тренировка была прервана и восстановлена. Проверьте подходы и нажмите «Сохранить», чтобы записать её как новую тренировку.",
      "open": "Открыть",
      "cancel": "Отмена",
      "liveBusy": "У вас есть незавершённая тренировка. Сохраните или удалите её, прежде чем восстанавливать эту.",
      "discardTitle": "Удалить тренировку?",
      "discardBody": "Восстановленная тренировка будет удалена безвозвратно.",
      "discardConfirm": "Удалить",
      "error": "Не удалось восстановить тренировку. Попробуйте ещё раз.",
      "mergeTitle": "Объединить тренировку",
      "mergePrompt": "Выберите тренировку того же дня для объединения:",
      "noSameDay": "Нет тренировки того же дня для объединения. Используйте «Сохранить как новую».",
      "nothingToMerge": "Нет завершённых подходов для объединения. Используйте «Сохранить как новую».",
      "supportPrefix": "Тренировка сохранена на этом телефоне после сбоя, отправлена из колокольчика. JSON черновика во вложении."
    },
    "group": {
      "title": "Сгруппировать упражнение",
      "close": "Закрыть",
      "standalone": "Отдельно",
      "supersetSection": "СУПЕРСЕТЫ",
      "circuitSection": "КРУГОВЫЕ",
      "supersetN": "Суперсет {{n}}",
      "circuitN": "Круговая {{n}}",
      "newSuperset": "+ Новый суперсет",
      "newCircuit": "+ Новая круговая"
    },
    "webview": {
      "close": "Закрыть",
      "openExternal": "Открыть в браузере",
      "errorTitle": "Страница не загрузилась",
      "errorBody": "Нажмите ниже, чтобы открыть в системном браузере.",
      "fallbackErrorTitle": "Не удалось открыть браузер",
      "fallbackErrorBody": "Попробуйте из другой сети."
    },
    "plates": {
      "title": "Расчёт блинов",
      "titleDumbbell": "Шаг гантелей",
      "close": "Закрыть",
      "apply": "Применить",
      "targetLabel": "Цель",
      "barLabel": "Гриф ({{unit}})",
      "barOptionLabel": "Гриф: {{weight}}",
      "barCustom": "Другой…",
      "barCustomLabel": "Свой вес грифа",
      "perSide": "На сторону: {{weight}}",
      "barOnly": "Только гриф, блины не нужны.",
      "pairs_one": "{{count}} пара",
      "pairs_few": "{{count}} пары",
      "pairs_many": "{{count}} пар",
      "pairs_other": "{{count}} пары",
      "plates_one": "{{count}} блин",
      "plates_few": "{{count}} блина",
      "plates_many": "{{count}} блинов",
      "plates_other": "{{count}} блина",
      "loadedSide": "Нагруженная сторона: {{weight}}",
      "singleSideHint": "Только одна сторона: блины ставятся лишь с одной стороны. Лендмайн, T-гриф, сани и рычаги на одну руку загружаются так.",
      "remainder": "Разница {{weight}}. Точно набрать этим инвентарём нельзя.",
      "belowBar": "Цель меньше веса грифа.",
      "invalid": "Введите корректный вес.",
      "inventoryTitle": "Доступные пары ({{unit}})",
      "pairsIncrement": "Добавить пару {{weight}}",
      "pairsDecrement": "Убрать пару {{weight}}",
      "signLabel": "ЗНАК EXTRA",
      "signAdd": "+ С отягощением",
      "signAssist": "− С помощью",
      "loadShapeLabel": "Как загружается",
      "loadShapeTwoSides": "Две стороны",
      "loadShapeOneSide": "Одна сторона",
      "loadShapeTwoSidesHint": "пары",
      "loadShapeOneSideHint": "одна стопка",
      "composeTitle": "Блины ({{unit}}): нажмите, чтобы добавить",
      "composeEmpty": "Блины не настроены. Укажите ниже, какие пары у вас есть.",
      "composeAddPair": "Повесить пару {{weight}} на гриф",
      "composeAddPlate": "Повесить блин {{weight}} на гриф",
      "composeRemovePair": "Снять пару {{weight}} с грифа",
      "composeRemovePlate": "Снять блин {{weight}} с грифа",
      "roundToLoadable": "Округлить до доступного веса",
      "dumbbellStepLabel": "Шаг гантелей ({{unit}})",
      "dumbbellStepAria": "Шаг гантелей ({{unit}})",
      "dumbbellStepOption": "Шаг: {{weight}}",
      "dumbbellStepHint": "Гантели растут с этим шагом. Нагрузки округляются до него. Не уверены? Шаг 2 подойдёт для любой стойки.",
      "calcOpen": "Калькулятор",
      "calcResult": "Результат: {{value}} {{unit}}",
      "calcClearKey": "C",
      "calcClear": "Сброс",
      "calcDecimal": "Запятая",
      "calcOpPlus": "Плюс",
      "calcOpMinus": "Минус",
      "calcOpTimes": "Умножить",
      "calcOpDivide": "Разделить",
      "calcDismiss": "Закрыть",
      "calcCopy": "Скопировать в вес",
      "calcCopyBlocked": "Сначала наберите вес больше нуля."
    },
    "restTimerScreen": {
      "title": "Таймеры",
      "back": "Назад"
    },
    "licenses": {
      "title": "Лицензии open source",
      "back": "Назад",
      "headlineIntro": "$t(brand.product) использует небольшой набор библиотек. Нажмите на строку, чтобы открыть проект. Подумайте о поддержке тех, которыми пользуетесь чаще всего.",
      "coreSection": "Основные библиотеки ({{count}})",
      "viewAllTitle": "Показать все пакеты",
      "viewAllSub": "Полные атрибуции для {{count}} пакетов, включённых в APK, сгруппированных по проектам.",
      "allTitle": "Все пакеты ({{count}})",
      "searchAll": "Поиск по имени, группе, лицензии или автору",
      "groupOther": "Прочие пакеты",
      "empty": "Нет пакетов, соответствующих поиску.",
      "footer": "Создано {{date}}",
      "openErrorTitle": "Не удаётся открыть ссылку"
    },
    "share": {
      "newPR": "НОВЫЙ PR",
      "topLifts": "ТОП УПРАЖНЕНИЙ",
      "durationMinute": "мин.",
      "durationHour": "ч",
      "footerSets": "подходов",
      "footerDensitySuffix": "/мин",
      "fallbackLabel": "Общий объём",
      "timeLabel": "Общее время",
      "tutLabel": "TUT",
      "impulseUnit": "кг·с",
      "impulseLabel": "Импульс",
      "e1rmSuffix": "E1RM"
    },
    "postSession": {
      "blockCalories": "Калории",
      "blockEffort": "Нагрузка",
      "blockDistance": "Дистанция",
      "effortHr": "{{avg}} сред. · {{peak}} пик уд/мин",
      "effortHrMax": "{{pct}}% от макс. ЧСС",
      "shareTitle": "Тренировка $t(brand.product)",
      "shareErrorTitle": "Не удалось поделиться",
      "headlineLabelPR": "НОВЫЙ E1RM",
      "headlineLabelDelta": "БОЛЬШОЙ СКАЧОК +{{delta}}",
      "headlineLabelSolid": "ХОРОШАЯ ТРЕНИРОВКА",
      "headlineSolidValue": "{{volume}} за {{duration}}",
      "headlineFallback": "{{label}}, подходов: {{sets}}",
      "blockTopLifts": "Лучшие упражнения",
      "fromSet": "из {{weight}} × {{reps}}",
      "blockVolume": "Объём",
      "blockDuration": "Длительность",
      "blockDensity": "Плотность",
      "blockNotes": "Заметки",
      "barsTitle": "Нагрузка по мышцам",
      "bodyTitle": "Задействованные мышцы",
      "sharing": "Подготовка…",
      "shareCta": "Поделиться карточкой тренировки",
      "done": "Готово",
      "summaryTitle": "Тренировка сохранена",
      "maxProposed_one": "Предложен новый MAX для {{exercises}}: смотрите в уведомлениях.",
      "maxProposed_few": "Предложены новые MAX для {{exercises}}: смотрите в уведомлениях.",
      "maxProposed_many": "Предложены новые MAX для {{exercises}}: смотрите в уведомлениях.",
      "maxProposed_other": "Предложены новые MAX для {{exercises}}: смотрите в уведомлениях.",
      "noteNotSaved_one": "{{count}} заметка не сохранена. Её текст здесь, скопируйте его при необходимости:",
      "noteNotSaved_few": "{{count}} заметки не сохранены. Их текст здесь, скопируйте при необходимости:",
      "noteNotSaved_many": "{{count}} заметок не сохранено. Их текст здесь, скопируйте при необходимости:",
      "noteNotSaved_other": "{{count}} заметки не сохранено. Их текст здесь, скопируйте при необходимости:"
    },
    "common": {
      "back": "Назад",
      "save": "Сохранить",
      "cancel": "Отмена",
      "close": "Закрыть"
    },
    "account": {
      "title": "Аккаунт",
      "labelDiagnostics": "ДИАГНОСТИКА",
      "navSub": "Имя, пароль, экспорт, удаление, выход",
      "nameLabel": "ИМЯ",
      "namePlaceholder": "Ваше имя",
      "saved": "Сохранено",
      "passwordLabel": "СМЕНА ПАРОЛЯ",
      "currentPassword": "Текущий пароль",
      "newPassword": "Новый пароль",
      "confirmPassword": "Подтвердите новый пароль",
      "currentPasswordWrong": "Текущий пароль неверный. Проверьте его и попробуйте снова.",
      "passwordChanged": "Пароль изменён.",
      "passwordSubmit": "Обновить пароль",
      "withdrawAge": "Отозвать заявление о возрасте",
      "withdrawAgeBody": "Экран с заявлением появится снова. Оттуда можно выйти из аккаунта или удалить его. Приложение останется заблокированным, пока вы не подтвердите снова.",
      "withdrawAgeConfirm": "Отозвать",
      "withdrawAgeNeedsConnection": "Чтобы отозвать заявление, нужно соединение. Подключитесь и повторите попытку.",
      "actionFailed": "Не получилось. Повторите попытку чуть позже.",
      "deleteNeedsConnection": "Для удаления аккаунта нужно соединение. Подключитесь и повторите попытку. Этот запрос никогда не сохраняется на потом.",
      "exportNeedsConnection": "Для экспорта данных нужно соединение. Подключитесь и повторите попытку."
    },
    "prefs": {
      "title": "Единицы и отображение",
      "navSub": "Единицы, тема, подсказки",
      "unitsLabel": "Единицы",
      "unitsHelp": "Единица веса по умолчанию для новых подходов. Её всё равно можно изменить для каждой строки в логгере.",
      "weekStartLabel": "Неделя начинается с",
      "weekStartHelp": "Первый день недели в столбцах и сериях.",
      "habitualDaysLabel": "Обычные дни тренировок",
      "habitualDaysHelp": "Нужны, чтобы предупредить, когда программа нагружает одну мышцу в соседние дни.",
      "habitualDaysManual": "Выбраны вами.",
      "habitualDaysReadError": "Не удалось прочитать ваш журнал. Выберите дни или попробуйте позже.",
      "habitualDaysInferred_one": "Определены по последней {{count}} неделе.",
      "habitualDaysInferred_few": "Определены по последним {{count}} неделям.",
      "habitualDaysInferred_many": "Определены по последним {{count}} неделям.",
      "habitualDaysInferred_other": "Определены по последним {{count}} неделям.",
      "habitualDaysUnknown_one": "Слишком мало тренировок за последнюю {{count}} неделю. Выберите дни сами.",
      "habitualDaysUnknown_few": "Слишком мало тренировок за последние {{count}} недели. Выберите дни сами.",
      "habitualDaysUnknown_many": "Слишком мало тренировок за последние {{count}} недель. Выберите дни сами.",
      "habitualDaysUnknown_other": "Слишком мало тренировок за последние {{count}} недели. Выберите дни сами.",
      "habitualDaysUseDeduced": "Использовать определённые дни",
      "habitualDaysInferredNoWindow": "Определены по вашему журналу.",
      "habitualDaysUnknownNoWindow": "Пока слишком мало тренировок. Выберите дни сами.",
      "habitualDaysLastOn": "Хотя бы один день остаётся выбранным.",
      "timeZoneLabel": "Часовой пояс",
      "timeZoneHelp": "Выберите регион, где вы тренируетесь. «Не выбран» означает UTC.",
      "timeZoneNone": "Не выбран (UTC)",
      "timeZoneChange": "Изменить",
      "timeZoneProposal": "{{region}}, с вашего устройства",
      "timeZoneConfirm": "Подтвердить",
      "timeZoneRegion": {
        "hawaii": "Гавайи",
        "alaska": "Аляска",
        "naPacific": "Тихоокеанское (США, Канада)",
        "naMountain": "Горное (США, Канада)",
        "naCentral": "Центральное (США, Канада)",
        "mexico": "Мексика, Центральная Америка",
        "naEastern": "Восточное (США, Канада)",
        "southAmericaWest": "Колумбия, Эквадор, Перу",
        "atlanticCanada": "Атлантическая Канада",
        "southAmericaEast": "Бразилия, Аргентина",
        "ukIreland": "Британия, Ирландия, Португалия",
        "westAfrica": "Нигерия, Центральная Африка",
        "centralEurope": "Центральная Европа",
        "easternEurope": "Восточная Европа",
        "southernAfrica": "Южная Африка",
        "turkeyMiddleEast": "Турция, Ближний Восток",
        "westernRussia": "Западная Россия",
        "gulfCaucasus": "ОАЭ, Оман, Кавказ",
        "pakistanCentralAsia": "Пакистан, Средняя Азия",
        "india": "Индия, Шри-Ланка",
        "southeastAsiaWest": "Таиланд, Вьетнам, Ява",
        "chinaSoutheastAsia": "Китай, Сингапур, Филиппины",
        "westernAustralia": "Западная Австралия",
        "japanKorea": "Япония, Корея",
        "australiaCentral": "Центральная Австралия",
        "australiaEast": "Восточная Австралия",
        "newZealand": "Новая Зеландия"
      },
      "unitsKg": "Килограммы (кг)",
      "unitsLb": "Фунты (lb)",
      "glucoseUnitsLabel": "Единицы глюкозы",
      "glucoseUnitsHelp": "Как глюкоза показывается и вводится. Хранится одинаково.",
      "glucoseMmol": "ммоль/л",
      "glucoseMgdl": "мг/дл",
      "themePaletteLabel": "Палитра темы",
      "themePaletteHelp": "Выберите цветовую палитру для всего приложения.",
      "themeModeLabel": "Оформление",
      "themeModeHelp": "Следовать системной настройке или задать светлую либо тёмную.",
      "themeMode": {
        "system": "Системная",
        "light": "Светлая",
        "dark": "Тёмная"
      }
    },
    "home": {
      "targetsTopPatterns": "Основные паттерны",
      "targetsSummary": "{{on}} из {{total}} в целевой зоне",
      "targetsHint": "Задайте недельные цели в Я → Цели, чтобы сравнивать с ними эти показатели.",
      "targetsZoneOnTarget": "в цели",
      "targetsZoneOver": "выше",
      "targetsZoneUnder": "в процессе",
      "targetsNoCoverage": "нет в плане",
      "targetsNoTarget": "Нет цели",
      "targetsUntargeted": "без цели",
      "targetsUntargetedA11y_one": "{{count}} мышца тренировалась без цели",
      "targetsUntargetedA11y_few": "{{count}} мышцы тренировались без цели",
      "targetsUntargetedA11y_many": "{{count}} мышц тренировались без цели",
      "targetsUntargetedA11y_other": "{{count}} мышцы тренировались без цели",
      "targetsIncomplete": "неполно",
      "targetsIncompleteWhy": "Упражнение, записанное за последние 7 дней, отсутствует в каталоге, поэтому его подходы не засчитаны ни одной мышце.",
      "targetsIncompleteNoBodyweight": "Тренировка за последние 7 дней сохранена без вашего веса, поэтому её подходы с собственным весом засчитаны как ноль. Администратор пересчитает её: вам ничего не нужно делать.",
      "targetsIncompleteMayBeHigher": "Реальное число может быть больше.",
      "targetsIncompleteA11y": "Почему неполно",
      "targetsEmptyTitle": "Целей пока нет",
      "targetsEmptySub": "Задайте, сколько хотите тренировать каждую мышцу в неделю. Ваш план будет работать на это; счётчик на главной покажет, где вы находитесь.",
      "targetsEmptyCta": "Задать цели",
      "weekEyebrow": "Последние 7 дней",
      "weeklySessions": "Тренировки",
      "weeklyVolume": "Объём",
      "weeklyA11y": "Тренировок: {{sessions}}, объём {{volume}}",
      "viewProgress": "Открыть прогресс",
      "badgesTitle": "Значки",
      "prPrev": "Предыдущий рекорд",
      "prNext": "Следующий рекорд",
      "prPosition": "Рекорд {{n}} из {{total}}",
      "eyebrow": "СЕГОДНЯ",
      "blankTitle": "Готовы тренироваться?",
      "blankLoading": "Загрузка плана…",
      "blankBody": "Сейчас нет активной программы. У $t(brand.product) есть готовые программы: выберите любую одним касанием. Или начните пустую тренировку.",
      "blankLibrary": "Смотреть готовые программы",
      "newWorkout": "Новая тренировка",
      "programMeta": "{{program}} · Неделя {{week}}",
      "morePreview": " +ещё {{count}}",
      "startToday": "▶ Начать тренировку",
      "blankInstead": "Начать пустую тренировку",
      "recentPrValue": "{{weight}} × {{reps}}",
      "recentPrValueBodyweight": "{{reps}} повт. с весом тела",
      "weightTitle": "Вес тела",
      "weightSaved": "Сохранено ✓",
      "weightCurrent": "Последний: {{weight}}",
      "weightNone": "Записывайте вес, чтобы видеть динамику.",
      "weightSave": "Сохранить",
      "repeatWorkout": "Повторить тренировку",
      "form": {
        "title": "Готовность",
        "ready": "Готов",
        "caution": "Осторожно",
        "rest": "Отдых",
        "reasonNoData": "Запишите тренировку, чтобы отслеживать готовность.",
        "reasonBalanced": "Ваша нагрузка выглядит сбалансированной.",
        "reasonFreshStart": "Пока записано мало тренировок.",
        "reasonShortRest": "Несколько тренировок на этой неделе, последняя несколько часов назад.",
        "reasonHighFrequency": "На этой неделе тренировок больше обычного.",
        "reasonLoadSpike": "Нагрузка резко выросла по сравнению со средней за последнее время.",
        "reasonLongGap": "Прошло несколько дней с последней тренировки."
      },
      "glucoseSave": "Сохранить",
      "weightSaveA11y": "Сохранить вес тела",
      "glucoseSaveA11y": "Сохранить уровень глюкозы",
      "config": {
        "title": "Настроить главную",
        "open": "Настроить главную",
        "active": "Активные",
        "inactive": "Неактивные",
        "dragHint": "Перетащите карточку за маркер, чтобы изменить порядок.",
        "inactiveEmpty": "Ничего не скрыто. Нажмите ✕ на карточке, чтобы скрыть её.",
        "pinned": "Всегда видна",
        "hide": "Скрыть: {{name}}",
        "show": "Показать: {{name}}",
        "reorder": "Переместить: {{name}}",
        "reorderKeys": "Переместить: {{name}}, используйте клавиши со стрелками",
        "reorderHint": "Перетащите, чтобы переместить, или используйте действия, чтобы сдвинуть выше или ниже.",
        "moveUp": "Выше",
        "moveDown": "Ниже",
        "reset": "Сбросить по умолчанию",
        "saveError": "Не удалось сохранить макет главной. Попробуйте ещё раз.",
        "widget": {
          "hero": "Сегодня",
          "readiness": "Готовность",
          "weeklyTargets": "Последние 7 дней",
          "quickWeight": "Вес тела",
          "quickGlucose": "Глюкоза",
          "badges": "Значки",
          "coverage": "Охват мышц",
          "e1rmTrends": "Тренды E1RM",
          "repsAtLoad": "Повторы на весе",
          "movementBalance": "Баланс паттернов движений",
          "painVolume": "Боль × объём",
          "intensityHeatmap": "Тепловая карта интенсивности",
          "exerciseFrequency": "Самые забытые упражнения",
          "painMap": "Карта боли",
          "measurements": "Замеры"
        },
        "columnMain": "Основная колонка",
        "columnRail": "Боковая колонка",
        "columnEmpty": "В этой колонке нет карточек."
      },
      "painMapEmpty": "Боль не отмечена.",
      "painMapOpenHint": "Открывает вашу карту боли для редактирования."
    },
    "superset": {
      "startingWith": "Начать суперсет с",
      "joinExisting": "В существующий",
      "pairInWorkout": "Объединить (в этой тренировке)",
      "templates": "Сохранённые суперсеты",
      "templateInsertHint": "Вставить этот суперсет; удерживайте для удаления",
      "templateDeleteBody": "Удалить этот сохранённый суперсет?",
      "createCta": "Создать суперсет ({{n}})",
      "cueCycle": "{{group}}, упражнение {{pos}} из {{total}}. Нажмите, чтобы перейти к {{next}}.",
      "cueStatic": "{{group}}, упражнение {{pos}} из {{total}}",
      "menuOpen": "Опции суперсета",
      "menuSaveTemplate": "Сохранить как шаблон",
      "menuAddExercise": "Добавить упражнение",
      "menuAddRound": "Добавить круг",
      "menuRemoveRound": "Убрать круг",
      "menuMoveUp": "Вверх",
      "menuMoveDown": "Вниз",
      "menuRemoveMember": "Убрать это упражнение",
      "menuSplit": "Расформировать суперсет",
      "namePlaceholder": "Название суперсета (необязательно)"
    },
    "premium": {
      "badge": "Премиум",
      "lockedA11y": "{{name}}, Премиум, не входит в базовый отчёт",
      "lockedItemA11y": "{{name}}, Премиум"
    },
    "widgetConfig": {
      "stateClosed": "Закрыта",
      "stateOpen": "Открыта",
      "expand": "Развернуть: {{name}}",
      "collapse": "Свернуть: {{name}}"
    },
    "bell": {
      "channelName": "Оповещения"
    }
  },
  "settings": {
    "langRegion": {
      "title": "Язык и регион"
    },
    "dateFormat": {
      "label": "Формат даты",
      "help": "Где стоят день и месяц. Автоматически следует региону этого устройства.",
      "auto": "Автоматически",
      "autoResolved": "Автоматически ({{order}})",
      "dmy": "Сначала день",
      "mdy": "Сначала месяц",
      "ymd": "Сначала год"
    },
    "restDefaults": {
      "title": "Настройки таймера отдыха по умолчанию",
      "globalLabel": "Глобальное значение",
      "globalUnset": "Не задано: используется {{n}} с",
      "customLabel": "Упражнения с индивидуальной настройкой",
      "customEmpty": "Нет индивидуальных значений. Откройте баннер отдыха в логгере и нажмите ⚙, чтобы задать.",
      "customRemoveA11y": "Удалить индивидуальный отдых для {{name}}",
      "clearGlobal": "Сбросить"
    },
    "hints": {
      "title": "Подсказки",
      "label": "Показывать подсказки",
      "help": "Удерживайте кнопку в логгере, чтобы узнать, что она делает, или нажмите на заголовок столбца. Выключите, чтобы скрыть подсказки, которые появляются сами."
    },
    "exerciseAgePulse": {
      "label": "Отмечать давно не выполнявшееся упражнение",
      "help": "Мигание на плашке истории, если упражнение долго не выполнялось. Выключите, чтобы видеть возраст без мигания."
    },
    "effortNudge": {
      "label": "Напоминание об усилии",
      "help": "Редкий мягкий импульс на шкале усилия, пока подход ждёт записи."
    },
    "inWorkoutMeter": {
      "label": "Счётчик целей в тренировке",
      "help": "Полоса вверху карточки упражнения с недельной целью для мышц, которые вы тренируете."
    },
    "audio": {
      "title": "Звук",
      "soundLabel": "Звук таймера",
      "soundHelp": "Воспроизводится по окончании таймера отдыха.",
      "vibrationLabel": "Вибрация",
      "vibrationHelp": "Вибрация по окончании таймера отдыха.",
      "previewButton": "Прослушать",
      "pickerTitle": "Выбрать звук",
      "pickerCancel": "Отмена",
      "category": {
        "serious": "Обычные",
        "fun": "Весёлые"
      },
      "soundOptions": {
        "none": "Без звука",
        "chime_crisp": "Колокольчик",
        "ding_dong": "Дин-дон",
        "meditation_bell": "Поющая чаша",
        "tada_fanfare": "Та-да",
        "cartoon_boing": "Боинг",
        "ah_yeah": "Ага!"
      }
    },
    "timerDefaults": {
      "range": "Введите {{min}}–{{max}} с",
      "globalTitle": "Общие значения",
      "restGlobal": "Таймер отдыха",
      "holdGlobal": "Таймер удержания",
      "saveRow": "Сохранить: {{label}}",
      "customLabel": "Настройки по упражнению",
      "customEmpty": "Пока нет настроек по упражнению. Нажмите + Добавить.",
      "unset": "Не задано: {{n}} с",
      "add": "+ Добавить",
      "editRestA11y": "Изменить отдых для {{name}}",
      "editHoldA11y": "Изменить удержание для {{name}}",
      "editA11y": "Изменить таймеры для {{name}}",
      "isDefault": "по умолч.",
      "equalsDefaultHint": "Значение, равное общему по умолчанию, не сохраняется как переопределение.",
      "remove": "Удалить"
    },
    "backend": {
      "section": "Бэкенд",
      "title": "Бэкенд",
      "navSub": "Выберите, куда пишет эта сборка",
      "pickLabel": "Писать мои данные в",
      "pickHelp": "Только dev-сборка. У каждого бэкенда своя сессия, свои очереди и свой черновик тренировки. Переключение не трогает другой.",
      "stageProduction": "ПРОДАКШН",
      "stageLab": "ЛАБОРАТОРИЯ",
      "liveLabel": "ЗАПИСЬ ИДЁТ В",
      "liveChecking": "Проверка…",
      "liveUnknown": "Неизвестно: бэкенд не ответил",
      "liveNotProduction": "Здесь нет ваших настоящих тренировок.",
      "confirmTitle": "Сменить бэкенд?",
      "confirmBody": "Приложение перезагрузится на {{stage}}. Там может потребоваться вход, а кэшированные списки будут сброшены.",
      "confirmCta": "Сменить",
      "blockedByQueue": "Не переключено: часть записей ещё не отправлена. Вернитесь в сеть и дождитесь отправки очередей."
    },
    "animations": {
      "cellularLabel": "Загружать анимации без Wi-Fi",
      "cellularHelp": "По умолчанию выключено. Анимации есть в любом случае: это лишь разрешает приложению загружать их заранее по мобильной сети, примерно 20-30 МБ на программу."
    },
    "crashReports": {
      "label": "Отправлять отчёты о сбоях",
      "help": "После сбоя при следующем запуске на наш сервер уходит: что сломалось, где в коде, используемая память, версии приложения и Android. Тренировки, заметки, веса и данные о здоровье не отправляются никогда."
    }
  },
  "web": {
    "preauth": {
      "tagline": "Силовые тренировки, которые планируются с учётом вашего усилия, вашего сегодняшнего состояния и инвентаря, который у вас есть на самом деле.",
      "status": "В разработке. Регистрация закрыта.",
      "contactLabel": "Доступ или информация"
    },
    "crash": {
      "body": "В приложении произошла непредвиденная ошибка. Ваши сохранённые данные в безопасности. Перезагрузите страницу, чтобы продолжить.",
      "reload": "Перезагрузить",
      "retryBody": "В приложении произошла непредвиденная ошибка. Ваши сохранённые данные в безопасности. Попробуйте снова, и если этот экран вернётся, пришлите нам сообщение ниже.",
      "retry": "Попробовать снова"
    },
    "postSession": {
      "headlineLabelPR": "НОВЫЙ E1RM",
      "headlineLabelDelta": "БОЛЬШОЙ СКАЧОК +{{delta}}",
      "headlineLabelSolid": "ХОРОШАЯ ТРЕНИРОВКА",
      "headlineSolidValue": "{{volume}} за {{duration}}",
      "headlineFallback": "{{label}}: {{sets}} подходов",
      "blockE1rm": "E1RM",
      "fromSet": "из {{weight}} × {{reps}}",
      "blockVolume": "Объём",
      "blockDuration": "Длительность",
      "blockDensity": "Плотность",
      "barsTitle": "Нагрузка по мышцам",
      "bodyTitle": "Задействованные мышцы",
      "sharing": "Подготовка…",
      "shareCta": "Поделиться карточкой тренировки"
    }
  },
  "muscle": {
    "quadriceps": "Квадрицепсы",
    "hamstrings": "Бицепсы бёдер",
    "glutes": "Ягодицы",
    "adductors": "Приводящие",
    "abductors": "Отводящие",
    "calves": "Икры",
    "core": "Корпус",
    "obliques": "Косые",
    "erectors": "Поясница",
    "pectoralis": "Грудь",
    "anterior-delts": "Передние дельты",
    "lateral-delts": "Средние дельты",
    "triceps": "Трицепсы",
    "lats": "Широчайшие",
    "rhomboids": "Верх спины",
    "rear-delts": "Задние дельты",
    "traps": "Трапеции",
    "biceps": "Бицепсы",
    "forearms": "Предплечья"
  },
  "experience": {
    "athlete": "Спортсмен",
    "coach": "Тренер",
    "admin": "Админ"
  },
  "composer": {
    "targetAxisExercise": "Упражнение",
    "targetKeyExercise": "Упражнение",
    "targetRefAvg": "~{{n}}/нед сред.",
    "targetRefNone": "Нет данных за последние 4 недели",
    "targetRefProgram": "программа задаёт ~{{n}}/нед",
    "targetUseAvg": "Взять среднее",
    "targetUseProgram": "Взять из программы",
    "projectionTitle": "Распределение целей",
    "projectionWeek": "Неделя {{n}}",
    "projectionContext": "Подходы / нагрузка, заданные программой на неделе {{n}}.",
    "projectionTarget": "Цель",
    "projectionWeekTotal": "Нед.",
    "projectionRamp": "Цикл",
    "projectionWeekShort": "Н{{n}}",
    "projectionEmpty": "Не запланировано",
    "targetsTitle": "Недельные цели",
    "targetsEmptyTitle": "Нет недельных целей",
    "targetsEmptySub": "Добавьте цель, чтобы включить шкалу уровня.",
    "targetAdd": "Добавить цель",
    "targetRemove": "Удалить цель {{name}}",
    "targetCollapse": "Свернуть",
    "targetAxis": "Ось",
    "targetAxisMuscle": "Мышца",
    "targetMetric": "Метрика",
    "targetMetricHardSets": "Тяжёлые подходы",
    "targetMetricTonnage": "Тоннаж",
    "targetMetricReps": "Повт.",
    "targetKeyMuscle": "Мышца",
    "targetValue": "Недельная цель",
    "targetUnitHardSets": "тяж. подходов",
    "targetUnitTonnage": "кг",
    "targetUnitReps": "повт.",
    "targetBand": "±{{pct}} %",
    "targetNotScored": "пока не в шкале",
    "targetNotScoredNote": "Этот тип цели пока не учитывается в шкале уровня.",
    "targetBandLabel": "Допуск",
    "targetBandAsym": "−{{lo}}% / +{{hi}}%",
    "targetBandBelow": "Процент ниже цели",
    "targetBandAbove": "Процент выше цели",
    "targetBandRange": "Ниже 0–99%, выше 0% или больше.",
    "compose": "Составить",
    "preview": "Предпросмотр",
    "addExercises": "Добавить упражнения",
    "editingBlockDay": "Редактируется Д{{d}}. Обновление применяется к этому дню (отметьте другие дни, чтобы применить и к ним)",
    "editingRampDay": "Недельная прогрессия в Д{{d}}. Обновление применяется к выбранным неделям, только этот день",
    "segments": "Сегменты",
    "rampSwitchHint": "Сначала обновите или отмените, затем меняйте сегмент",
    "setupHint": "Задайте начальную форму. Дни можно добавить или удалить, а недели изменить позже в редакторе.",
    "repsHint": "Повторы «5+» = AMRAP: минимум 5, дальше сколько сможете.",
    "repsHintA11y": "Как записываются повторения",
    "addingWeek": "Новая неделя W{{n}}. Обновление добавит её к этому упражнению",
    "cloneWeek": "Клонировать неделю…",
    "cloneWeekFrom": "Из",
    "cloneWeekApply": "Клонировать",
    "cloneWeekConflict": "{{name}} уже имеет содержимое в W{{week}} (D{{day}})",
    "cloneWeekEmpty": "Нечего клонировать. Выберите заполненную неделю-источник и хотя бы одну цель",
    "editingWeekDay": "Редактируется только W{{n}} в Д{{d}}. Обновление отделит её от сегмента",
    "perWeek": "По неделям",
    "dupExercise": "{{name}} уже есть в D{{day}} в выбранных неделях",
    "days": "Дни",
    "weeks": "Недели",
    "setNote": "Заметка к подходу",
    "removeExercise": "Убрать упражнение",
    "replaceExercise": "Заменить упражнение",
    "remove": "Удалить",
    "verbatim": "Расширенный слот (мульти-вариант): сохраняется как есть, здесь не редактируется",
    "metaWeeks_one": "{{count}} неделя",
    "metaWeeks_few": "{{count}} недели",
    "metaWeeks_many": "{{count}} недель",
    "metaWeeks_other": "{{count}} недели",
    "tabPlan": "План",
    "importPlanHint": "Упражнения добавятся в редактируемый день, во все недели цикла.",
    "importPlanEmpty": "Сохранённых планов пока нет.",
    "importPlanMeta_one": "{{count}} упражнение",
    "importPlanMeta_few": "{{count}} упражнения",
    "importPlanMeta_many": "{{count}} упражнений",
    "importPlanMeta_other": "{{count}} упражнений",
    "importPlanAction_one": "Добавить {{name}} в этот день ({{meta}}), в единственную неделю цикла",
    "importPlanAction_few": "Добавить {{name}} в этот день ({{meta}}), во все {{count}} недели цикла",
    "importPlanAction_many": "Добавить {{name}} в этот день ({{meta}}), во все {{count}} недель цикла",
    "importPlanAction_other": "Добавить {{name}} в этот день ({{meta}}), во все {{count}} недель цикла",
    "removeSlotConfirmTitle_one": "Убрать из этой недели?",
    "removeSlotConfirmTitle_few": "Убрать из всех {{count}} недель?",
    "removeSlotConfirmTitle_many": "Убрать из всех {{count}} недель?",
    "removeSlotConfirmTitle_other": "Убрать из всех {{count}} недель?",
    "removeSlotConfirm_one": "Убрать {{name}} из этого дня? Назначение на эту неделю будет удалено.",
    "removeSlotConfirm_few": "Убрать {{name}} из этого дня? Будут удалены назначения на все {{count}} недели, а не только на показанную.",
    "removeSlotConfirm_many": "Убрать {{name}} из этого дня? Будут удалены назначения на все {{count}} недель, а не только на показанную.",
    "removeSlotConfirm_other": "Убрать {{name}} из этого дня? Будут удалены назначения на все {{count}} недель, а не только на показанную.",
    "metaDays_one": "{{count}} тренировочный день",
    "metaDays_few": "{{count}} тренировочных дня",
    "metaDays_many": "{{count}} тренировочных дней",
    "metaDays_other": "{{count}} тренировочных дня",
    "gridToggle": "Сетка интенсивности",
    "addDay": "Добавить день",
    "removeDay": "Удалить день D{{n}}",
    "removeDayConfirm": "Подтвердить: удалить день D{{n}}?",
    "dayEmpty": "В этом дне пока нет упражнений. Добавьте одно, чтобы начать.",
    "prescribeDayEmpty": "В этом дне пока нет упражнений.",
    "prescribeFocusEmpty": "Выберите упражнение выше, чтобы задать его подходы.",
    "prescribeViewMatrix": "Матрица",
    "prescribeViewEditor": "Редактор",
    "prescribeViewGroup": "Переключить вид",
    "checkEmptyCell": "W{{w}}·D{{d}} без упражнений",
    "checkPctNoMax": "{{name}} использует %MAX без сохранённого MAX",
    "exerciseNote": "Заметка к упражнению",
    "exerciseNotePlaceholder": "Заметка к упражнению (видна при записи)",
    "warnLine_one": "{{count}} предупреждение",
    "warnLine_few": "{{count}} предупреждения",
    "warnLine_many": "{{count}} предупреждений",
    "warnLine_other": "{{count}} предупреждения",
    "adjacencyWarnLine_one": "{{count}} предупреждение о восстановлении мышц",
    "adjacencyWarnLine_few": "{{count}} предупреждения о восстановлении мышц",
    "adjacencyWarnLine_many": "{{count}} предупреждений о восстановлении мышц",
    "adjacencyWarnLine_other": "{{count}} предупреждения о восстановлении мышц",
    "adjacencyWarnItem": "{{muscle}}: нагрузка в смежные дни ({{count}}×)",
    "weekShort": "Неделя",
    "placed": "включено",
    "notPlaced": "выключено",
    "placementHint": "Удерживайте ячейку, чтобы поставить или убрать «{{exercise}}» там.",
    "addWeek": "Добавить пустую неделю",
    "removeWeek": "Удалить неделю",
    "holdDayToRemoveHint": "Удерживайте день, чтобы удалить его",
    "holdWeekToRemoveHint": "Удерживайте неделю, чтобы удалить её",
    "holdAddWeekToCloneHint": "Удерживайте W ＋, чтобы повторить эту неделю",
    "holdCellToPlaceHint": "Удерживайте ячейку, чтобы поставить туда упражнение",
    "cloneWeekAction": "Добавить неделю, повторяющую эту",
    "removeWeekConfirm": "Подтвердить: удалить эту неделю и её подходы",
    "coverageTitle": "Покрытие: тяжёлые подходы/неделя",
    "coverageHint": "Среднее за весь цикл. Ноль виден здесь ещё до тренировки.",
    "rosterNotThisWeek": "не на этой неделе",
    "dayWeekCursor": "D{{d}}·W{{w}}",
    "prescribeNotThisWeek": "{{exercise}} не запланировано на {{cursor}}.",
    "prescribeLockedNewFields": "У {{exercise}} подходы по кругам, диапазон повторений или смешанные оси нагрузки. Здесь только просмотр: изменить можно на телефоне.",
    "prescribePlaceHere": "Поставить на {{cursor}}",
    "placementAddHere": "Поставить «{{exercise}}» сюда",
    "placementRemoveHere": "Убрать «{{exercise}}» отсюда",
    "weekCue": "Неделя {{pos}} из {{total}}. Нажмите для следующей недели.",
    "weekCuePrev": "Предыдущая неделя",
    "targetRefThisWeek": "последние 7 дней {{n}}",
    "setNoteChip": "Заметка",
    "setNoteChipA11y": "Написать заметку к подходу этого круга",
    "weekMenuHint": "Открывает меню круга",
    "weekMenuHoldHint": "Нажмите для меню круга. Удерживайте, чтобы удалить круг.",
    "setNoteChipLocked": "Видно, пока у подхода есть заметка",
    "importProgramBack": "Назад к программам",
    "importProgramDayHint": "Его упражнения добавляются в конец дня, который вы редактируете. Лишние круги отбрасываются, недостающие остаются пустыми.",
    "importProgramDayAction": "Добавить {{day}} из {{program}} в этот день ({{meta}})",
    "importProgramEmpty": "Других программ пока нет.",
    "importProgramOpen": "{{name}} ({{meta}}): выберите день",
    "importProgramDays_one": "{{count}} день",
    "importProgramDays_few": "{{count}} дня",
    "importProgramDays_many": "{{count}} дней",
    "importProgramDays_other": "{{count}} дня",
    "importProgramRounds_one": "{{count}} круг",
    "importProgramRounds_few": "{{count}} круга",
    "importProgramRounds_many": "{{count}} кругов",
    "importProgramRounds_other": "{{count}} круга"
  },
  "gym": {
    "setPlace": "Где?",
    "whichPlace": "Где вы тренируетесь?",
    "newPlace": "Добавить место",
    "fallback": "По умолчанию",
    "chipA11y": "Место тренировки",
    "footnote": "Определяет порядок показа. Тренеру не передаётся.",
    "namePlaceTitle": "Назовите это место",
    "namePlaceHint": "Название места",
    "namePlaceSave": "Использовать это место",
    "pinPlace": "Сделать {{place}} местом по умолчанию",
    "unpinPlace": "Убрать {{place}} как место по умолчанию",
    "pinHint": "Запоминает это как место, где вы обычно тренируетесь.",
    "unpinHint": "Забывает ваше место по умолчанию.",
    "pinErrorTitle": "Не сохранено",
    "pinErrorBody": "Ваше место по умолчанию не изменилось."
  },
  "inbox": {
    "emptyTitle": "Входящие",
    "emptyBody": "Сейчас нет ничего, что ждёт ответа.",
    "accept": "Принять",
    "decline": "Отклонить",
    "acknowledge": "Понятно",
    "feedback": {
      "statusChanged": {
        "title": "Ваше сообщение",
        "body": "Ваше сообщение отмечено как {{status}}."
      }
    },
    "sessionCorrection": {
      "orphaned": {
        "title": "Исправление ждёт на другом телефоне",
        "body": "Тренировку с вашим исправлением удалили на другом устройстве. Исправление осталось на телефоне, где вы его сохранили: откройте там «Уведомления» (колокольчик) и нажмите «Сохранить как новую»."
      }
    },
    "maxBump": {
      "raise": {
        "title": "Новый MAX",
        "body": "{{exercise}}: тренировка показывает новый MAX {{suggestedKg}}."
      },
      "lower": {
        "title": "MAX мог снизиться",
        "body": "{{exercise}}: тренировка показывает {{suggestedKg}}. Ваш MAX {{currentKg}}, установлен {{weeks}}."
      },
      "confirm": "Подтвердить",
      "lowerTo": "Снизить до {{suggestedKg}}",
      "skip": "Пропустить",
      "keep": "Оставить {{currentKg}}",
      "badDay": "Плохой день",
      "thisWeek": "на этой неделе",
      "weeksAgo_one": "{{count}} неделю назад",
      "weeksAgo_few": "{{count}} недели назад",
      "weeksAgo_many": "{{count}} недель назад",
      "weeksAgo_other": "{{count}} недели назад",
      "badDayHint": "Оставляет ваш MAX и молчит об этом упражнении, пока спад не повторится."
    },
    "bodyweight": {
      "missing": {
        "title": "Вес тела не указан",
        "body": "Для упражнений с собственным весом нужен ваш вес, чтобы рассчитать нагрузку и объём. Добавьте его в Я → Замеры.",
        "cta": "Добавить вес",
        "dismiss": "Не напоминать"
      }
    },
    "coachEdge": {
      "invitedByCoach": {
        "title": "Приглашение от тренера",
        "body": "Тренер пригласил вас стать его подопечным."
      },
      "invitedByAthlete": {
        "title": "Запрос на тренерство",
        "body": "Спортсмен пригласил вас стать его тренером."
      }
    },
    "assignment": {
      "program": {
        "title": "Новая программа",
        "body": "{{from}} хочет назначить вам {{itemName}}.",
        "bodySelf": "Вы отправили себе {{itemName}} как тренер. Ниже вы можете принять или отклонить."
      },
      "plan": {
        "title": "Новый план",
        "body": "{{from}} хочет назначить вам {{itemName}}.",
        "bodySelf": "Вы отправили себе {{itemName}} как тренер. Ниже вы можете принять или отклонить."
      },
      "accepted": {
        "title": "Назначение принято",
        "body": "{{itemName}} принято."
      },
      "rejected": {
        "title": "Назначение отклонено",
        "body": "{{itemName}} отклонено."
      }
    },
    "followedProgram": {
      "updated": {
        "title": "Программа обновлена",
        "body": "Автор изменил {{itemName}}."
      },
      "removed": {
        "title": "Программа больше не доступна",
        "body": "У вас больше нет доступа к {{itemName}}."
      },
      "gone": {
        "title": "Программа удалена",
        "body": "Автор удалил {{itemName}}."
      }
    },
    "followedPlan": {
      "updated": {
        "title": "План обновлён",
        "body": "Автор изменил {{itemName}}."
      },
      "removed": {
        "title": "План больше не доступен",
        "body": "У вас больше нет доступа к {{itemName}}."
      },
      "gone": {
        "title": "План удалён",
        "body": "Автор удалил {{itemName}}."
      }
    },
    "actionError": "Не получилось. Повторите попытку.",
    "actionErrorItemGone": "Это предложение больше недоступно. Нажмите «Отклонить», чтобы убрать карточку.",
    "bell": {
      "label": "Оповещения",
      "title": "Уведомления",
      "close": "Закрыть уведомления",
      "a11y_one": "{{count}} уведомление",
      "a11y_few": "{{count}} уведомления",
      "a11y_many": "{{count}} уведомлений",
      "a11y_other": "{{count}} уведомления"
    },
    "actionErrorNoLongerAssigned": "Отправитель его отозвал. Нажмите «Отклонить», чтобы убрать карточку.",
    "actionErrorWrongParty": "Ответить может только приглашённый.",
    "actionErrorFanout": "Не удалось добавить в вашу библиотеку. Повторите попытку.",
    "loadError": "Не удалось загрузить уведомления.",
    "retry": "Повторить",
    "local": {
      "eyebrow": "Этот телефон",
      "action": {
        "open": "Открыть",
        "hide": "Скрыть",
        "retry": "Повторить",
        "details": "Подробности",
        "retrying": "Новая попытка…",
        "resume": "Продолжить",
        "discard": "Удалить",
        "merge": "Объединить",
        "sendSupport": "Отправить в поддержку",
        "sending": "Отправка…"
      },
      "hcNoConsent": {
        "title": "Health Connect отключён",
        "body": "В вашем аккаунте нет согласия для Health Connect, поэтому этот телефон перестал импортировать данные. То, что он уже прочитал, ждёт здесь, пока вы не подключитесь снова."
      },
      "hcRefusalTitle": {
        "granted": "Согласие не записано",
        "revoked": "Отзыв не записан",
        "revokedElsewhere": "Health Connect отключён"
      },
      "hcDriftTitle": {
        "deviceOff": "Health Connect не разрешён на этом телефоне",
        "undated": "Подтвердите согласие для Health Connect",
        "noRecord": "Подтвердите согласие для Health Connect"
      },
      "hcUpdate": {
        "title": "Обновите Health Connect",
        "body": "$t(brand.product) не сможет читать Health Connect, пока вы не обновите его приложение."
      },
      "stuckWrites": {
        "title_one": "{{count}} запись не прошла",
        "title_few": "{{count}} записи не прошли",
        "title_many": "{{count}} записей не прошло",
        "title_other": "{{count}} записей не прошло",
        "body": "Этот телефон уже повторил попытку сам. Повторите сейчас или откройте подробности, чтобы увидеть, что не прошло.",
        "bodyStill": "Только что попробовали снова, без результата. Откройте подробности, чтобы увидеть ответ сервера по каждой записи."
      },
      "profileName": {
        "title": "Ваше имя не сохранено",
        "body": "Не удалось сохранить ваше имя при первом входе. Нажмите, чтобы добавить его в разделе «Аккаунт»."
      },
      "autoSaved": {
        "title": "Тренировка сохранена автоматически",
        "body": "Тренировка {{date}} осталась открытой без ответа и была сохранена с выполненными подходами. Нажмите, чтобы изменить её.",
        "keptTitle": "Тренировка закрыта без сохранения",
        "keptBody": "Тренировка {{date}} осталась открытой без ответа. Она закрыта без сохранения, и этот телефон её сохранил. Нажмите, чтобы продолжить."
      },
      "draftResume": {
        "title": "Тренировка не сохранена",
        "body": "Приложение закрылось во время вашей тренировки {{date}}, она всё ещё на этом телефоне. Чтобы удалить её, нажмите «Удалить» в «Уведомлениях». Нажмите, чтобы продолжить.",
        "discardTitle": "Удалить тренировку?",
        "discardBody": "Подходы тренировки {{date}} так и не были сохранены. Если удалить её, они пропадут с этого телефона навсегда."
      },
      "workoutRecovery": {
        "title": "Несохранённая тренировка {{date}}",
        "titleCorrection": "Исправление {{date}} не сохранено",
        "body": "Приложение закрылось до того, как тренировка была сохранена, и этот телефон её сохранил. Подходов выполнено: {{done}} из {{total}}. Сохраните её как новую, объедините с тренировкой того же дня или удалите.",
        "bodySent": "Отправлено в поддержку. Тренировка остаётся на этом телефоне, пока вы её не сохраните, не объедините или не удалите."
      }
    },
    "actionErrorOffline": "Для этого нужно подключение. Подключитесь и повторите попытку."
  },
  "editorV3": {
    "addExerciseToRound": "Добавить {{name}} в W{{n}}",
    "addToRound": "Добавить в W{{n}}",
    "alignTrimHint": "Удаляет лишние подходы в конце. «Отменить» в сообщении вернёт их.",
    "backToDay": "Назад к {{day}}",
    "clear": "Очистить день",
    "clearBody_one": "Будет удалено {{count}} упражнение.",
    "clearBody_few": "Будет удалено {{count}} упражнения.",
    "clearBody_many": "Будет удалено {{count}} упражнений.",
    "clearBody_other": "Будет удалено {{count}} упражнения.",
    "clearTitle": "Очистить {{day}}?",
    "copyName": "{{name}} (копия)",
    "copyOnto": "Копировать в…",
    "copyOntoBody_one": "В {{day}} {{count}} упражнение. Его заменит копия {{from}}.",
    "copyOntoBody_few": "В {{day}} {{count}} упражнения. Их заменит копия {{from}}.",
    "copyOntoBody_many": "В {{day}} {{count}} упражнений. Их заменит копия {{from}}.",
    "copyOntoBody_other": "В {{day}} {{count}} упражнения. Их заменит копия {{from}}.",
    "copyOntoFootnote": "Выбранный день потеряет то, что в нём сейчас.",
    "copyOntoQuestion": "В какой день копировать {{day}}?",
    "copyOntoTitle": "Заменить {{day}}?",
    "copyRoundBody_few": "В {{round}} {{count}} упражнения по всем дням. Их заменит копия {{from}}.",
    "copyRoundBody_many": "В {{round}} {{count}} упражнений по всем дням. Их заменит копия {{from}}.",
    "copyRoundBody_one": "В {{round}} {{count}} упражнение по всем дням. Его заменит копия {{from}}.",
    "copyRoundBody_other": "В {{round}} {{count}} упражнения по всем дням. Их заменит копия {{from}}.",
    "copyRoundFootnote": "Выбранный круг потеряет то, что в нём сейчас, во всех днях.",
    "copyRoundQuestion": "В какой круг копировать {{round}}?",
    "copyRoundTitle": "Заменить {{round}}?",
    "dayChipA11y": "День {{n}} {{name}}",
    "dayCleared": "{{day}} очищен",
    "dayCopied": "Скопировано в {{day}}",
    "dayDuplicated": "День продублирован",
    "dayEmpty": "В {{day}} пока нет упражнений.",
    "dayMenuA11y": "{{day}}, меню дня",
    "dayName": "Название дня",
    "dayRemoved": "{{day}} удалён",
    "daysA11y": "Дни",
    "dissolveSuperset": "Распустить суперсет",
    "duplicateDay": "Дублировать день",
    "duplicateRound": "Дублировать круг",
    "exerciseMenuA11y": "{{name}}, меню",
    "exerciseRemoved": "{{name}} удалено",
    "exerciseTipA11y": "Об упражнении {{name}}",
    "historyLoad": "как в прошлый раз",
    "lensA11y": "Показать день по",
    "lensExercises": "Упражнения",
    "lensRound": "По кругу",
    "moveDayEarlier": "Переместить раньше",
    "moveDayLater": "Переместить позже",
    "moveRoundEarlier": "Переместить раньше",
    "moveRoundLater": "Переместить позже",
    "notInRound": "Не в этом круге",
    "offRoundOnlyInDay": "Единственное упражнение этого дня в W{{n}}",
    "offRoundOnlyRound": "Его нет ни в одном другом круге",
    "remove": "Удалить",
    "removeDay": "Удалить день",
    "removeDayBody_one": "День удаляется вместе с {{count}} упражнением.",
    "removeDayBody_few": "День удаляется вместе с {{count}} упражнениями.",
    "removeDayBody_many": "День удаляется вместе с {{count}} упражнениями.",
    "removeDayBody_other": "День удаляется вместе с {{count}} упражнениями.",
    "removeDayEmptyBody": "День пуст.",
    "removeDayTitle": "Удалить {{day}}?",
    "removeExerciseBody": "Оно уходит из этого дня во всех кругах.",
    "removeExerciseTitle": "Удалить {{name}}?",
    "removeFromRound": "Убрать из W{{n}}",
    "removeRound": "Удалить W{{n}}",
    "removeRoundBody": "Его подходы уйдут из всех дней. Следующие круги сдвинутся на одно место раньше.",
    "removeRoundTitle": "Удалить W{{n}}?",
    "removedFromRound": "{{name}} убрано из W{{n}}",
    "renameDay": "Переименовать",
    "renameSuperset": "Переименовать суперсет",
    "renameTitle": "Переименовать {{day}}",
    "replace": "Заменить",
    "replaceExercise": "Заменить упражнение",
    "roundA11y": "Круг {{n}}: {{line}}",
    "roundChipA11y": "Круг {{n}}",
    "roundCopied": "Скопировано в {{round}}",
    "roundDuplicated": "W{{n}} продублирован",
    "roundLastInDay": "{{name}}: единственное упражнение этого дня в W{{n}}. Удалите упражнение или круг.",
    "roundLastOfExercise": "W{{n}}: единственный круг, где есть {{name}}. Удалите упражнение.",
    "roundScope": "Повторения, нагрузка и секунды меняются только в этом круге. Ось, ограничение по времени и подходы меняются во всех кругах.",
    "roundScopeLens": "Повторения, нагрузка, секунды и подходы меняются только в этом круге. Ось и ограничение по времени меняются во всех кругах.",
    "alignPadEachRound": "+ Дополнить до самого длинного в каждом круге",
    "alignTrimEachRound": "− Сократить до самого короткого в каждом круге",
    "setsTrimmedEachRound": "Суперсет создан, подходы сокращены до самого короткого в каждом круге",
    "roundSetAdded": "W{{n}}: на один подход больше",
    "roundSetRemoved": "W{{n}}: на один подход меньше",
    "roundSetCount_one": "W{{n}}: {{count}} подход",
    "roundSetCount_few": "W{{n}}: {{count}} подхода",
    "roundSetCount_many": "W{{n}}: {{count}} подходов",
    "roundSetCount_other": "W{{n}}: {{count}} подхода",
    "roundOnlySet": "В W{{n}} остался один подход. Лучше уберите упражнение из круга.",
    "roundMixedBound": "W{{n}} без изменений: подход на время и подход на повторения поменялись бы местами.",
    "setRangeA11y": "от {{lo}} до {{hi}} подходов по",
    "roundsA11y": "Круги",
    "secondsUnit": "с",
    "setsTrimmed": "Суперсет создан, подходы сокращены до {{n}}",
    "sideRead": "Сторона: {{side}}",
    "supersetN": "Суперсет {{n}}",
    "supersetName": "Название суперсета",
    "supersetNameHint": "Оставьте пустым, чтобы вернуть номер.",
    "supersetWithNext": "Суперсет со следующим упражнением",
    "variants": "Чередуется с {{names}}. Здесь пока не редактируется.",
    "problems_one": "{{count}} проблема",
    "problems_few": "{{count}} проблемы",
    "problems_many": "{{count}} проблем",
    "problems_other": "{{count}} проблемы",
    "problemPrev": "Предыдущая проблема, {{n}} из {{total}}",
    "problemNext": "Следующая проблема, {{n}} из {{total}}",
    "problemGoA11y": "Проблема {{n}} из {{total}}, {{where}}: {{message}}. Перейти",
    "select": "Выбрать",
    "selectDone": "Готово",
    "selectA11y": "Выбрать упражнения в {{day}}",
    "selectDoneA11y": "Закончить выбор в {{day}}",
    "copyToOtherDays": "Копировать в другие дни",
    "copyTo": "Копировать в…",
    "copyToDaysQuestion": "В какие дни скопировать {{what}}?",
    "copyToDaysFootnote": "Каждый день получает свою копию, в конце. Суперсет копируется целиком.",
    "copyToDaysNone": "Копировать",
    "copyToDaysConfirm_one": "Копировать в {{count}} день",
    "copyToDaysConfirm_few": "Копировать в {{count}} дня",
    "copyToDaysConfirm_many": "Копировать в {{count}} дней",
    "copyToDaysConfirm_other": "Копировать в {{count}} дня",
    "copiedToDays": "Скопировано в {{days}}.",
    "addedOneToDays": "{{name}} добавлено в {{days}}.",
    "addedManyToDays_one": "{{count}} упражнение добавлено в {{days}}.",
    "addedManyToDays_few": "{{count}} упражнения добавлены в {{days}}.",
    "addedManyToDays_many": "{{count}} упражнений добавлено в {{days}}.",
    "addedManyToDays_other": "{{count}} упражнения добавлены в {{days}}.",
    "addedAgain_one": "В {{days}} оно уже было: теперь оно там дважды.",
    "addedAgain_few": "В {{days}} некоторые уже были: теперь они там дважды.",
    "addedAgain_many": "В {{days}} некоторые уже были: теперь они там дважды.",
    "addedAgain_other": "В {{days}} некоторые уже были: теперь они там дважды.",
    "valuesFromRole": "Значения по роли дня.",
    "removeSelectedTitle_one": "Удалить {{count}} упражнение?",
    "removeSelectedTitle_few": "Удалить {{count}} упражнения?",
    "removeSelectedTitle_many": "Удалить {{count}} упражнений?",
    "removeSelectedTitle_other": "Удалить {{count}} упражнения?",
    "removeSelectedBody_one": "Оно уходит из этого дня во всех кругах.",
    "removeSelectedBody_few": "Они уходят из этого дня во всех кругах.",
    "removeSelectedBody_many": "Они уходят из этого дня во всех кругах.",
    "removeSelectedBody_other": "Они уходят из этого дня во всех кругах.",
    "selectedRemoved_one": "{{count}} упражнение удалено",
    "selectedRemoved_few": "{{count}} упражнения удалены",
    "selectedRemoved_many": "{{count}} упражнений удалено",
    "selectedRemoved_other": "{{count}} упражнения удалены",
    "nExercises_one": "{{count}} упражнение",
    "nExercises_few": "{{count}} упражнения",
    "nExercises_many": "{{count}} упражнений",
    "nExercises_other": "{{count}} упражнения",
    "selectedCount_one": "Выбрано: {{count}}",
    "selectedCount_few": "Выбрано: {{count}}",
    "selectedCount_many": "Выбрано: {{count}}",
    "selectedCount_other": "Выбрано: {{count}}",
    "programDayImported": "{{day}} из {{program}} добавлен.",
    "roundsDropped_one": "{{rounds}} не вошёл: в этой программе меньше кругов.",
    "roundsDropped_few": "{{rounds}} не вошли: в этой программе меньше кругов.",
    "roundsDropped_many": "{{rounds}} не вошли: в этой программе меньше кругов.",
    "roundsDropped_other": "{{rounds}} не вошли: в этой программе меньше кругов.",
    "daysFull_one": "В {{days}} было бы больше {{max}} упражнений: туда ничего не добавлено.",
    "daysFull_few": "В {{days}} было бы больше {{max}} упражнений: туда ничего не добавлено.",
    "daysFull_many": "В {{days}} было бы больше {{max}} упражнений: туда ничего не добавлено.",
    "daysFull_other": "В {{days}} было бы больше {{max}} упражнений: туда ничего не добавлено.",
    "importNothing": "Ничего не добавлено: в {{day}} нет упражнений в кругах этой программы.",
    "roundTypeMenu": "Тип круга…",
    "roundTypeQuestion": "Какого типа круг {{round}}?",
    "roundTypeNormal": "Обычный",
    "roundTypeDeload": "Разгрузка",
    "roundTypeTest": "Тест",
    "roundTypedA11y": "Круг {{n}}, {{type}}: {{line}}",
    "roundChipTypedA11y": "Круг {{n}}, {{type}}",
    "roundTypeSet": "W{{n}}: {{type}}. Применено ко всей программе.",
    "roundRemovedByRules": "W{{n}} удалён. Ячейки, введённые вручную после него, сдвигаются вместе со своим кругом.",
    "roundTypeFootnoteRules": "Тип действует на всю программу. Каждое упражнение получает эффект по своему правилу.",
    "rule": {
      "name": {
        "constant": "Постоянно",
        "effortRamp": "Рост усилия",
        "tetrad": "Тетрада, тест и разгрузка",
        "perSet": "По подходам",
        "linear": "Линейно",
        "repsThenLoad": "Повторения, затем вес",
        "triple": "Тройная прогрессия",
        "timed": "На время",
        "history": "Как в прошлый раз",
        "waves": "Волны",
        "blocks": "Блоками",
        "pyramid": "Пирамида",
        "repsUp": "Растущие повторения",
        "topBackoff": "Топ-подход и бэк-офф"
      },
      "preset": {
        "linearKg": "Линейно в кг"
      },
      "manual": "Значения вручную",
      "manualBody": "Правило не распознано. Каждую ячейку можно менять вручную.",
      "manualBodyRead": "Правило не распознано: каждый круг записан отдельно.",
      "title": "Правило · {{name}}",
      "perRound": "{{step}} за круг",
      "upTo": "{{what}} до {{cap}}",
      "ramp_one": "от {{from}} до {{to}} за {{count}} круг",
      "ramp_few": "от {{from}} до {{to}} за {{count}} круга",
      "ramp_many": "от {{from}} до {{to}} за {{count}} кругов",
      "ramp_other": "от {{from}} до {{to}} за {{count}} круга",
      "cycle": "по очереди {{values}}",
      "blocks_one": "{{count}} блок, начинается заново",
      "blocks_few": "{{count}} блока, каждый начинается заново",
      "blocks_many": "{{count}} блоков, каждый начинается заново",
      "blocks_other": "{{count}} блока, каждый начинается заново",
      "threshold": "повторения от {{min}} до {{max}} по {{step}}",
      "thenSets": "затем подходы до {{n}}",
      "thenLoad": "затем {{step}}",
      "repsStep": "{{step}} повт.",
      "amrapInTest": "последний подход AMRAP в тестовом круге",
      "testLast": "тест {{step}} в последнем подходе",
      "testTop": "тест {{step}} в самых тяжёлых подходах",
      "test": "тест {{step}}",
      "deloadPct": "разгрузка {{pct}}%",
      "deload": "разгрузка {{step}}",
      "deloadEffort": "разгрузка {{value}}",
      "deloadSets_one": "на {{count}} подход меньше в разгрузке",
      "deloadSets_few": "на {{count}} подхода меньше в разгрузке",
      "deloadSets_many": "на {{count}} подходов меньше в разгрузке",
      "deloadSets_other": "на {{count}} подхода меньше в разгрузке",
      "same": "одинаково в каждом круге",
      "applied": "Правило изменено. Применено к кругам, которые ему следуют.",
      "appliedMany_one": "Правило применено к {{count}} упражнению. Применено к кругам, которые ему следуют.",
      "appliedMany_few": "Правило применено к {{count}} упражнениям. Применено к кругам, которые ему следуют.",
      "appliedMany_many": "Правило применено к {{count}} упражнениям. Применено к кругам, которые ему следуют.",
      "appliedMany_other": "Правило применено к {{count}} упражнения. Применено к кругам, которые ему следуют.",
      "rowRealigned": "Строка снова по правилу.",
      "roundRealigned": "{{round}} снова по правилу.",
      "blockAdded": "Добавлены {{from}}-{{to}}.",
      "byHand": "{{round}}, подход {{set}}: введено вручную. Применено только здесь.",
      "followsAgain": "Снова следует правилу.",
      "handCount_one": "{{count}} ячейка вручную",
      "handCount_few": "{{count}} ячейки вручную",
      "handCount_many": "{{count}} ячеек вручную",
      "handCount_other": "{{count}} ячейки вручную",
      "handDone_one": "{{count}} вручную в выполненных кругах",
      "handDone_few": "{{count}} вручную в выполненных кругах",
      "handDone_many": "{{count}} вручную в выполненных кругах",
      "handDone_other": "{{count}} вручную в выполненных кругах",
      "realign": "Выровнять",
      "realignHint": "Все ячейки снова по правилу",
      "change": "Изменить правило",
      "byHandMark": "вручную",
      "realignRound": "Выровнять {{round}} по правилу",
      "typedStays": "Значение, введённое здесь, остаётся вашим: правило его не перезапишет.",
      "addBlock_one": "{{count}} круг",
      "addBlock_few": "{{count}} круга",
      "addBlock_many": "{{count}} кругов",
      "addBlock_other": "{{count}} круга",
      "blockAdd_one": "Добавить {{count}} круг",
      "blockAdd_few": "Добавить {{count}} круга",
      "blockAdd_many": "Добавить {{count}} кругов",
      "blockAdd_other": "Добавить {{count}} круга",
      "blockTitle": "Добавить {{from}}-{{to}}",
      "blockShape": "Ещё одна тетрада: два обычных круга, один тестовый, один разгрузочный.",
      "blockCarry": "Строки с весом и повторениями продолжаются. Повторения в диапазоне начинаются заново; записанный вес растёт на один шаг.",
      "blockEffort": "Строки по усилию повторяют форму. Вес растёт вместе с MAX, измеренным в тестовом круге.",
      "blockFocus": "Новые круги следуют модели с этой целью. Прежние круги остаются как были.",
      "sheetTitle": "Правило",
      "sheetTitleMany_one": "Правило для {{count}} упражнения",
      "sheetTitleMany_few": "Правило для {{count}} упражнений",
      "sheetTitleMany_many": "Правило для {{count}} упражнений",
      "sheetTitleMany_other": "Правило для {{count}} упражнения",
      "apply": "Применить",
      "presets": "Шаблоны",
      "changes": "меняется",
      "roundsChange_one": "Меняется {{count}} круг.",
      "roundsChange_few": "Меняются {{count}} круга.",
      "roundsChange_many": "Меняются {{count}} кругов.",
      "roundsChange_other": "Меняются {{count}} круга.",
      "alsoTitle": "Применить также к:",
      "alsoSame": "То же упражнение, другие дни",
      "alsoOthers": "Другие упражнения",
      "alsoShowAll": "Показать все",
      "alsoShowLess": "Показать меньше",
      "alsoEach": "У каждого упражнения свои стартовые значения.",
      "lostTest": "Без AMRAP в тестовом круге.",
      "lostTestMany": "Без AMRAP в тестовом круге: {{names}}.",
      "lostDeload": "Без разгрузки.",
      "lostDeloadMany": "Без разгрузки: {{names}}.",
      "stallNever": "В этих кругах вес не растёт.",
      "stallAt": "В этих кругах вес не растёт. Первый рост: {{round}}.",
      "noRoundChanges": "Ни один круг не меняется.",
      "handStays_one": "{{count}} ячейка вручную остаётся.",
      "handStays_few": "{{count}} ячейки вручную остаются.",
      "handStays_many": "{{count}} ячеек вручную остаются.",
      "handStays_other": "{{count}} ячейки вручную остаются.",
      "supersetFollows": "Суперсет получает то же число подходов.",
      "undoable": "Можно отменить.",
      "waveLess": "На одно значение меньше в цикле",
      "waveMore": "На одно значение больше в цикле",
      "selectionAction": "Правило",
      "field": {
        "sets": "Подходы",
        "reps": "Повторения",
        "effort": "Усилие",
        "step": "Шаг за круг",
        "cap": "Предел",
        "load": "От",
        "deloadPct": "Разгрузка",
        "repsMin": "Повт. мин",
        "repsMax": "Повт. макс",
        "repsStep": "Шаг повт.",
        "loadStep": "Затем",
        "seconds": "Секунды",
        "efforts": "Усилия цикла",
        "setsMax": "Подходы до",
        "repsSetStep": "Повт. на подход",
        "loadSetStep": "Вес на подход",
        "backoffSets": "Бэк-офф подходы",
        "topEffort": "Усилие топ-подхода",
        "backoffEffort": "Усилие бэк-офф",
        "off": "Нет"
      },
      "backoff": "бэк-офф подходы {{step}}",
      "eachSet": "каждый подход {{steps}}",
      "handAxisResets_one": "{{count}} значение, введённое вручную, заменяется: новое правило использует другую единицу.",
      "handAxisResets_few": "{{count}} значения, введённые вручную, заменяются: новое правило использует другую единицу.",
      "handAxisResets_many": "{{count}} значений, введённых вручную, заменяются: новое правило использует другую единицу.",
      "handAxisResets_other": "{{count}} значения, введённые вручную, заменяются: новое правило использует другую единицу.",
      "lockedStay": "Выполнено до {{round}}: эти круги остаются как есть.",
      "reference": "ориент. ≈ {{load}}",
      "pickPreset": "Ни один шаблон не записывает это правило. Выберите шаблон, чтобы заменить его.",
      "pickPresetManual": "Правило не распознано. Выберите шаблон, чтобы заменить значения, введённые вручную.",
      "blockFull": "В программе не больше {{max}} кругов: для ещё одной тетрады нет места."
    },
    "tetrad": {
      "scratchTitle": "С нуля",
      "scratchBody": "Один пустой день и четыре круга.",
      "rounds": "Круги",
      "roundsA11y_one": "{{count}} круг",
      "roundsA11y_few": "{{count}} круга",
      "roundsA11y_many": "{{count}} кругов",
      "roundsA11y_other": "{{count}} круга",
      "perWeek": "Тренировок в неделю",
      "perWeekA11y_one": "{{count}} тренировка в неделю",
      "perWeekA11y_few": "{{count}} тренировки в неделю",
      "perWeekA11y_many": "{{count}} тренировок в неделю",
      "perWeekA11y_other": "{{count}} тренировки в неделю",
      "dayEmpty": "Нет упражнений: дню нужно хотя бы одно.",
      "removeExercise": "Убрать {{name}}",
      "back": "Назад",
      "needName": "Сначала дайте программе название.",
      "needDay": "Каждому дню нужно хотя бы одно упражнение: верните одно.",
      "putBack": "Вернуть {{name}}",
      "takenOut": "убрано"
    },
    "model": {
      "fromModel": "Из модели",
      "fromModelBody": "Модель задаёт дни и круги. Вы выбираете уровень, время на тренировку и упражнения.",
      "fromTemplate": "Из шаблона",
      "fromTemplateBody": "Копия публичной программы, которую можно менять как угодно.",
      "readyAsk": "Нужна готовая программа?",
      "noTemplate": "Шаблонов пока нет.",
      "loading": "Загрузка…",
      "loadError": "Не удалось загрузить. Нажмите, чтобы повторить.",
      "level": "Уровень",
      "minutes": "Минут на тренировку",
      "minutesA11y_one": "{{count}} минута",
      "minutesA11y_few": "{{count}} минуты",
      "minutesA11y_many": "{{count}} минут",
      "minutesA11y_other": "{{count}} минуты",
      "minutes45": "Без необязательных упражнений и на один подход меньше во вспомогательных.",
      "minutes60": "Без необязательных упражнений.",
      "minutes75": "Все упражнения.",
      "nameMinutes": "{{n}} мин",
      "nameFollows": "Название следует вашему выбору, пока вы не введёте его сами.",
      "minutesOver": "Внимание: в некоторые дни уложиться в выбранное вами время не получится.",
      "focus": "Цель",
      "focusStrength": "Сила",
      "focusMass": "Масса",
      "focusStrengthHint": "Мало повторений в базовых упражнениях, долгий отдых. День разгрузки остаётся лёгким.",
      "focusMassHint": "Больше подходов и повторений, короче отдых. День разгрузки становится днём объёма.",
      "rotateHint_one": "{{count}} день чередуется: круг длится {{length}} дн.",
      "rotateHint_few": "{{count}} дня чередуются: круг длится {{length}} дн.",
      "rotateHint_many": "{{count}} дней чередуются: круг длится {{length}} дн.",
      "rotateHint_other": "{{count}} дня чередуются: круг длится {{length}} дн.",
      "blocksHint_one": "Программа проходит {{count}} раз.",
      "blocksHint_few": "Программа проходит {{count}} раза: каждый раз на ступень выше.",
      "blocksHint_many": "Программа проходит {{count}} раз: каждый раз на ступень выше.",
      "blocksHint_other": "Программа проходит {{count}} раза: каждый раз на ступень выше.",
      "swapA11y_one": "{{name}}. Альтернатив: {{count}}. Нажмите, чтобы заменить",
      "swapA11y_few": "{{name}}. Альтернатив: {{count}}. Нажмите, чтобы заменить",
      "swapA11y_many": "{{name}}. Альтернатив: {{count}}. Нажмите, чтобы заменить",
      "swapA11y_other": "{{name}}. Альтернатив: {{count}}. Нажмите, чтобы заменить",
      "alternatives": "Альтернативы",
      "alternativesCount_one": "{{count}} альтернатива",
      "alternativesCount_few": "{{count}} альтернативы",
      "alternativesCount_many": "{{count}} альтернатив",
      "alternativesCount_other": "{{count}} альтернативы",
      "mine": "Мои модели",
      "ours": "Модели $t(brand.product)",
      "noMine": "Пока нет. В Библиотеке нажмите «Сохранить как модель» у одной из ваших программ.",
      "deleteTitle": "Удалить эту модель?",
      "deleteBody": "«{{name}}» будет удалена. Программы, созданные по ней, останутся.",
      "deleteError": "Не удалось удалить модель. Попробуйте ещё раз.",
      "deleting": "Удаление…",
      "comeback": "Недели перерыва",
      "comebackNone": "Без перерыва",
      "comebackA11y_one": "{{count}} неделя перерыва",
      "comebackA11y_few": "{{count}} недели перерыва",
      "comebackA11y_many": "{{count}} недель перерыва",
      "comebackA11y_other": "{{count}} недели перерыва",
      "comebackMoreA11y_one": "{{count}} неделя перерыва или больше",
      "comebackMoreA11y_few": "{{count}} недели перерыва или больше",
      "comebackMoreA11y_many": "{{count}} недель перерыва или больше",
      "comebackMoreA11y_other": "{{count}} недели перерыва или больше",
      "comebackOffHint": "Нагрузка, как её задаёт модель.",
      "comebackLightHint": "Нагрузка начинается немного ниже.",
      "comebackSetHint": "Нагрузка начинается ниже, на один подход меньше в каждом упражнении.",
      "comebackOldMax": "Выберите вес, который вы поднимаете сегодня с этим усилием, а не тот, что был до перерыва.",
      "nameComeback": "Возвращение {{n}} нед.",
      "special": "Мышца для акцента",
      "specialNone": "Нет",
      "specialOffHint": "Каждая мышца, как её задаёт модель.",
      "specialHint": "На один подход больше в каждом упражнении, которое прямо нагружает эту мышцу: {{muscle}}.",
      "nameSpecial": "+{{muscle}}"
    },
    "roundLocked": "W{{n}} уже выполнен: он остаётся как есть.",
    "addSetAlign": "Подход не добавлен: в кругах разные подходы. Сначала выровняйте круги.",
    "lock": {
      "unlock": "Разблокировать",
      "unlockA11y": "Разблокировать уже выполненные круги",
      "title": "Разблокировать выполненные круги?",
      "body": "Уже выполненные тренировки берут назначение из программы: изменение {{rounds}} меняет то, что в истории значится назначенным. Они останутся разблокированными, пока вы не закроете редактор.",
      "done": "выполнен",
      "doneA11y": "выполнен, только чтение",
      "offDone": "Не в этом круге, и он уже выполнен: разблокируйте вверху, чтобы добавить упражнение.",
      "readOnly": "{{round}} выполнен: только чтение. Разблокировать можно вверху редактора.",
      "range": "{{from}}-{{to}}"
    },
    "grid": {
      "structure": "Структура",
      "exercise": "Упражнение",
      "lensEffort": "Усилие",
      "lensReps": "Повторения",
      "lensLoad": "Вес",
      "lensSets": "Подходы",
      "dayPeak": "Пик",
      "dayPeakA11y": "Пик: {{band}}",
      "noMaxA11y": "Нет MAX для расчёта нагрузки",
      "loadUnwrittenA11y": "Килограммы ещё не указаны",
      "setsFieldA11y": "{{name}}, {{round}}: подходы в этом круге",
      "setsNote": "Введите подходы одного круга: изменение действует только для этого круга, на весь суперсет.",
      "lensA11y": "Показать в сетке",
      "roundHeadA11y": "{{round}}, меню круга",
      "cellA11y": "{{name}}, {{round}}: {{line}}",
      "note": "Один срез за раз. «Вес» показывает записанный вес или ≈ вес из вашего MAX для строки по усилию. Нажмите на ячейку, чтобы открыть её справа. Писать здесь можно только в срезе «Подходы»: повторы, вес и усилие меняются в панели справа.",
      "noteRead": "Один срез за раз. «Вес» показывает записанный вес или ≈ вес из вашего MAX для строки по усилию. Нажмите на ячейку, чтобы открыть её справа.",
      "pickExercise": "Выберите упражнение в сетке, чтобы увидеть его здесь.",
      "keysNote": "Клавиши: стрелки перемещают, Shift со стрелкой или щелчком выделяет блок, Esc отменяет. Enter открывает упражнение; в «Подходах» ввод начинают Enter и цифра. Ctrl+C копирует, Ctrl+V вставляет (Cmd на Mac). В «Подходах» Ctrl+D заполняет вниз, а Ctrl+R вправо, вместо команд браузера. Перетащите квадратик в углу блока, чтобы заполнить.",
      "effortOfMax": "{{load}} · ≈{{pct}} %",
      "why": {
        "setsOnly": "писать можно только в срезе «Подходы»",
        "off": "упражнения нет в этом круге",
        "locked": "круг уже выполнен",
        "parse": "это не значение для этого среза",
        "lastSet": "в круге остаётся хотя бы один подход",
        "mixedBound": "подход на время и подход на повторения поменялись бы местами"
      },
      "nothingWritten": "Ничего не записано: {{why}}.",
      "cellsWritten_one": "Записана {{count}} ячейка, только в своём круге.",
      "cellsWritten_few": "Записаны {{count}} ячейки, каждая только в своём круге.",
      "cellsWritten_many": "Записано {{count}} ячеек, каждая только в своём круге.",
      "cellsWritten_other": "Записано {{count}} ячейки, каждая только в своём круге.",
      "cellsSkipped_one": "{{count}} осталась как была: {{why}}.",
      "cellsSkipped_few": "{{count}} остались как были: {{why}}.",
      "cellsSkipped_many": "{{count}} остались как были: {{why}}.",
      "cellsSkipped_other": "{{count}} остались как были: {{why}}.",
      "cellsCopied_one": "Скопирована {{count}} ячейка.",
      "cellsCopied_few": "Скопированы {{count}} ячейки.",
      "cellsCopied_many": "Скопировано {{count}} ячеек.",
      "cellsCopied_other": "Скопировано {{count}} ячейки.",
      "cellsSelected_one": "Выбрана {{count}} ячейка",
      "cellsSelected_few": "Выбраны {{count}} ячейки",
      "cellsSelected_many": "Выбрано {{count}} ячеек",
      "cellsSelected_other": "Выбрано {{count}} ячейки",
      "selectA11y": "Выбрать ячейки в {{day}}",
      "selectDoneA11y": "Закончить выбор ячеек в {{day}}",
      "menu": {
        "actions": "Действия",
        "title": "Выбранные ячейки",
        "copy": "Копировать",
        "paste": "Вставить",
        "fillDown": "Заполнить вниз",
        "fillRight": "Заполнить вправо",
        "noClipboardRead": "этот браузер не даёт странице читать буфер обмена",
        "needsRows": "выберите больше одной строки",
        "needsCols": "выберите больше одного круга",
        "clipboardRefused": "Браузер не разрешил доступ к буферу обмена."
      },
      "act": {
        "select": "Начать выделение отсюда",
        "extend": "Расширить выбор досюда",
        "copy": "Копировать выделение",
        "paste": "Вставить в выделение",
        "fillDown": "Заполнить выделение вниз",
        "fillRight": "Заполнить выделение вправо"
      },
      "tapToStart": "Нажмите на ячейку, чтобы начать"
    }
  },
  "simulator": {
    "title": "Симуляция",
    "subtitle": "программа как написана, без истории",
    "summaryOut_one": "{{count}} мышца вне диапазона",
    "summaryOut_few": "{{count}} мышцы вне диапазона",
    "summaryOut_many": "{{count}} мышц вне диапазона",
    "summaryOut_other": "{{count}} мышцы вне диапазона",
    "summaryInBand": "Все тренируемые мышцы в диапазоне",
    "summaryMinutes": "~{{n}} мин за тренировку",
    "roundIsNotWeek_one": "Цифры даны за неделю: в круге {{count}} тренировка, {{week}} в неделю.",
    "roundIsNotWeek_few": "Цифры даны за неделю: в круге {{count}} тренировки, {{week}} в неделю.",
    "roundIsNotWeek_many": "Цифры даны за неделю: в круге {{count}} тренировок, {{week}} в неделю.",
    "roundIsNotWeek_other": "Цифры даны за неделю: в круге {{count}} тренировки, {{week}} в неделю.",
    "musclesTitle": "Тяжёлые подходы в неделю, среднее за цикл",
    "perWeekDays_one": "{{sets}} / нед · {{days}} день",
    "perWeekDays_few": "{{sets}} / нед · {{days}} дня",
    "perWeekDays_many": "{{sets}} / нед · {{days}} дней",
    "perWeekDays_other": "{{sets}} / нед · {{days}} дня",
    "perWeekDaysA11y": "Тяжёлых подходов в неделю: {{sets}}, дней: {{days}}",
    "perWeekIndirect": "{{sets}} / нед · только косвенно",
    "perWeekIndirectA11y": "Тяжёлых подходов в неделю: {{sets}}, все косвенные",
    "direction": {
      "unlikelyToGrow": "скорее всего, мало для роста",
      "likelyToGrow": "в диапазоне, где мышцы растут",
      "diminishingReturns": "больше подходов, мало прибавки"
    },
    "weeksBelow": "ниже MEV: {{weeks}}",
    "weeksAbove": "выше MRV: {{weeks}}",
    "assumed": "из них {{n}} без RPE и RIR, считаются тяжёлыми",
    "notTrained": "Не тренируются: {{names}}",
    "assumedTotal_one": "{{assumed}} из {{count}} тяжёлого подхода без RPE, RIR и правила остановки: считаются тяжёлыми (RIR {{rir}} или меньше).",
    "assumedTotal_few": "{{assumed}} из {{count}} тяжёлых подходов без RPE, RIR и правила остановки: считаются тяжёлыми (RIR {{rir}} или меньше).",
    "assumedTotal_many": "{{assumed}} из {{count}} тяжёлых подходов без RPE, RIR и правила остановки: считаются тяжёлыми (RIR {{rir}} или меньше).",
    "assumedTotal_other": "{{assumed}} из {{count}} тяжёлых подходов без RPE, RIR и правила остановки: считаются тяжёлыми (RIR {{rir}} или меньше).",
    "patternsTitle": "Дней в неделю по движению",
    "days_one": "{{n}} день",
    "days_few": "{{n}} дня",
    "days_many": "{{n}} дней",
    "days_other": "{{n}} дня",
    "repsTitle": "Подходы по повторениям",
    "repsRow_one": "{{count}} повторение",
    "repsRow_few": "{{count}} повторения",
    "repsRow_many": "{{count}} повторений",
    "repsRow_other": "{{count}} повторения",
    "repsAmrap_one": "из них {{count}} минимум AMRAP",
    "repsAmrap_few": "из них {{count}} минимума AMRAP",
    "repsAmrap_many": "из них {{count}} минимумов AMRAP",
    "repsAmrap_other": "из них {{count}} минимума AMRAP",
    "repsTimed_one": "{{count}} подход на время",
    "repsTimed_few": "{{count}} подхода на время",
    "repsTimed_many": "{{count}} подходов на время",
    "repsTimed_other": "{{count}} подхода на время",
    "repsOpen_one": "{{count}} открытый подход, повторения пишутся на тренировке",
    "repsOpen_few": "{{count}} открытых подхода, повторения пишутся на тренировке",
    "repsOpen_many": "{{count}} открытых подходов, повторения пишутся на тренировке",
    "repsOpen_other": "{{count}} открытых подхода, повторения пишутся на тренировке",
    "effortTitle": "Подходы по усилию",
    "untargeted": "Без цели по усилию, нагрузка: {{axis}}",
    "axis": {
      "absolute": "фиксированный вес",
      "percentage": "% от максимума",
      "history": "прошлая тренировка",
      "none": "не указана"
    },
    "staticTitle": "Строки, одинаковые в каждом круге",
    "staticNone": "Нет: каждая строка меняется за цикл.",
    "staticRow_one": "{{day}} · {{exercise}}: одинаково в {{count}} круге",
    "staticRow_few": "{{day}} · {{exercise}}: одинаково в {{count}} кругах",
    "staticRow_many": "{{day}} · {{exercise}}: одинаково в {{count}} кругах",
    "staticRow_other": "{{day}} · {{exercise}}: одинаково в {{count}} круга",
    "staticByEffortRows_one": "{{count}} строка с нагрузкой по усилию: вес ещё может расти",
    "staticByEffortRows_few": "{{count}} строки с нагрузкой по усилию: вес ещё может расти",
    "staticByEffortRows_many": "{{count}} строк с нагрузкой по усилию: вес ещё может расти",
    "staticByEffortRows_other": "{{count}} строки с нагрузкой по усилию: вес ещё может расти",
    "staticNoFixed": "Ни у одной нет фиксированного веса.",
    "durationTitle": "Длительность тренировки, оценка",
    "minutes": "{{n}} мин",
    "minutesRange": "от {{min}} до {{max}} мин",
    "untimed_one": "{{count}} подход без времени: отдых считается, работа нет",
    "untimed_few": "{{count}} подхода без времени: отдых считается, работа нет",
    "untimed_many": "{{count}} подходов без времени: отдых считается, работа нет",
    "untimed_other": "{{count}} подхода без времени: отдых считается, работа нет",
    "amrapTitle": "Подходы AMRAP",
    "amrapRow": "{{week}} · {{day}} · {{exercise}}, подход {{set}}: минимум {{reps}}",
    "amrapNoStop": "правило остановки не задано",
    "source": {
      "acsm": "ACSM 2009, умеренный темп"
    },
    "assumptions": "Направления, а не прогнозы: программа как написана, для спортсмена без истории. Тяжёлый подход: RIR {{rir}} или меньше. Диапазон: {{band}}. Одно повторение: {{secs}} с ({{source}}). Отдых не задан: {{rest}} с, {{superset}} с в суперсете. Круги разгрузки не сравниваются с диапазоном.",
    "unknown_one": "{{count}} упражнение отсутствует в каталоге и не учитывается: {{names}}",
    "unknown_few": "{{count}} упражнения отсутствуют в каталоге и не учитываются: {{names}}",
    "unknown_many": "{{count}} упражнений нет в каталоге, они не учитываются: {{names}}",
    "unknown_other": "{{count}} упражнения нет в каталоге, они не учитываются: {{names}}"
  },
  "calendar": {
    "today": "сегодня",
    "planned_one": "Запланировано: {{count}}",
    "planned_few": "Запланировано: {{count}}",
    "planned_many": "Запланировано: {{count}}",
    "planned_other": "Запланировано: {{count}}",
    "prevMonth": "Предыдущий месяц",
    "nextMonth": "Следующий месяц",
    "loadError": "Не удалось загрузить ваши планы.",
    "nothing": "На этот день ничего не запланировано.",
    "openPlanHint": "Открывает план",
    "exercises_one": "{{count}} упражнение",
    "exercises_few": "{{count}} упражнения",
    "exercises_many": "{{count}} упражнений",
    "exercises_other": "{{count}} упражнения",
    "legendPlanned": "Запланировано",
    "legendCount": "Планов в этот день",
    "legendToday": "Сегодня",
    "legendPicked": "Выбрано",
    "done_one": "Выполнено: {{count}}",
    "done_few": "Выполнено: {{count}}",
    "done_many": "Выполнено: {{count}}",
    "done_other": "Выполнено: {{count}}",
    "legendDone": "Выполнено",
    "missed": "Не выполнено",
    "plannedHeading": "Запланировано",
    "doneHeading": "Выполнено",
    "planOn": "Запланировать тренировку на {{date}}",
    "openSessionHint": "Открывает тренировку"
  }
}
